/*
 * @Author: WGL
 * @Date: 2023-04-03 15:28:54
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-12-01 14:13:34
 * @Description: 哈萨克语
 */
export default {
  vabI18n: {
    首页: 'Басты бет',
    看板: 'Канбан',
    工作台: 'Жұмыс орны',
    个人中心: 'Жеке орталық',
    Excel: 'Excel',
    错误页: 'Қате бет',
    403: '403',
    404: '404',
    邮件: 'Пошта',
    更多: 'Қосымша',
    退出登录: 'Шығу',
    登录: 'Кіру',
    验证码: 'Растау коды',
    注册: 'Тіркеу',
    国际化: 'Халықаралық',
    刷新: 'Жаңарту',
    通知: 'Хабарландыру',
    全屏: 'Толық экран',
    页面动画: 'Бет анимациясы',
    搜索: 'Іздеу',
    重置: 'Қалпына келтіру',
    开启: 'Қосу',
    关闭: 'Жабу',
    保存: 'Сақтау',
    欢迎来到: 'Қош келдіңіз',
    请输入用户名: 'Пайдаланушы атын енгізіңіз',
    请输入密码: 'Құпия сөзді енгізіңіз',
    用户名不能为空: 'Пайдаланушы аты бос болмауы керек',
    密码不能少于6位: 'Құпия сөз 6 таңбадан аз болмауы керек',
    请输入正确的手机号: 'Дұрыс телефон нөмірін енгізіңіз',
    请输入手机号: 'Телефон нөмірін енгізіңіз',
    请输入手机验证码: 'Телефон растау кодын енгізіңіз',
    获取验证码: 'Растау кодын алу',
    // ==================================== 常用基本 ==============================
    大: 'Үлкен',
    中: 'Орта',
    小: 'Кіші',
    基本信息: 'Негізгі ақпарат',
    分类名称: 'Санат атауы',
    请输入分类名称: 'Санат атауын енгізіңіз',
    排序: 'Сұрыптау',
    状态: 'Күй',
    备注: 'Ескерту',
    请输入备注: 'Ескертуді енгізіңіз',
    序号: 'Нөмір',
    规格: 'Спецификация',
    '重量/长-宽-高/体积': 'Салмақ/Ұзындық-Ені-Биіктігі/Көлем',
    价格: 'Баға',
    '价格(元)': 'Баға (юань)',
    销量: 'Сату көлемі',
    封面图: 'Мұқаба суреті',
    图片: 'Сурет',
    图标: 'Белгіше',
    编码: 'Код',
    OEM编码: 'OEM коды',
    '产品编码/OEM编码': 'Өнім коды/OEM коды',
    '编码超级搜索，多个编码换行隔开':
      'Кодтарды супер іздеу, бірнеше кодты жол ауыстыру арқылы бөлу',
    库存: 'Қор',
    调出仓库: 'Шығару қоймасы',
    调入仓库: 'Қабылдау қоймасы',
    '真实库存(锁定库存)': 'Нақты қор (бұғатталған қор)',
    采购价: 'Сатып алу бағасы',
    毛利率: 'Жалпы пайыз',
    客户报价: 'Тұтынушы бағасы',
    报价状态: 'Баға күйі',
    来源: 'Қайнар көз',
    创建时间: 'Құру уақыты',
    更新时间: 'Жаңарту уақыты',
    使用状态: 'Қолдану күйі',
    总价: 'Жалпы баға',
    操作: 'Әрекет',
    名称: 'Атауы',
    加载数据中: 'Деректер жүктелуде...',
    系统: 'Жүйе',
    确定: 'Анықтау',
    确认: 'Растау',
    取消: 'Болдырмау',
    取消操作: 'Әрекетті болдырмау!',
    '此操作将会永久删除数据，是否继续?':
      'Бұл әрекет деректерді біржола жояды, жалғастырасыз ба?',
    '确定要复制当前数据?': 'Ағымдағы деректерді көшіруді қалайсыз ба?',
    请配置打印接口: 'Басып шығару интерфейсін конфигурациялаңыз!',
    暂无数据可导出: 'Экспорттау үшін деректер жоқ!',
    正在生成中: 'Құрылуда...',
    请配置导出接口: 'Экспорт интерфейсін конфигурациялаңыз!',
    '当前页面可能存在未保存内容，直接离开内容将不被保存':
      'Ағымдағы бетте сақталмаған мазмұн болуы мүмкін, тікелей шықсаңыз мазмұн сақталмайды',
    请配置上传的路径地址: 'Жүктеу жолын конфигурациялаңыз!',
    编辑: 'Өңдеу',
    删除: 'Жою',
    新建: 'Жаңа',
    提示: 'Ескерту',
    '请配置导出接口！': 'Экспорт интерфейсін конфигурациялаңыз!',
    '暂无数据可导出！': 'Экспорттау үшін деректер жоқ!',
    正在下载中: 'Жүктелуде...',
    文件: 'Файл',
    '请配置文件上传接口！': 'Файл жүктеу интерфейсін конфигурациялаңыз!',
    '请配置编辑接口！': 'Өңдеу интерфейсін конфигурациялаңыз!',
    '导出数据过多，已添加至异步导出队列生成':
      'Экспорттау үшін деректер тым көп, асинхронды экспорт кезегіне қосылды',
    请配置文件上传接口: 'Файл жүктеу интерфейсін конфигурациялаңыз!',
    请配置编辑接口: 'Өңдеу интерфейсін конфигурациялаңыз!',
    请配置详情接口: 'Толық ақпарат интерфейсін конфигурациялаңыз!',
    头像裁剪: 'Аватарды қию',
    选择图片: 'Суретті таңдау',
    上传并保存: 'Жүктеу және сақтау',
    返回: 'Қайту',
    产品详情: 'Өнім туралы толық ақпарат',
    总计: 'Барлығы',
    查询: 'Сұрау',
    单位: 'Бірлік',
    附件: 'Қосымша',
    仓库: 'Қойма',
    手机号: 'Телефон нөмірі',
    角色: 'Рөл',
    权限: 'Рұқсаттар',
    是否负责人: 'Жауапты ма',
    固定号码: 'Стационар нөмірі',
    上传文件: 'Файл жүктеу',
    '附件名称(点击预览)': 'Қосымша атауы (алдын ала қарау үшін басыңыз)',
    附件类型: 'Қосымша түрі',
    附件大小: 'Қосымша көлемі',
    上传人: 'Жүктеген',
    上传图片大小不能超过: 'Жүктелетін суреттің көлемі аспауы керек',
    最多上传: 'Ең көбі',
    您选择了: 'Сіз таңдадыңыз',
    '个文件,请重新选择': 'файл, қайта таңдаңыз',
    你确定要删除: 'Жоюды қалайсыз ба',
    上传时间: 'Жүктеу уақыты',
    明细: 'Толық ақпарат',
    文件名称: 'Файл атауы',
    请输入分类排序: 'Санат сұрыптауын енгізіңіз',
    展开: 'Жаю',
    合并: 'Біріктіру',
    紧急程度: 'Шұғылдық деңгейі',
    添加: 'Қосу',
    请选择: 'Таңдаңыз',
    供应商: 'Жеткізуші',
    最近报价: 'Соңғы баға',
    品牌: 'Бренд',
    车型: 'Көлік моделі',
    请选择车型: 'Көлік моделін таңдаңыз',
    部件: 'Бөлшек',
    请选择部件: 'Бөлшекті таңдаңыз',
    年份: 'Жыл',
    请选择年份: 'Жылды таңдаңыз',
    发表评论: 'Пікір қалдыру',
    修改: 'Өзгерту',
    '暂无评论~': 'Пікірлер жоқ~',
    评论人员: 'Пікір қалдырушы',
    '暂无信息~': 'Ақпарат жоқ~',
    姓名: 'Аты',
    电话: 'Телефон',
    请输入电话: 'Телефонды енгізіңіз',
    邮箱: 'Электрондық пошта',
    部门: 'Бөлім',
    职务: 'Лауазым',
    图表显示: 'Диаграмма көрінісі',
    指标值: 'Көрсеткіш мәні',
    日: 'Күн',
    月: 'Ай',
    年: 'Жыл',
    已选择: 'Таңдалды',
    请输入关键词: 'Кілт сөзді енгізіңіз',
    使用选择: 'Таңдауды қолдану',
    暂无内容: 'Мазмұн жоқ',
    选择成功: 'Таңдау сәтті',
    跟进: 'Бақылау',
    已添加: 'Қосылды',
    库存不足: 'Қор жеткіліксіз',
    是: 'Иә',
    否: 'Жоқ',
    请填写: 'Толтырыңыз',
    币种: 'Валюта',
    创建人: 'Құрушы',
    最近更新: 'Соңғы жаңарту',
    从素材库选择: 'Материалдар кітапханасынан таңдау',
    // TODO: 2023-11-14 start
    从素材库选: 'Материалдар кітапханасынан таңдау',
    在此处粘贴图片即上传: 'Суретті жүктеу үшін осы жерге қойыңыз',
    '上传图片只能是JPG,PNG,GIF,WEBP格式':
      'Жүктелетін суреттер тек JPG,PNG,GIF,WEBP форматында болуы керек',
    只能上传一张图片: 'Тек бір сурет жүктеуге болады',
    当前浏览器不支持本地图片粘贴:
      'Ағымдағы браузер жергілікті суреттерді қоюды қолдамайды',
    粘贴内容非图片: 'Қойылған мазмұн сурет емес',
    上传文件大小不能超过: 'Жүктелетін файл көлемі аспауы керек',
    正在上传中: 'Жүктелуде...',
    上传: 'Жүктеу',
    上传完成: 'Жүктеу аяқталды',
    上传失败请重新上传: 'Жүктеу сәтсіз, қайта жүктеңіз',
    正在导入中: 'Импортталуда',
    导入: 'Импорттау',
    导出: 'Экспорттау',
    全选: 'Барлығын таңдау',
    使用选中: 'Таңдалғанды қолдану',
    一键抠图: 'Бір басқанда қию',
    抠图: 'Қию',
    不抠图: 'Қимау',
    完成: 'Аяқтау',
    下载: 'Жүктеу',
    查看: 'Қарау',
    暂无数据: 'Деректер жоқ',
    上级分类: 'Жоғарғы санат',
    添加分类: 'Санат қосу',
    编辑分类: 'Санатты өңдеу',
    删除分类: 'Санатты жою',
    分类名称不能为空: 'Санат атауы бос болмауы керек',
    音频: 'Аудио',
    只能选择一张图片: 'Тек бір сурет таңдауға болады',
    请配置分类接口: 'Санат интерфейсін конфигурациялаңыз!',
    全部: 'Барлығы',
    请配置素材接口: 'Материалдар интерфейсін конфигурациялаңыз!',
    请添加分类: 'Санат қосыңыз',
    请配置分类添加接口: 'Санат қосу интерфейсін конфигурациялаңыз',
    请配置分类编辑接口: 'Санат өңдеу интерфейсін конфигурациялаңыз',
    请配置分类删除接口: 'Санат жою интерфейсін конфигурациялаңыз',
    文件类型格式不正确: 'Файл түрінің форматы дұрыс емес!',
    大小不能超过: 'Көлемі аспауы керек',
    个文件请重新选择: 'файл, қайта таңдаңыз',
    请配置素材分类导出接口:
      'Материалдар санатын экспорттау интерфейсін конфигурациялаңыз!',
    立即新增: 'Дереу қосу',
    上传视频大小不能超过: 'Жүктелетін видео көлемі аспауы керек',
    图标选择器: 'Белгішелер таңдаушысы',
    最后编辑: 'Соңғы өңдеу',
    步骤: 'Қадам',
    标题: 'Тақырып',
    审核: 'Тексеру',
    审核状态: 'Тексеру күйі',
    请选择类型: 'Түрін таңдаңыз',
    请选择审核状态: 'Тексеру күйін таңдаңыз',
    通过: 'Өтті',
    不通过: 'Өтпеді',
    付款状态: 'Төлем күйі',
    请选择付款状态: 'Төлем күйін таңдаңыз',
    发货状态: 'Жөнелту күйі',
    请选择发货状态: 'Жөнелту күйін таңдаңыз',
    提成金额: 'Комиссия сомасы',
    请输入提成金额: 'Комиссия сомасын енгізіңіз',
    回款方式: 'Қайтару тәсілі',
    请选择回款方式: 'Қайтару тәсілін таңдаңыз',
    回款日期: 'Қайтару күні',
    请输入回款日期: 'Қайтару күнін енгізіңіз',
    流水单号: 'Транзакция нөмірі',
    请输入支付流水单号: 'Төлем транзакция нөмірін енгізіңіз',
    支付凭证: 'Төлем талоні',
    付款方式: 'Төлем тәсілі',
    请选择付款方式: 'Төлем тәсілін таңдаңыз',
    付款日期: 'Төлем күні',
    请输入付款日期: 'Төлем күнін енгізіңіз',
    下单日期: 'Тапсырыс күні',
    请选择下单日期: 'Тапсырыс күнін таңдаңыз',
    请输入名称: 'Атауын енгізіңіз',
    保存并新增: 'Сақтау және жаңа қосу',
    您确定要对当前数据进行提审:
      'Ағымдағы деректерді тексеруге жіберуді қалайсыз ба?',
    您确定要对当前数据进行提审并通过:
      'Ағымдағы деректерді тексеруге жіберіп өтуді қалайсыз ба?',
    '您确定要对当前状态进行撤销？撤销后可重新编辑提审':
      'Ағымдағы күйді болдырмауды қалайсыз ба? Болдырмағаннан кейін қайта өңдеп тексеруге жіберуге болады',
    您确定要对当前订单进行续单: 'Ағымдағы тапсырысты жалғастыруды қалайсыз ба?',
    您确定要对当前订单生成出库单:
      'Ағымдағы тапсырыс үшін шығару құжатын құруды қалайсыз ба?',
    // ==================================== 邮箱模块 ==============================
    表格模版: 'Кесте үлгісі',
    去添加: 'Қосуға өту',
    邮件模版: 'Пошта үлгісі',
    生成预览: 'Алдын ала қарауды құру',
    表格: 'Кесте',
    取消附件: 'Қосымшаны болдырмау',
    单选: 'Бір таңдау',
    只看我的: 'Тек менікін қарау',
    先发给自己: 'Алдымен өзіме жіберу',
    主题: 'Тақырып',
    请输入主题: 'Тақырыпты енгізіңіз',
    请输入标题: 'Тақырыпты енгізіңіз',
    收件人: 'Алушы',
    请选择收件人: 'Алушыны таңдаңыз',
    头部: 'Бас',
    尾部: 'Соңы',
    发送: 'Жіберу',
    // ==================================== f附件模块 ==============================
    下次联系时间: 'Келесі байланыс уақыты',
    跟进内容: 'Бақылау мазмұны',
    上传附件: 'Қосымша жүктеу',
    '是否删除这条跟进记录?': 'Бұл бақылау жазбасын жою керек пе?',
    确定进入: 'Кіруді растау',
    阶段: 'Кезең',
    // ==================================== f成员管理模块 ==============================
    成员管理: 'Қатысушыларды басқару',
    成员: 'Қатысушы',
    请选择成员: 'Қатысушыны таңдаңыз',
    只读: 'Тек оқу',
    读写: 'Оқу және жазу',
    负责人: 'Жауапты',
    更换负责人: 'Жауаптыны ауыстыру',
    设置为负责人: 'Жауапты ету',
    请选择负责人: 'Жауаптыны таңдаңыз',
    // ==================================== 产品模块 ==============================
    产品: 'Өнім',
    数量: 'Саны',
    产品名称: 'Өнім атауы',
    请输入产品名称: 'Өнім атауын енгізіңіз',
    产品分类: 'Өнім санаты',
    请选择产品分类: 'Өнім санатын таңдаңыз',
    产品类型: 'Өнім түрі',
    请选择产品类型: 'Өнім түрін таңдаңыз',
    请输入排序: 'Сұрыптауды енгізіңіз',
    产品编码: 'Өнім коды',
    请输入产品编码: 'Өнім кодын енгізіңіз',
    请输入OEM编码: 'OEM кодын енгізіңіз',
    适用车型: 'Қолданылатын көлік моделі',
    请选择适用车型: 'Қолданылатын көлік моделін таңдаңыз',
    车身部件: 'Кузов бөлшектері',
    请选择车身部件: 'Кузов бөлшектерін таңдаңыз',
    产品货币: 'Өнім валютасы',
    请选择产品货币单位: 'Өнім валютасын таңдаңыз',
    预警库存: 'Ескерту қоры',
    '建议售价/最低售价/成本': 'Ұсынылған баға/Ең төменгі баға/Құны',
    外贸: 'Сыртқы сауда',
    零售: 'Жеке сауда',
    成本: 'Құны',
    '名称/编码/OEM编码': 'Атауы/Коды/OEM коды',
    '重量/体积/长-宽-高': 'Салмақ/Көлем/Ұзындық-Ені-Биіктігі',
    上下架: 'Сатуға шығару/Шығару',
    上架: 'Сатуға шығару',
    下架: 'Сатудан шығару',
    请选择单位: 'Бірлікті таңдаңыз',
    建议售价: 'Ұсынылған баға',
    最低售价: 'Ең төменгі баға',
    成本价: 'Өзіндік құны',
    装箱量: 'Қаптама саны',
    箱规: 'Қаптама спецификациясы',
    '箱规-长(cm)': 'Қаптама спецификациясы-Ұзындығы(см)',
    '箱规-宽(cm)': 'Қаптама спецификациясы-Ені(см)',
    '箱规-高(cm)': 'Қаптама спецификациясы-Биіктігі(см)',
    '箱规-装箱量': 'Қаптама спецификациясы-Қаптама саны',
    '箱规-净重(kg)': 'Қаптама спецификациясы-Таза салмағы(кг)',
    '箱规-毛重(kg)': 'Қаптама спецификациясы-Жалпы салмағы(кг)',
    '箱规-体积(m³)': 'Қаптама спецификациясы-Көлемі(м³)',
    '重量(kg)': 'Салмағы(кг)',
    '单个-长(cm)': 'Біреуі-Ұзындығы(см)',
    '单个-宽(cm)': 'Біреуі-Ені(см)',
    '单个-高(cm)': 'Біреуі-Биіктігі(см)',
    '单个-体积(m³)': 'Біреуі-Көлемі(м³)',
    '单个-净重(kg)': 'Біреуі-Таза салмағы(кг)',
    '单个-毛重(kg)': 'Біреуі-Жалпы салмағы(кг)',
    证书: 'Сертификат',
    建议尺寸比例: 'Ұсынылған өлшем қатынасы 1*1',
    重量: 'Салмақ',
    体积: 'Көлем',
    分类: 'Санат',
    '体积(m³)': 'Көлемі(м³)',
    描述: 'Сипаттама',
    请输入描述: 'Сипаттаманы енгізіңіз',
    图集: 'Суреттер жинағы',
    实施服务: 'Енгізу қызметі',
    请选择实施服务: 'Енгізу қызметін таңдаңыз',
    扩展信息: 'Қосымша ақпарат',
    请选择供应商: 'Жеткізушіні таңдаңыз',
    图片信息: 'Сурет ақпараты',
    请选择仓库: 'Қойманы таңдаңыз',
    请选择产品: 'Өнімді таңдаңыз',
    入库: 'Қоймаға қабылдау',
    产品图片: 'Өнім суреті',
    我方编码: 'Біздің кодымыз',
    对方编码: 'Қарсылас коды',
    历史最低: 'Тарихи ең төменгі',
    近期价格: 'Жуықтағы баға',
    历史最高: 'Тарихи ең жоғарғы',
    联系人: 'Байланыс адамы',
    详细地址: 'Толық мекенжай',
    请选择车型品牌: 'Көлік моделінің брендін таңдаңыз',
    请选择配置: 'Конфигурацияны таңдаңыз',
    货源: 'Қайнар көз',
    产品概览: 'Өнім шолуы',
    配套产品: 'Қосымша өнімдер',
    配套产品详情: 'Қосымша өнімдер туралы толық ақпарат',
    平替产品: 'Альтернативті өнімдер',
    价格策略: 'Баға стратегиясы',
    策略条件: 'Стратегия шарттары',
    数量大于等于: 'Саны үлкен немесе тең',
    单价为: 'Бірлік бағасы',
    类型: 'Түрі',
    策略方式: 'Стратегия тәсілі',
    策略类型: 'Стратегия түрі',
    请选择策略类型: 'Стратегия түрін таңдаңыз',
    库存提示: 'Ағымдағы қор (жалпы қор/бұғатталған қор/ескерту қоры)',
    包含产品: 'Қамтылған өнімдер',
    配置: 'Конфигурация',
    导出原图: 'Түпнұсқа суретті экспорттау',
    视频信息: 'Видео ақпарат',
    视频: 'Видео',
    目标市场: 'Мақсатты нарық',
    请选择目标市场: 'Мақсатты нарықты таңдаңыз',
    产品货源: 'Өнім қайнар көзі',
    请选择产品货源: 'Өнім қайнар көзін таңдаңыз',
    上下架状态: 'Сату күйі',
    请选择产品上下架状态: 'Өнім сату күйін таңдаңыз',
    index: {},
    // ==================================== 产品分类模块 ==============================
    需要以字母开头: 'Әріптен басталуы керек',
    显示名称: 'Көрсету атауы',
    请输入显示名称: 'Көрсету атауын енгізіңіз',
    用于生成电商网站时显示的分类标题:
      'Электрондық коммерция сайтын құрғанда көрсетілетін санат тақырыбы',
    分类url: 'Санат url',
    请输入字母或数字: 'Әріп немесе санды енгізіңіз',
    '请输入分类url,如lights': 'Санат url енгізіңіз, мысалы lights',
    用于生成电商网站的链接:
      'Электрондық коммерция сайтын құру үшін қолданылатын сілтеме',
    分类描述: 'Санат сипаттамасы',
    用于生成电商网站时SEO:
      'Электрондық коммерция сайтын құрғанда SEO үшін қолданылады',
    分类关键词: 'Санат кілт сөздері',
    请输入分类: 'Санатты енгізіңіз',
    // ==================================== 销售模块 ==============================
    内容: 'Мазмұн',
    跟进人: 'Бақылаушы',
    跟进时间: 'Бақылау уақыты',
    添加成员: 'Қатысушы қосу',
    删除成员: 'Қатысушыны жою',
    '请选择成员(可多选)': 'Қатысушыны таңдаңыз (бірнешеуін таңдауға болады)',
    客户: 'Тұтынушы',
    客户名称: 'Тұтынушы атауы',
    请输入客户名称: 'Тұтынушы атауын енгізіңіз',
    客户编码: 'Тұтынушы коды',
    成交单数: 'Шарт жасау саны',
    成交金额: 'Шарт жасау сомасы',
    回款金额: 'Қайтару сомасы',
    客户来源: 'Тұтынушы қайнар көзі',
    请选择客户来源: 'Тұтынушы қайнар көзін таңдаңыз',
    客户行业: 'Тұтынушы саласы',
    请选择客户行业: 'Тұтынушы саласын таңдаңыз',
    客户等级: 'Тұтынушы деңгейі',
    请选择客户等级: 'Тұтынушы деңгейін таңдаңыз',
    下次跟进时间: 'Келесі бақылау уақыты',
    地区: 'Аймақ',
    请选择地区: 'Аймақты таңдаңыз',
    请输入客户手机号: 'Тұтынушы телефон нөмірін енгізіңіз',
    请输入邮箱地址: 'Электрондық пошта мекенжайын енгізіңіз',
    地址: 'Мекенжай',
    请输入客户地址: 'Тұтынушы мекенжайын енгізіңіз',
    是否成交: 'Шарт жасалды ма',
    请选择是否成交: 'Шарт жасалғанын таңдаңыз',
    客户详情: 'Тұтынушы туралы толық ақпарат',
    最后跟进时间: 'Соңғы бақылау уақыты',
    微信: 'WeChat',
    请输入微信: 'WeChat енгізіңіз',
    商机: 'Мүмкіндік',
    范围: 'Ауқым',
    请选择数据范围: 'Деректер ауқымын таңдаңыз',
    客户地区: 'Тұтынушы аймағы',
    团队成员: 'Команда қатысушылары',
    发票信息: 'Есеп-шот ақпараты',
    客户分析: 'Тұтынушы талдауы',
    客户订单分析: 'Тұтынушы тапсырыстарын талдау',
    请选择开始日期: 'Бастау күнін таңдаңыз',
    开始日期: 'Бастау күні',
    结束日期: 'Аяқтау күні',
    退货产品: 'Қайтару өнімі',
    结束时间: 'Аяқтау уақыты',
    开始时间: 'Бастау уақыты',
    核心数据: 'Негізгі деректер',
    成交趋势: 'Шарт жасау үрдісі',
    产品分布: 'Өнім таралуы',
    产品排行: 'Өнім рейтингі',
    销售前20产品: 'Сату бойынша алғашқы 20 өнім',
    历史订单: 'Тарихи тапсырыстар',
    订单金额: 'Тапсырыс сомасы',
    订单总金额: 'Тапсырыс жалпы сомасы',
    订单笔数: 'Тапсырыс саны',
    下单数量: 'Тапсырыс саны',
    实收金额: 'Нақты алынған сома',
    '当前订单收款总和，扣除退款':
      'Ағымдағы тапсырыс алынған сомасының қосындысы, қайтарылғанды есептемегенде',
    退款金额: 'Қайтару сомасы',
    当前订单退款金额: 'Ағымдағы тапсырыс қайтару сомасы',
    未收回款: 'Алынбаған қайтарым',
    '订单金额-已收金额': 'Тапсырыс сомасы-Алынған сома',
    已开票金额: 'Есеп-шот шығарылған сома',
    订单已开票的金额: 'Тапсырыс үшін шығарылған есеп-шот сомасы',
    平均单价: 'Орташа бірлік бағасы',
    每笔订单平均单价: 'Әрбір тапсырыстың орташа бірлік бағасы',
    排名: 'Рейтинг',
    渠道来源: 'Арна қайнар көзі',
    金额占比: 'Сома үлесі',
    订单占比: 'Тапсырыс үлесі',
    公司名称: 'Компания атауы',
    请输入公司名称: 'Компания атауын енгізіңіз',
    税号: 'Салық нөмірі',
    请输入公司税号: 'Компания салық нөмірін енгізіңіз',
    开户行: 'Банк',
    银行账号: 'Банк шоты',
    账户信息: 'Шот ақпараты',
    发票抬头: 'Есеп-шот алушы',
    关联客户: 'Байланысты тұтынушы',
    请选择客户: 'Тұтынушыны таңдаңыз',
    货币币种: 'Валюта',
    开户银行: 'Банк',
    请输入开户银行全称: 'Толық банк атауын енгізіңіз',
    银行卡号: 'Банк картасы нөмірі',
    请输入银行卡号: 'Банк картасы нөмірін енгізіңіз',
    请输入地址: 'Мекенжайды енгізіңіз',
    退货商品为空表示只退款: 'Қайтару заттары бос болса, тек қайтару ғана',
    请输入退货数量: 'Қайтару санын енгізіңіз',
    产品明细: 'Өнім туралы толық ақпарат',
    请至少添加一个产品: 'Кем дегенде бір өнім қосыңыз',
    // TODO: 2023-11-14 start
    商机名称: 'Мүмкіндік атауы',
    请输入商机名称: 'Мүмкіндік атауын енгізіңіз',
    商机阶段: 'Мүмкіндік кезеңі',
    请选择商机阶段: 'Мүмкіндік кезеңін таңдаңыз',
    商机属性: 'Мүмкіндік сипаты',
    请选择商机属性: 'Мүмкіндік сипатын таңдаңыз',
    商机状态: 'Мүмкіндік күйі',
    请选择商机状态: 'Мүмкіндік күйін таңдаңыз',
    预计金额: 'Болжалды сома',
    请输入预计成交金额: 'Болжалды сауда сомасын енгізіңіз',
    请选择货币: 'Валютаны таңдаңыз',
    预计成交: 'Болжалды сауда',
    请输入预计成交日期: 'Болжалды сауда күнін енгізіңіз',
    结束: 'Аяқтау',
    商机详情: 'Мүмкіндік туралы толық ақпарат',
    预计成交金额: 'Болжалды сауда сомасы',
    预计成交时间: 'Болжалды сауда уақыты',
    // ==================================== 报价单模块 ==============================
    报价单: 'Баға ұсынысы',
    请选择报价单: 'Баға ұсынысын таңдаңыз',
    报价详情: 'Баға ұсынысы туралы толық ақпарат',
    单号: 'Нөмір',
    复用价格: 'Қайта қолдану бағасы',
    时间: 'Уақыт',
    我的报价: 'Менің баға ұсыныстарым',
    '标题/编号': 'Тақырып/Нөмір',
    订单Id: 'Тапсырыс Id',
    客户名: 'Тұтынушы аты',
    单价: 'Бірлік бағасы',
    请选择出入库类型: 'Қоймаға кіру/шығу түрін таңдаңыз',
    所有客户: 'Барлық тұтынушылар',
    当前客户: 'Ағымдағы тұтынушы',
    时间范围: 'Уақыт аралығы',
    价格范围: 'Баға аралығы',
    请选择状态: 'Күйді таңдаңыз',
    关联商机: 'Байланысты мүмкіндік',
    请选择商机: 'Мүмкіндікті таңдаңыз',
    请选择币种: 'Валютаны таңдаңыз',
    生成订单: 'Тапсырыс жасау',
    交付日期: 'Жеткізу күні',
    '订单交付/发货日期': 'Тапсырыс жеткізу/жөнелту күні',
    请选择交付日期: 'Жеткізу күнін таңдаңыз',
    报价单名称: 'Баға ұсыныс атауы',
    报价单编码: 'Баға ұсыныс коды',
    产品数量: 'Өнім саны',
    订单货币: 'Тапсырыс валютасы',
    编号: 'Нөмір',
    金额: 'Сома',
    销售金额: 'Сату сомасы',
    销售订单: 'Сату тапсырысы',
    订单数量: 'Тапсырыс саны',
    产品列表: 'Өнімдер тізімі',
    订单详情: 'Тапсырыс туралы толық ақпарат',
    发货计划: 'Жөнелту жоспары',
    回款计划: 'Қайтару жоспары',
    回款明细: 'Қайтару туралы толық ақпарат',
    出入库记录: 'Қоймаға кіру/шығу журналы',
    服务明细: 'Қызмет туралы толық ақпарат',
    绩效明细: 'Көрсеткіш туралы толық ақпарат',
    开票计划: 'Есеп-шот шығару жоспары',
    '退/换货': 'Қайтару/ауыстыру',
    合同: 'Келісім',
    应收款: 'Алынатын төлем',
    未收款: 'Алынбаған төлем',
    已收金额: 'Алынған сома',
    '当前订单收款总和，不扣除退款':
      'Ағымдағы тапсырыс алынған сомасының қосындысы, қайтарылғанды есептемегенде',
    已退金额: 'Қайтарылған сома',
    实收回款: 'Нақты алынған қайтарым',
    退款中金额: 'Қайтарылу барысындағы сома',
    订单退款审批中金额: 'Тапсырыс қайтаруын тексеру барысындағы сома',
    '金额(应收/实收)': 'Сома (алынатын/алынған)',
    下单时间: 'Тапсырыс уақыты',
    发货时间: 'Жөнелту уақыты',
    请选择发货时间: 'Жөнелту уақытын таңдаңыз',
    订单: 'Тапсырыс',
    签单类型: 'Қолтаңба түрі',
    生成任务时的开始日期: 'Тапсырманы жасау кезіндегі бастау күні',
    单据日期: 'Құжат күні',
    订单成交时日期: 'Тапсырыс саудасы болған күн',
    '订单退/换货': 'Тапсырыс қайтаруы/ауыстыруы',
    请输入退款金额: 'Қайтару сомасын енгізіңіз',
    退款金额为0表示只退货: 'Қайтару сомасы 0 болса, тек қайтару ғана',
    退款方式: 'Қайтару тәсілі',
    请选择退款方式: 'Қайтару тәсілін таңдаңыз',
    退款日期: 'Қайтару күні',
    请选择退款日期: 'Қайтару күнін таңдаңыз',
    补差金额: 'Айырмашылықты толтыру сомасы',
    请输入补差金额: 'Айырмашылықты толтыру сомасын енгізіңіз',
    补差金额为0表示只换货:
      'Айырмашылықты толтыру сомасы 0 болса, тек ауыстыру ғана',
    补差方式: 'Айырмашылықты толтыру тәсілі',
    请选择补差方式: 'Айырмашылықты толтыру тәсілін таңдаңыз',
    补差日期: 'Айырмашылықты толтыру күні',
    请选择补差计划日期: 'Айырмашылықты толтыру жоспар күнін таңдаңыз',
    换货商品为空表示只补差金额:
      'Ауыстыру заттары бос болса, тек айырмашылықты толтыру ғана',
    '退/换货备注': 'Қайтару/ауыстыру ескертуі',
    请输入退货备注: 'Қайтару ескертуін енгізіңіз',
    订单名称: 'Тапсырыс атауы',
    订单编码: 'Тапсырыс коды',
    发货日期: 'Жөнелту күні',
    包装要求: 'Қаптау талабы',
    规格说明: 'Спецификация сипаттамасы',
    价格条款: 'Баға шарттары',
    订单进度: 'Тапсырыс барысы',
    // ==================================== 仓库模块 ==============================
    备货中: 'Дайындау барысында',
    备货完成: 'Дайындау аяқталды',
    业务员: 'Саудагер',
    计划时间: 'Жоспар уақыты',
    备货状态: 'Дайындау күйі',
    发货计划详情: 'Жөнелту жоспары туралы толық ақпарат',
    发货进度: 'Жөнелту барысы',
    计划日期: 'Жоспар күні',
    采购计划: 'Сатып алу жоспары',
    箱单: 'Қаптама тізімі',
    发货单: 'Жөнелту құжаты',
    请选择销售订单: 'Сату тапсырысын таңдаңыз',
    交货日期: 'Жеткізу күні',
    采购状态: 'Сатып алу күйі',
    请选择采购状态: 'Сатып алу күйін таңдаңыз',
    添加采购计划: 'Сатып алу жоспарын қосу',
    请输入采购数量: 'Сатып алу санын енгізіңіз',
    添加到采购单: 'Сатып алу құжатына қосу',
    换货产品: 'Ауыстыру өнімі',
    换货商品为空表示只补差额:
      'Ауыстыру заттары бос болса, тек айырмашылықты толтыру ғана',
    出入库: 'Қоймаға кіру/шығу',
    出库: 'Қоймадан шығару',
    日期: 'Күн',
    入库类型: 'Қоймаға қабылдау түрі',
    出库类型: 'Қоймадан шығару түрі',
    出入库类型: 'Қоймаға кіру/шығу түрі',
    供应商名称: 'Жеткізуші атауы',
    '供应商/客户': 'Жеткізуші/Тұтынушы',
    盘点状态: 'Тексеру күйі',
    '未作废数据删除，库存将不会恢复是否删除':
      'Жарамсыз етілмеген деректерді жойсаңыз, қор қалпына келмейді. Жою керек пе?',
    '此操作将会永久删除数据，是否继续':
      'Бұл әрекет деректерді біржола жояды, жалғастырасыз ба?',
    您确定要作废当前数据: 'Ағымдағы деректерді жарамсыз етуді қалайсыз ба?',
    // TODO: 2023-11-15 start
    '金额(应付/实付)': 'Сома (төленетін/төленген)',
    实付金额: 'Нақты төленген сома',
    '当前订单付款总和，扣除退款':
      'Ағымдағы тапсырыс төленген сомасының қосындысы, қайтарылғанды есептемегенде',
    未付金额: 'Төленбеген сома',
    采购: 'Сатып алу',
    采购单详情: 'Сатып алу құжаты туралы толық ақпарат',
    采购进度: 'Сатып алу барысы',
    付款计划: 'Төлем жоспары',
    付款明细: 'Төлем туралы толық ақпарат',
    采购数量: 'Сатып алу саны',
    // ==================================== 供应商模块 ==============================
    供应商详情: 'Жеткізуші туралы толық ақпарат',
    '确认删除？': 'Жоюды растайсыз ба?',
    消息: 'Хабарлама',
    暂无评论: 'Пікірлер жоқ',
    暂无信息: 'Ақпарат жоқ',
    素材选择: 'Материалдарды таңдау',
    '文件已存在下载队列中！': 'Файл жүктеу кезегінде бар!',
    新增故事: 'Жаңа әңгіме қосу',
    请输入内容: 'Мазмұнды енгізіңіз',
    只能选择一张: 'Тек бір дана таңдауға болады',
    请选择邮件模板: 'Пошта үлгісін таңдаңыз',
    '正在生成中...': 'Құрылуда...',
    '该附件格式不支持预览，请下载后查看':
      'Бұл қосымша форматын алдын ала қарау қолдамайды, жүктеп алып қараңыз',
    设备: 'Құрылғы',
    总数: 'Жалпы саны',
    在线: 'Желіде',
    离线: 'Желіден тыс',
    故障: 'Ақаулық',
    在线率: 'Желідегі үлесі',
    故障率: 'Ақаулық үлесі',
    '确认要离开本页面吗？': 'Бұл беттен шығуды қалайсыз ба?',
    历史报价: 'Тарихи баға',
    '产品名称/编码': 'Өнім атауы/коды',
    '智慧商贸-ERP': 'Ақылды сауда-ERP',
    '正在加载中...': 'Жүктелуде...',
    简体中文: 'Қарапайым қытай тілі',
    繁體中文: 'Дәстүрлі қытай тілі',
    已创建: 'Құрылды',
    进行中: 'Орындалуда',
    已完成: 'Аяқталды',
    折线图: 'Сынық сызық диаграммасы',
    柱状图: 'Гистограмма',
    周: 'Апта',
    已作废: 'Жарамсыз етілді',
    已过期: 'Мерзімі өтті',
    编辑中: 'Өңделуде',
    待支付: 'Төлем күтілуде',
    已付定金: 'Аванс төленді',
    已支付: 'Төленді',
    已发货: 'Жөнелтілді',
    已签收: 'Қабылданды',
    '报价单-出口': 'Баға ұсынысы-экспорт',
    '报价单-内销': 'Баға ұсынысы-ішкі сауда',
    '报价单-门市': 'Баға ұсынысы-дүкен',
    '报价单-淘宝': 'Баға ұсынысы-таобао',
    '报价单-云工厂': 'Баға ұсынысы-бұлт зауыты',
    '报价单-智能工厂': 'Баға ұсынысы-ақылды зауыт',
    禁用: 'Бұғаттау',
    启用: 'Қосу',
    隐藏: 'Жасыру',
    显示: 'Көрсету',
    未知: 'Белгісіз',
    抖音: 'Доуинь',
    快手: 'Куаишоу',
    待确定: 'Анықтау күтілуде',
    有效: 'Жарамды',
    无效: 'Жарамсыз',
    推广微信公众号: 'WeChat қоғамдық аккаунтты насихаттау',
    推广抖音账号: 'Доуинь аккаунтты насихаттау',
    推广抖音视频: 'Доуинь видеосын насихаттау',
    推广快手账号: 'Куаишоу аккаунтты насихаттау',
    推广快手视频: 'Куаишоу видеосын насихаттау',
    销售收入: 'Сату түбіркісі',
    押金收入: 'Кепілдік түбіркісі',
    租赁收入: 'Жалға беру түбіркісі',
    购买支出: 'Сатып алу шығыны',
    押金退还: 'Кепілдік қайтару',
    男: 'Ер',
    女: 'Әйел',
    保密: 'Құпия',
    待处理: 'Өңдеу күтілуде',
    处理中: 'Өңделуде',
    已处理: 'Өңделді',
    文本框: 'Мәтін өрісі',
    多行文本框: 'Көпжолды мәтін өрісі',
    数字文本框: 'Сандық мәтін өрісі',
    日期选择框: 'Күн таңдау өрісі',
    状态选择: 'Күй таңдау',
    单选框: 'Бір таңдау өрісі',
    多选框: 'Көп таңдау өрісі',
    下拉单选择: 'Ашылмалы тізімнен бір таңдау',
    下拉多选择: 'Ашылмалы тізімнен көп таңдау',
    单图片: 'Бір сурет',
    多图片: 'Көп сурет',
    日期选择: 'Күн таңдау',
    未读: 'Оқылмаған',
    已读: 'Оқылған',
    待审核: 'Тексеру күтілуде',
    私有: 'Жеке',
    公海: 'Қоғамдық теңіз',
    无: 'Жоқ',
    低: 'Төмен',
    高: 'Жоғары',
    离职: 'Жұмыстан шығу',
    在职: 'Жұмыста',
    销售: 'Сату',
    按数量区间设置: 'Сан аралығы бойынша орнату',
    '按客户/供应商设置': 'Тұтынушы/жеткізуші бойынша орнату',
    待接受: 'Қабылдау күтілуде',
    已接受: 'Қабылданды',
    不接受: 'Қабылданбады',
    公司: 'Компания',
    银行账户: 'Банк шоты',
    单位地址: 'Ұйым мекенжайы',
    '千美元)': 'мың доллар)',
    宽松默认: 'Бос орын әдепкі',
    严格模式: 'Қатаң режим',
    '支持jpg、jpeg、png格式，单次可最多选择':
      'jpg、jpeg、png форматтарын қолдайды, бір уақытта ең көбі',
    '张图片，每张不可大于': 'сурет таңдауға болады, әрқайсысы',
    如果大于: 'аспаса',
    会自动为您过滤: 'болмаса, автоматты түрде сүзіледі',
    查看大图: 'Үлкен суретті қарау',
    '正在上传中...': 'Жүктелуде...',
    当前上传成功数: 'Ағымдағы жүктеу сәтті саны',
    张: 'дана',
    当前上传失败数: 'Ағымдағы жүктеу сәтсіз саны',
    开始上传: 'Жүктеуді бастау',
    '上传完成!': 'Жүктеу аяқталды!',
    共上传: 'Барлығы жүктелді',
    张图片: 'сурет',
    '上传失败,文件大小为': 'Жүктеу сәтсіз, файл көлемі',
    当前限制选择: 'Ағымдағы шектеу таңдау',
    '个文件，本次选择了': 'файл, бұл рет таңдалды',
    个文件: 'файл',
    密码不能少于: 'Құпия сөз кем дегенде',
    位: 'таңба',
    销售前: 'Сатуға дейін',
    更新日志: 'Жаңарту журналы',
    用户管理: 'Пайдаланушыларды басқару',
    角色管理: 'Рөлдерді басқару',
    部门管理: 'Бөлімдерді басқару',
    菜单管理: 'Мәзірді басқару',
    系统日志: 'Жүйе журналы',
    组件: 'Құрамдас бөліктер',
    其他: 'Басқа',
    角色权限: 'Рөл рұқсаттары',
    外链: 'Сыртқы сілтеме',
    常规图标: 'Қарапайым белгішелер',
    小清新图标: 'Кішкене жаңа белгішелер',
    综合表格: 'Комплексті кесте',
    行内编辑表格: 'Жол ішінде өңдеу кестесі',
    自定义表格: 'Теңшеу кестесі',
    表单: 'Пішін',
    综合表单: 'Комплексті пішін',
    分步表单: 'Қадамдық пішін',
    按钮: 'Түйме',
    文字链接: 'Мәтіндік сілтеме',
    输入框: 'Енгізу өрісі',
    计数器: 'Санағыш',
    选择器: 'Таңдаушы',
    开关: 'Қосқыш',
    滑块: 'Сырғытқыш',
    时间选择器: 'Уақыт таңдаушы',
    日期选择器: 'Күн таңдаушы',
    日期时间选择器: 'Күн уақыт таңдаушы',
    评分: 'Бағалау',
    工作流: 'Жұмыс ағыны',
    图表: 'Диаграмма',
    打印: 'Басып шығару',
    手机预览: 'Ұялы телефон алдын ала қарау',
    时间线: 'Уақыт сызығы',
    数字自增长: 'Сандардың өздігінен өсуі',
    多标签: 'Көп белгі',
    动态Meta: 'Динамикалық Meta',
    动态路径参数: 'Динамикалық жол параметрлері',
    列表: 'Тізім',
    多级路由缓存: 'Көп деңгейлі маршрут кэші',
    多级路由: 'Көп деңгейлі маршрут',
    拖拽: 'Ұстап апару',
    卡片拖拽: 'Карта ұстап апару',
    加载: 'Жүктеу',
    视频播放器: 'Видео ойнатқыш',
    编辑器: 'Өңдегіш',
    富文本编辑器: 'Бай мәтін өңдегіш',
    错误日志模拟: 'Қате журналын имитациялау',
    导出Excel: 'Excel-ге экспорттау',
    导出选中行Excel: 'Таңдалған жолдарды Excel-ге экспорттау',
    导出合并Excel: 'Біріктірілген Excel-ге экспорттау',
    动画: 'Анимация',
    第三方登录: 'Үшінші тарап арқылы кіру',
    物料源: 'Материал көзі',
    物料市场: 'Материал нарығы',
    清空消息: 'Хабарламаларды тазалау',
    关闭其他: 'Басқаларын жабу',
    关闭左侧: 'Сол жағын жабу',
    关闭右侧: 'Оң жағын жабу',
    关闭全部: 'Барлығын жабу',
    主题配置: 'Тақырып конфигурациясы',
    常用设置: 'Жиі қолданылатын параметрлер',
    其它设置: 'Басқа параметрлер',
    分栏布局时生效: 'Бағандық орналасу кезінде әрекет етеді',
    标签开启时生效: 'Белгі қосылған кезде әрекет етеді',
    '布局配置仅在电脑视窗下生效，手机视窗时将默认锁定为纵向布局':
      'Орналасу конфигурациясы тек компьютер терезесінде әрекет етеді, ұялы телефон терезесінде әдепкі түрде тік орналасуға бекітіледі',
    默认: 'Әдепкі',
    海洋之心: 'Теңіз жүрегі',
    海洋之心sss: 'Теңіз жүрегіsss',
    绿荫草场: 'Жасыл көлеңкелі шөл',
    碰触纯白: 'Таза ақ түсті түрткізу',
    月上重火: 'Айдағы ауыр өрт',
    蓝黑: 'Көк қара',
    蓝白: 'Көк ақ',
    绿黑: 'Жасыл қара',
    绿白: 'Жасыл ақ',
    红黑: 'Қызыл қара',
    红白: 'Қызыл ақ',
    渐变: 'Градиент',
    布局: 'Орналасу',
    分栏: 'Баған',
    纵向: 'Тік',
    横向: 'Көлденең',
    综合: 'Комплексті',
    常规: 'Қарапайым',
    浮动: 'Қалқымалы',
    菜单背景: 'Мәзір фонды',
    分栏风格: 'Баған стилі',
    箭头: 'Көрсеткіш',
    头部固定: 'Бас бөлігін бекіту',
    固定: 'Бекіту',
    不固定: 'Бекітпеу',
    标签: 'Белгі',
    标签风格: 'Белгі стилі',
    标签图标: 'Белгі белгішесі',
    卡片: 'Карта',
    灵动: 'Икемді',
    圆滑: 'Дөңгелек',
    进度条: 'Барыс жолағы',
    随机换肤: 'Кездейсоқ тері ауыстыру',
    购买源码: 'Бастапқы кодты сатып алу',
    拷贝源码: 'Бастапқы кодты көшіру',
    清理缓存: 'Кэшті тазалау',
    恢复默认: 'Әдепкіге қалпына келтіру',
    '检测到新版本，正在下载中，请稍后...':
      'Жаңа нұсқа анықталды, жүктелуде, күте тұрыңыз...',
    温馨提示: 'Қауіпсіздік ескертуі',
    更新版本完成: 'Нұсқаны жаңарту аяқталды',
    后刷新项目: 'кейін жобаны жаңартыңыз',
    我的待办: 'Менің күтілген істерім',
    已办事项: 'Орындалған істер',
    经营分析: 'Басқару талдауы',
    决策辅助: 'Шешім қабылдауға көмек',
    采购订单: 'Сатып алу тапсырысы',
    供应管理: 'Жеткізу басқаруы',
    客户管理: 'Тұтынушыларды басқару',
    商机管理: 'Мүмкіндіктерді басқару',
    对外报价: 'Сыртқы баға ұсыныстар',
    财务: 'Қаржы',
    仓库管理: 'Қойма басқаруы',
    收款计划: 'Алынатын төлем жоспары',
    收款明细: 'Алынатын төлем туралы толық ақпарат',
    开票详情: 'Есеп-шот туралы толық ақпарат',
    库存盘点: 'Қорды тексеру',
    库存报表: 'Қор есептемесі',
    库存余额: 'Қор қалдығы',
    收发明细: 'Қабылдау жөнелту туралы толық ақпарат',
    收发汇总: 'Қабылдау жөнелту қорытындысы',
    单据列表: 'Құжаттар тізімі',
    产品入库: 'Өнімді қоймаға қабылдау',
    产品出库: 'Өнімді қоймадан шығару',
    产品调拨: 'Өнімді қайта бөлу',
    产品组装: 'Өнімді жинау',
    产品拆卸: 'Өнімді бөлу',
    绩效: 'Көрсеткіш',
    我的绩效: 'Менің көрсеткіштерім',
    团队绩效: 'Команда көрсеткіштері',
    绩效核定: 'Көрсеткішті растау',
    绩效规则: 'Көрсеткіш ережелері',
    任务: 'Тапсырма',
    任务列表: 'Тапсырмалар тізімі',
    电商: 'Электрондық коммерция',
    首页设置: 'Басты бет параметрлері',
    商品: 'Тауар',
    轮播图: 'Слайд-шоу',
    文章管理: 'Мақалаларды басқару',
    设置: 'Параметрлер',
    公司信息: 'Компания ақпараты',
    销售配置: 'Сату конфигурациясы',
    产品配置: 'Өнім конфигурациясы',
    产品素材: 'Өнім материалдары',
    模版管理: 'Үлгілерді басқару',
    扩展字段: 'Кеңейтілген өрістер',
    系统设置: 'Жүйе параметрлері',
    操作日志: 'Әрекет журналы',
    公司列表: 'Компаниялар тізімі',
    用户列表: 'Пайдаланушылар тізімі',
    权限管理: 'Рұқсаттарды басқару',
    行业管理: 'Салаларды басқару',
    资源: 'Ресурстар',
    店铺选址: 'Дүкен орнын таңдау',
    教程管理: 'Оқулықтарды басқару',
    超级管理员: 'Супер администратор',
    '没有菜单权限！': 'Мәзір рұқсаттары жоқ!',
    '路由格式返回有误！': 'Маршрут форматы қате қайтарылды!',
    运行中: 'Жұмыс істеуде',
    已下线: 'Желіден шықты',
    游客: 'Қонақ',
    '未开启登录拦截)': 'Кіру бұғаттау қосылмаған)',
    早上好: 'Таң атты',
    上午好: 'Таңертең',
    中午好: 'Түскі асы',
    下午好: 'Кеш',
    晚上好: 'Түн',
    欢迎登录: 'Кіргеніңізге қуаныштымыз',
    '登录接口异常，未正确返回':
      'Кіру интерфейсінде аномалия, дұрыс қайтарылмады',
    '核心接口异常，请检查返回JSON格式是否正确，是否正确返回':
      'Негізгі интерфейсте аномалия, қайтарылған JSON форматы дұрыс па, дұрыс қайтарылды ма тексеріңіз',
    '核心接口异常，请检查返回JSON格式是否正确':
      'Негізгі интерфейсте аномалия, қайтарылған JSON форматы дұрыс па тексеріңіз',
    复制: 'Көшіру',
    成功: 'Сәтті',
    失败: 'Сәтсіз',
    '重量/毛重': 'Салмақ/Жалпы салмақ',
    产品证书: 'Өнім сертификаты',
    推荐价格: 'Ұсынылған баға',
    邮编: 'Пошта индексі',
    传真: 'Факс',
    官网: 'Ресми сайт',
    企业状态: 'Кәсіпорын күйі',
    营收: 'Шаруашылық нәтижесі',
    员工人数: 'Қызметкерлер саны',
    公司类型: 'Компания түрі',
    所属国家: 'Тиесілі ел',
    所属城市: 'Тиесілі қала',
    简介: 'Анықтама',
    产品服务: 'Өнім қызметтері',
    请输入: 'Енгізіңіз',
    产品价格策略: 'Өнім баға стратегиясы',
    起始价格: 'Бастапқы баға',
    分类logo: 'Санат логотипі',
    建议尺寸: 'Ұсынылған өлшем',
    分类banner: 'Санат баннері',
    请输入分类描述: 'Санат сипаттамасын енгізіңіз',
    退款金额为: 'Қайтару сомасы',
    表示只退货: 'тек қайтару ғана',
    补差金额为: 'Айырмашылықты толтыру сомасы',
    表示只换货: 'тек ауыстыру ғана',
    请输入客户编码: 'Тұтынушы кодын енгізіңіз',
    请输入联系人: 'Байланыс адамын енгізіңіз',
    请输入客户Whats: 'Тұтынушы Whats-ын енгізіңіз',
    规则名称: 'Ереже атауы',
    请输入规则名称: 'Ереже атауын енгізіңіз',
    绩效类型: 'Көрсеткіш түрі',
    请选择绩效类型: 'Көрсеткіш түрін таңдаңыз',
    优先级: 'Артықшылық',
    请输入优先级: 'Артықшылықты енгізіңіз',
    请输入编码: 'Кодты енгізіңіз',
    请选择分类: 'Санатты таңдаңыз',
    请输入详细地址: 'Толық мекенжайды енгізіңіз',
    固定电话: 'Стационар телефон',
    请输入固定电话: 'Стационар телефонды енгізіңіз',
    请输入邮箱: 'Электрондық поштаны енгізіңіз',
    请输入QQ: 'QQ енгізіңіз',
    网址: 'Веб-сайт',
    请输入网址: 'Веб-сайтты енгізіңіз',
    添加到采购计划: 'Сатып алу жоспарына қосу',
    请输入数量: 'Санын енгізіңіз',
    选择负责人: 'Жауаптыны таңдау',
    服务年限: 'Қызмет мерзімі',
    '请输入服务年限(报告年限)': 'Қызмет мерзімін енгізіңіз (есеп беру мерзімі)',
    任务日期: 'Тапсырма күні',
    请选择任务日期: 'Тапсырма күнін таңдаңыз',
    请输入任务金额: 'Тапсырма сомасын енгізіңіз',
    请选择关联销售订单: 'Байланысты сату тапсырысын таңдаңыз',
    请输入回款金额: 'Қайтару сомасын енгізіңіз',
    请选择回款日期: 'Қайтару күнін таңдаңыз',
    批量生成回款计划: 'Қайтару жоспарын жаппай құру',
    首次回款日期: 'Бірінші қайтару күні',
    请选择首次回款日期: 'Бірінші қайтару күнін таңдаңыз',
    回款间隔时间: 'Қайтару аралығы',
    请输入回款间隔时间: 'Қайтару аралығын енгізіңіз',
    总回款期数: 'Жалпы қайтару мерзімі',
    请输入总回款期数: 'Жалпы қайтару мерзімін енгізіңіз',
    请选择关联回款计划: 'Байланысты қайтару жоспарын таңдаңыз',
    渠道: 'Арна',
    请选择渠道: 'Арнаны таңдаңыз',
    凭证: 'Талон',
    请选择采购订单: 'Сатып алу тапсырысын таңдаңыз',
    请选择关联采购订单: 'Байланысты сатып алу тапсырысын таңдаңыз',
    付款金额: 'Төлем сомасы',
    请输入付款金额: 'Төлем сомасын енгізіңіз',
    请选择付款日期: 'Төлем күнін таңдаңыз',
    批量生成付款计划: 'Төлем жоспарын жаппай құру',
    首次付款日期: 'Бірінші төлем күні',
    请选择首次付款日期: 'Бірінші төлем күнін таңдаңыз',
    付款间隔时间: 'Төлем аралығы',
    请输入付款间隔时间: 'Төлем аралығын енгізіңіз',
    总付款期数: 'Жалпы төлем мерзімі',
    请输入总付款期数: 'Жалпы төлем мерзімін енгізіңіз',
    请选择关联付款计划: 'Байланысты төлем жоспарын таңдаңыз',
    请选择发票抬头: 'Есеп-шот алушыны таңдаңыз',
    开票金额: 'Есеп-шот сомасы',
    请输入开票金额: 'Есеп-шот сомасын енгізіңіз',
    含税金额: 'Салықпен бірге сома',
    商品名称: 'Тауар атауы',
    请输入商品名称: 'Тауар атауын енгізіңіз',
    商品编号: 'Тауар нөмірі',
    请输入商品编号: 'Тауар нөмірін енгізіңіз',
    规格型号: 'Спецификация моделі',
    请输入商品规格型号: 'Тауар спецификация моделін енгізіңіз',
    商品单位: 'Тауар бірлігі',
    请输入商品单位: 'Тауар бірлігін енгізіңіз',
    发票类型: 'Есеп-шот түрі',
    请选择发票类型: 'Есеп-шот түрін таңдаңыз',
    税率: 'Салық ставкасы',
    请输入税率: 'Салық ставкасын енгізіңіз',
    商品数量: 'Тауар саны',
    请输入商品数量: 'Тауар санын енгізіңіз',
    开票日期: 'Есеп-шот күні',
    请选择开票日期: 'Есеп-шот күнін таңдаңыз',
    开票明细: 'Есеп-шот туралы толық ақпарат',
    员工离职交接: 'Қызметкердің жұмыстан шығуын тапсыру',
    交接人: 'Тапсырушы',
    请选择交接人: 'Тапсырушыны таңдаңыз',
    单据时间: 'Құжат уақыты',
    请选择单据时间: 'Құжат уақытын таңдаңыз',
    箱数: 'Қаптама саны',
    请输入预估箱数: 'Болжалды қаптама санын енгізіңіз',
    装箱预估数量: 'Қаптау болжалды саны',
    出库单: 'Қоймадан шығару құжаты',
    请选择出库单: 'Қоймадан шығару құжатын таңдаңыз',
    正: 'Дұрыс',
    侧: 'Бүйір',
    唛信息: 'Белгі ақпараты',
    目的地: 'Мақсат',
    请输入收货目的地: 'Қабылдау мақсатын енгізіңіз',
    箱号标识: 'Қаптама нөмірі белгісі',
    '如M、B': 'Мысалы M, B',
    产地: 'Шығарылған жері',
    请输入产地: 'Шығарылған жерін енгізіңіз',
    订单号: 'Тапсырыс нөмірі',
    将自动填充: 'автоматты түрде толтырылады',
    净重: 'Таза салмағы',
    毛重: 'Жалпы салмағы',
    产品盘点: 'Өнімді тексеру',
    请选择单据日期: 'Құжат күнін таңдаңыз',
    组装: 'Жинау',
    拆卸: 'Бөлу',
    请输选择: 'Таңдаңыз',
    入库仓库: 'Қоймаға қабылдау',
    出库仓库: 'Қоймадан шығару',
    费用: 'Шығын',
    存为模版: 'Үлгі ретінде сақтау',
    拆卸产品: 'Өнімді бөлу',
    请选择拆卸产品: 'Бөлу үшін өнімді таңдаңыз',
    图片名称: 'Сурет атауы',
    请输入图片: 'Суретті енгізіңіз',
    链接地址: 'Сілтеме мекенжайы',
    请输入图片链接地址: 'Сурет сілтеме мекенжайын енгізіңіз',
    文章: 'Мақала',
    文章标题: 'Мақала тақырыбы',
    请输入文章标题: 'Мақала тақырыбын енгізіңіз',
    文章类型: 'Мақала түрі',
    请选择文章类型: 'Мақала түрін таңдаңыз',
    文章内容: 'Мақала мазмұны',
    请输入文章内容: 'Мақала мазмұнын енгізіңіз',
    提单详情: 'Контейнер туралы толық ақпарат',
    采购商: 'Сатып алушы',
    产品信息: 'Өнім ақпараты',
    总金额: 'Жалпы сома',
    产品描述: 'Өнім сипаттамасы',
    货运信息: 'Жүк тасымалдау ақпараты',
    原产国: 'Шығарылған ел',
    目的国: 'Мақсат ел',
    运输方式: 'Көлік түрі',
    数据来源: 'Дерек көзі',
    请输入姓名: 'Атын енгізіңіз',
    请输入部门: 'Бөлімді енгізіңіз',
    请输入职务: 'Лауазымды енгізіңіз',
    绩效月份: 'Көрсеткіш айы',
    请选择绩效月份: 'Көрсеткіш айын таңдаңыз',
    计提人: 'Есептеуші',
    请选计提人: 'Есептеушіні таңдаңыз',
    请选择调出仓库: 'Шығару қоймасын таңдаңыз',
    请选择调入仓库: 'Қабылдау қоймасын таңдаңыз',
    回款类型: 'Қайтару түрі',
    请选择回款类型: 'Қайтару түрін таңдаңыз',
    退款: 'Қайтару',
    回款: 'Қайтару',
    付款类型: 'Төлем түрі',
    请选择付款类型: 'Төлем түрін таңдаңыз',
    请选择优先级: 'Артықшылықты таңдаңыз',
    关键词: 'Кілт сөз',
    请选择上下架状态: 'Сату күйін таңдаңыз',
    只允许输入数字和字母: 'Тек сандар мен әріптерді енгізуге болады',
    请输入产品关键词: 'Өнім кілт сөзін енгізіңіз',
    请输入HS编码: 'HS кодын енгізіңіз',
    请输入供应商名称: 'Жеткізуші атауын енгізіңіз',
    请输入采购商名称: 'Сатып алушы атауын енгізіңіз',
    请选择原产国: 'Шығарылған елді таңдаңыз',
    请选择目的国: 'Мақсат елді таңдаңыз',
    起始时间: 'Бастау уақыты',
    请输入关键词搜索: 'Кілт сөзді іздеу үшін енгізіңіз',
    请输入公司名称搜索: 'Компания атауын іздеу үшін енгізіңіз',
    请输入产品名称搜索: 'Өнім атауын іздеу үшін енгізіңіз',
    请选择国家ISO编码: 'Елдің ISO кодын таңдаңыз',
    请选择公司经营状态: 'Компанияның қызмет күйін таңдаңыз',
    请选择公司营收范围: 'Компанияның табыс ауқымын таңдаңыз',
    请选择公司人数: 'Компания қызметкерлер санын таңдаңыз',
    一: 'бір',
    二: 'екі',
    三: 'үш',
    四: 'төрт',
    五: 'бес',
    六: 'алты',
    刚刚: 'жаңа ғана',
    分钟前: 'минут бұрын',
    小时前: 'сағат бұрын',
    天前: 'күн бұрын',
    时: 'сағат',
    分: 'минут',
    是一个函数: 'функция болып табылады',
    服务器成功返回请求数据: 'Сервер сұраныс деректерін сәтті қайтарды',
    新建或修改数据成功: 'Жаңа құру немесе деректерді өзгерту сәтті',
    '一个请求已经进入后台排队(异步任务)':
      'Бір сұраныс фондық кезекке түсті (асинхронды тапсырма)',
    删除数据成功: 'Деректерді жою сәтті',
    发出信息有误: 'Жіберілген ақпарат қате',
    '用户没有权限(令牌失效、用户名、密码错误、登录过期)':
      'Пайдаланушының рұқсаттары жоқ (токен жарамсыз, пайдаланушы аты, құпия сөз қате, кіру мерзімі өткен)',
    令牌过期: 'Токен мерзімі өткен',
    '用户得到授权，但是访问是被禁止的':
      'Пайдаланушыға рұқсат берілді, бірақ қолжетімділік бұғатталған',
    访问资源不存在: 'Қолжетімді ресурс жоқ',
    请求格式不可得: 'Сұраныс форматы қолжетімсіз',
    '请求资源被永久删除，且不会被看到':
      'Сұраныс ресурсы біржола жойылды және көрінбейді',
    服务器发生错误: 'Серверде қате пайда болды',
    网关错误: 'Шлюз қатесі',
    '服务不可用，服务器暂时过载或维护':
      'Қызмет қолжетімсіз, сервер уақытша асып түсіп немесе жөнделуде',
    网关超时: 'Шлюз уақыты өтті',
    '无网络！,请连接网络！！': 'Желі жоқ! Желіге қосылыңыз!!',
    '网络不给力！,请检查网络！！':
      'Желі жақсы жұмыс істемейді! Желіні тексеріңіз!!',
    '服务端正在升级中，请稍后再试':
      'Сервер жаңартылуда, кейінірек қайталап көріңіз',
    提审并通过: 'Тексеруге жіберу және өткізу',
    转: 'Ауыстыру',
    切换公司主体: 'Компания субъектісін ауыстыру',
    '确定解绑企业微信?': 'Кәсіпорын WeChat-ын ажыратуды растайсыз ба?',
    主体未设置企业微信: 'Субъекті кәсіпорын WeChat-ын орнатпаған',
    扫描二维码联系工作人员: 'Қызметкермен байланысу үшін QR кодын сканерлеңіз',
    正在导出的文件: 'Экспортталып жатқан файл',
    '版本)': 'нұсқа)',
    '异常捕获(温馨提示：错误必须解决)':
      'Аномалияны анықтау (Ескерту: қатені шешу керек)',
    报错路由: 'Қате маршрут',
    错误信息: 'Қате ақпарат',
    错误详情: 'Қате туралы толық ақпарат',
    暂不显示: 'Уақытша көрсетпеу',
    百度搜索: 'Baidu іздеу',
    谷歌搜索: 'Google іздеу',
    最近访问: 'Соңғы қаралған',
    总览: 'Жалпы шолу',
    开启全屏失败: 'Толық экранды қосу сәтсіз',
    服务将于: 'Қызмет мерзімі',
    天后到期: 'күннен кейін аяқталады',
    服务永不到期: 'Қызмет мерзімі ешқашан аяқталмайды',
    站内信: 'Сайт ішіндегі хат',
    全部已读: 'Барлығы оқылды',
    消息状态: 'Хабарлама күйі',
    请选择消息类型: 'Хабарлама түрін таңдаңыз',
    标记已读: 'Оқылған деп белгілеу',
    没有更多了: 'Басқа жоқ',
    清空消息成功: 'Хабарламаларды тазалау сәтті',
    自有产品: 'Менің өнімдерім',
    '已在当前产品！请换一个试试！':
      'Ағымдағы өнімде бар! Басқасын қолданып көріңіз!',
    电商网站: 'Электрондық коммерция сайты',
    '支持纵向布局、分栏布局、综合布局、常规布局，不支持横向布局、浮动布局':
      'Тік орналасу, бағандық орналасу, комплексілі орналасу, қалыпты орналасуды қолдайды, көлденең орналасу мен қалқымалы орналасуды қолдамайды',
    '请输入密码(密码在购买时获得，跳转后需登录购买时绑定的github账号)':
      'Құпия сөзді енгізіңіз (құпия сөз сатып алу кезінде алынады, ауысқаннан кейін сатып алу кезінде байланыстырылған github аккаунтпен кіру керек)',
    '秘钥不正确！': 'Құпия кілт дұрыс емес!',
    错误拦截: 'Қате бұғаттау',
    '检测到您当前浏览器使用的是IE内核，自':
      'Ағымдағы браузеріңіз IE ядросын қолданып жатқаны анықталды, бастап',
    '月起，微软已宣布弃用IE，且不再对IE提供任何更新维护，请':
      'айынан бастап, Microsoft IE-ді тоқтатқанын жариялады және IE үшін ешқандай жаңарту жөндеу жасамайды, сондықтан',
    '基于admin-plus构建': 'admin-plus негізінде құрылған',
    '抱歉!': 'Кешіріңіз!',
    '您没有操作角色...': 'Сізде әрекет рөлі жоқ...',
    '当前帐号没有操作角色,请联系管理员。':
      'Ағымдағы аккаунтта әрекет рөлі жоқ, әкімшімен байланысыңыз.',
    '当前页面不存在...': 'Ағымдағы бет жоқ...',
    '请检查您输入的网址是否正确，或点击下面的按钮返回首页。':
      'Енгізген веб-мекенжайыңыздың дұрыстығын тексеріңіз немесе төмендегі түймені басып басты бетке оралыңыз.',
    返回首页: 'Басты бетке оралу',
    '重量(KG)': 'Салмағы (КГ)',
    交易次数: 'Сауда саны',
    交易重量: 'Сауда салмағы',
    交易金额: 'Сауда сомасы',
    出口: 'Экспорт',
    期间采购共计: 'Аралықта сатып алу жиынтығы',
    次: 'рет',
    采购次数最高: 'Сатып алу саны ең жоғары',
    采购次数最低: 'Сатып алу саны ең төмен',
    采购商数量: 'Сатып алушылар саны',
    供应商数量: 'Жеткізушілер саны',
    月度趋势: 'Айлық үрдіс',
    已添加为客户: 'Тұтынушы ретінде қосылды',
    添加客户: 'Тұтынушы қосу',
    进口详单: 'Импорт туралы толық ақпарат',
    出口详单: 'Экспорт туралы толық ақпарат',
    贸易总览: 'Сауда шолуы',
    更新数据: 'Деректерді жаңарту',
    区域分布: 'Аймақ бойынша таралу',
    编码分布: 'Код бойынша таралу',
    货运历史: 'Жүк тасымалдау тарихы',
    进口: 'Импорт',
    贸易伙伴: 'Сауда серіктесі',
    搜索时间: 'Іздеу уақыты',
    页码: 'Бет нөмірі',
    查看数据: 'Деректерді қарау',
    无搜索结果: 'Іздеу нәтижесі жоқ',
    国家: 'Ел',
    经营状态: 'Қызмет күйі',
    营收范围: 'Табыс ауқымы',
    公司人数: 'Компания қызметкерлер саны',
    搜索历史: 'Іздеу тарихы',
    历史搜索: 'Тарихи іздеу',
    公司本地名称: 'Компанияның жергілікті атауы',
    城市: 'Қала',
    已解锁: 'Құлпы ашылды',
    未解锁: 'Құлпы ашылмаған',
    详情: 'Толық ақпарат',
    '您确定要解锁当前客户数据?':
      'Ағымдағы тұтынушы деректерінің құлпын ашуды қалайсыз ба?',
    产品搜索: 'Өнім іздеу',
    公司搜索: 'Компания іздеу',
    交易分析: 'Сауда талдауы',
    分析报告: 'Талдау есебі',
    回款详情: 'Қайтару туралы толық ақпарат',
    '您确定要对当前数据进行提审？':
      'Ағымдағы деректерді тексеруге жіберуді қалайсыз ба?',
    '您确定要对当前数据进行提审并通过？':
      'Ағымдағы деректерді тексеруге жіберіп өтуді қалайсыз ба?',
    回款时间: 'Қайтару уақыты',
    审核人: 'Тексеруші',
    审核时间: 'Тексеру уақыты',
    回款计划详情: 'Қайтару жоспары туралы толық ақпарат',
    '您确定要对当前数据生成发货单？':
      'Ағымдағы деректер үшін жөнелту құжатын құруды қалайсыз ба?',
    计划回款金额: 'Жоспарланған қайтару сомасы',
    付款详情: 'Төлем туралы толық ақпарат',
    付款时间: 'Төлем уақыты',
    开票计划详情: 'Есеп-шот шығару жоспары туралы толық ақпарат',
    开票公司: 'Есеп-шот шығаратын компания',
    计划开票金额: 'Жоспарланған есеп-шот сомасы',
    计划开票时间: 'Жоспарланған есеп-шот уақыты',
    开票商品名称: 'Есеп-шот шығару тауарының атауы',
    开票商品编号: 'Есеп-шот шығару тауарының нөмірі',
    商品规格型号: 'Тауар спецификация моделі',
    开票商品单位: 'Есеп-шот шығару тауарының бірлігі',
    开票税率: 'Есеп-шот салық ставкасы',
    开票商品数量: 'Есеп-шот шығару тауарының саны',
    付款计划详情: 'Төлем жоспары туралы толық ақпарат',
    计划付款金额: 'Жоспарланған төлем сомасы',
    需要数量: 'Қажетті саны',
    仓库名称: 'Қойма атауы',
    剩余数量: 'Қалған саны',
    分配库存: 'Қорды бөлу',
    关联订单: 'Байланысты тапсырыс',
    开票公司名称: 'Есеп-шот шығаратын компания атауы',
    一键复制: 'Бір басқанда көшіру',
    计划: 'Жоспар',
    计划开票占比: 'Жоспарланған есеп-шот үлесі',
    开票时间: 'Есеп-шот шығару уақыты',
    付款编号: 'Төлем нөмірі',
    关联采购单: 'Байланысты сатып алу құжаты',
    计划编号: 'Жоспар нөмірі',
    期数: 'Мерзім',
    第: 'Бірінші',
    期: 'мерзім',
    计划付款占比: 'Жоспарланған төлем үлесі',
    采购金额: 'Сатып алу сомасы',
    已付款金额占比: 'Төленген сома үлесі',
    '当前期数/总期数': 'Ағымдағы мерзім/Жалпы мерзім',
    '您确定当前数据快速付款？': 'Ағымдағы деректерді тез төлеуді қалайсыз ба?',
    计划回款占比: 'Жоспарланған қайтару үлесі',
    '已回款金额/占比': 'Қайтарылған сома/үлесі',
    '您确定当前数据快速回款？':
      'Ағымдағы деректерді тез қайтаруды қалайсыз ба?',
    回款编号: 'Қайтару нөмірі',
    客户排行: 'Тұтынушы рейтингі',
    毛利分析: 'Жалпы пайыз талдауы',
    销量最高: 'Сату көлемі ең жоғары',
    毛利最高: 'Жалпы пайыз ең жоғары',
    采购数量最大: 'Сатып алу саны ең көп',
    采购利润最高: 'Сатып алу пайдасы ең жоғары',
    采购额: 'Сатып алу сомасы',
    销售分析: 'Сату талдауы',
    成交最多的销售: 'Сауда саны ең көп',
    销量最高的产品: 'Сату көлемі ең жоғары өнім',
    毛利最多的销售: 'Жалпы пайыз ең көп',
    毛利最高的产品: 'Жалпы пайыз ең жоғары өнім',
    最近爆发的销售: 'Соңғы уақытта жаңа пайда болған сату',
    上月增长最高的产品: 'Өткен айда өсімі ең жоғары өнім',
    最近沉默的销售: 'Соңғы уақытта белсенділігі төмендеген сату',
    上月下降最多的产品: 'Өткен айда төмендеуі ең көп өнім',
    销售额: 'Сату сомасы',
    产品分析: 'Өнім талдауы',
    最畅销的产品: 'Ең сәтті сатылатын өнім',
    最赚钱的产品: 'Ең көп пайда әкелетін өнім',
    最近爆发产品: 'Соңғы уақытта жаңа пайда болған өнім',
    最近沉默产品: 'Соңғы уақытта белсенділігі төмендеген өнім',
    产品销售量: 'Өнім сату көлемі',
    商机漏斗: 'Мүмкіндік воронкасы',
    漏斗图: 'Воронка диаграммасы',
    销售排行: 'Сату рейтингі',
    数据简报: 'Дерек туралы қысқаша есеп',
    环比: 'Салыстырмалы',
    新增客户: 'Жаңа тұтынушы',
    新增商机: 'Жаңа мүмкіндік',
    新增订单: 'Жаңа тапсырыс',
    累计回款: 'Жинақталған қайтару',
    累计退款: 'Жинақталған қайтару',
    前天: 'Алдыңғы күні',
    前周: 'Алдыңғы апта',
    前月: 'Алдыңғы ай',
    前年: 'Алдыңғы жыл',
    用户趋势: 'Пайдаланушы үрдісі',
    用户数量: 'Пайдаланушылар саны',
    趋势: 'Үрдіс',
    客户跟进: 'Тұтынушы бақылауы',
    需跟进的客户: 'Бақылау қажет тұтынушы',
    商机跟进: 'Мүмкіндік бақылауы',
    订单跟进: 'Тапсырыс бақылауы',
    待办任务: 'Күтілген тапсырмалар',
    任务名称: 'Тапсырма атауы',
    计划完成时间: 'Жоспарланған аяқтау уақыты',
    占位符: 'Толтырғыш',
    图形验证码: 'Графикалық растау коды',
    账号登录: 'Аккаунт арқылы кіру',
    快捷登录: 'Жылдам кіру',
    扫码登录: 'QR код арқылы кіру',
    '企业微信扫码登录失败，请先确认您的企业微信账号确认属于该企业':
      'Кәсіпорын WeChat QR коды арқылы кіру сәтсіз, алдымен кәсіпорын WeChat аккаунтыңыздың осы кәсіпорынға тиесілі екенін растаңыз',
    验证码不能空: 'Растау коды бос болмауы керек',
    事项信息: 'Мәселе ақпараты',
    事项标题: 'Мәселе тақырыбы',
    事项类型: 'Мәселе түрі',
    所属目标: 'Тиесілі мақсат',
    重要程度: 'Маңыздылық деңгейі',
    事项参与人员: 'Мәселе қатысушылары',
    请选择参与人员: 'Қатысушыларды таңдаңыз',
    创建者: 'Құрушы',
    参与人员: 'Қатысушылар',
    事项: 'Мәселе',
    请输入事项标题: 'Мәселе тақырыбын енгізіңіз',
    请输入重要程度: 'Маңыздылық деңгейін енгізіңіз',
    请选择紧急程度: 'Шұғылдық деңгейін таңдаңыз',
    目标开始时间: 'Мақсат бастау уақыты',
    目标结束时间: 'Мақсат аяқтау уақыты',
    目标时间: 'Мақсат уақыты',
    请输入所属目标: 'Тиесілі мақсатты енгізіңіз',
    请选择所属目标: 'Тиесілі мақсатты таңдаңыз',
    数据已存在: 'Дерек бар',
    还有: 'Тағы да',
    '项...': 'элемент...',
    系统创建: 'Жүйе құрды',
    事件已结束: 'Оқиға аяқталды',
    新建日程: 'Жаңа күн тәртібі',
    上一年: 'Өткен жыл',
    上一月: 'Өткен ай',
    今天: 'Бүгін',
    下一月: 'Келесі ай',
    下一年: 'Келесі жыл',
    日程主题: 'Күн тәртібі тақырыбы',
    请输入日程主题: 'Күн тәртібі тақырыбын енгізіңіз',
    日程周期: 'Күн тәртібі мерзімі',
    日程描述: 'Күн тәртібі сипаттамасы',
    请输入日程描述: 'Күн тәртібі сипаттамасын енгізіңіз',
    产品英文名: 'Өнімнің ағылшын атауы',
    请输入产品英文名: 'Өнімнің ағылшын атауын енгізіңіз',
    产品主图: 'Өнімнің негізгі суреті',
    产品轮播图: 'Өнім слайд-шоуы',
    请输入产品描述: 'Өнім сипаттамасын енгізіңіз',
    计量单位: 'Өлшем бірлігі',
    请输入产品计量单位: 'Өнім өлшем бірлігін енгізіңіз',
    产品库存: 'Өнім қоры',
    产品销量: 'Өнім сату көлемі',
    产品成本价: 'Өнім өзіндік құны',
    产品排序值: 'Өнім сұрыптау мәні',
    产品重量: 'Өнім салмағы',
    采购建议: 'Сатып алу ұсынысы',
    请输入采购建议: 'Сатып алу ұсынысын енгізіңіз',
    于: 'уақытта',
    创建者创建时间: 'Құрушы құру уақыты',
    最近操作时间: 'Соңғы әрекет уақыты',
    故事: 'Әңгіме',
    数据周期: 'Дерек мерзімі',
    '请输入属性名：库存': 'Сипат атауын енгізіңіз: қор',
    '属性名：库存': 'Сипат атауы: қор',
    请选择数据周期: 'Дерек мерзімін таңдаңыз',
    数据类型: 'Дерек түрі',
    请选择数据类型: 'Дерек түрін таңдаңыз',
    定时任务: 'Уақыттық тапсырма',
    请选择定时任务: 'Уақыттық тапсырманы таңдаңыз',
    目标组名称: 'Мақсат тобы атауы',
    '开始时间-结束时间': 'Бастау уақыты-Аяқтау уақыты',
    目标标题: 'Мақсат тақырыбы',
    指标标题: 'Көрсеткіш тақырыбы',
    图表类型: 'Диаграмма түрі',
    目标组: 'Мақсат тобы',
    目标组标题: 'Мақсат тобы тақырыбы',
    请输入目标组标题: 'Мақсат тобы тақырыбын енгізіңіз',
    目标组开始时间: 'Мақсат тобы бастау уақыты',
    目标组结束时间: 'Мақсат тобы аяқтау уақыты',
    目标组时间: 'Мақсат тобы уақыты',
    目标: 'Мақсат',
    请输入目标标题: 'Мақсат тақырыбын енгізіңіз',
    所属目标组: 'Тиесілі мақсат тобы',
    请选择所属目标组: 'Тиесілі мақсат тобын таңдаңыз',
    指标: 'Көрсеткіш',
    请输入指标标题: 'Көрсеткіш тақырыбын енгізіңіз',
    数据源: 'Дерек көзі',
    请选择数据源: 'Дерек көзін таңдаңыз',
    选择出数据源: 'Дерек көзін таңдау',
    手动: 'Қолмен',
    自动: 'Автоматты',
    指标数据: 'Көрсеткіш деректері',
    重要不紧急: 'Маңызды, бірақ шұғыл емес',
    重要紧急: 'Маңызды және шұғыл',
    不重要不紧急: 'Маңызды емес және шұғыл емес',
    不重要紧急: 'Маңызды емес, бірақ шұғыл',
    所属指标: 'Тиесілі көрсеткіш',
    横坐标: 'Көлденең ось',
    数值: 'Мән',
    显示近一周: 'Соңғы аптаны көрсету',
    显示近一月: 'Соңғы айды көрсету',
    显示近一年: 'Соңғы жылды көрсету',
    显示全部: 'Барлығын көрсету',
    个人: 'Жеке',
    团队: 'Команда',
    预计提成: 'Алдын ала есептелген премия',
    元: 'юань',
    '预计提成：团队比例': 'Алдын ала есептелген премия: команда үлесі',
    '计提人(团队)': 'Есептеуші (команда)',
    当期金额: 'Ағымдағы кезең сомасы',
    实际提成: 'Нақты премия',
    订单编号: 'Тапсырыс нөмірі',
    团队提成: 'Команда премиясы',
    服务金额: 'Қызмет сомасы',
    合计: 'Барлығы',
    条件: 'Шарт',
    符合以下条件时按本规则计提:
      'Келесі шарттар орындалған кезде осы ереже бойынша есептеу',
    添加条件: 'Шарт қосу',
    '元）': 'юань)',
    新建规则: 'Жаңа ереже',
    '规则ID、规则名称': 'Ереже ID, ереже атауы',
    编辑规则: 'Ережені өңдеу',
    '负责人/提计人': 'Жауапты/есептеуші',
    产品分类下的扩展属性: 'Өнім санатындағы кеңейтілген сипаттар',
    产品属性: 'Өнім сипаттары',
    设置方式: 'Орнату тәсілі',
    销售价格: 'Сату бағасы',
    采购价格: 'Сатып алу бағасы',
    按客户设置: 'Тұтынушы бойынша орнату',
    价格为: 'Бағасы',
    价格币种: 'Баға валютасы',
    标准单价: 'Стандартты бірлік бағасы',
    按客户类别设置: 'Тұтынушы санаты бойынша орнату',
    默认调价比例: 'Әдепкі баға өзгерту қатынасы',
    实际调价比例: 'Нақты баға өзгерту қатынасы',
    起始年份: 'Бастау жылы',
    截止年份: 'Аяқтау жылы',
    补充年份: 'Қосымша жылдар',
    已上传: 'Жүктелді',
    上传图片: 'Сурет жүктеу',
    共: 'Барлығы',
    综述信息: 'Жалпы ақпарат',
    跟进信息: 'Бақылау ақпараты',
    详细跟进: 'Толық бақылау',
    请填写跟进内容: 'Бақылау мазмұнын толтырыңыз',
    发布: 'Жариялау',
    下次跟进: 'Келесі бақылау',
    绩效比例: 'Көрсеткіш қатынасы',
    '个人绩效相对团队绩效占比，剩余部分归负责人':
      'Жеке көрсеткіштің команда көрсеткішіне қатынасы, қалған бөлігі жауаптыға тиесілі',
    最新价格: 'Ең жаңа баға',
    历史近期: 'Тарихи соңғы',
    供应: 'Жеткізу',
    已付金额: 'Төленген сома',
    '当前订单付款总和，不扣除退款':
      'Ағымдағы тапсырыс төлемдерінің жиынтығы, қайтарылғанды есептемегенде',
    '您确定要对当前数据生成入库单？':
      'Ағымдағы деректер үшін қоймаға қабылдау құжатын құруды қалайсыз ба?',
    批量添加: 'Жаппай қосу',
    请输入企业名称: 'Кәсіпорын атауын енгізіңіз',
    '您确定要对当前数据进行作废？':
      'Ағымдағы деректерді жарамсыз етуді қалайсыз ба?',
    请选择组装拆卸产品明细: 'Жинау/бөлу өнімдерінің толық ақпаратын таңдаңыз',
    请选择组装拆卸产品: 'Жинау/бөлу өнімін таңдаңыз',
    箱单详情: 'Қаптама тізімі туралы толық ақпарат',
    '您确定要生成发货单？': 'Жөнелту құжатын құруды қалайсыз ба?',
    装箱数: 'Қаптама саны',
    '未作废数据删除，库存将不会恢复是否删除？':
      'Жарамсыз етілмеген деректерді жойсаңыз, қор қалпына келмейді. Жою керек пе?',
    '您确定要作废当前数据？': 'Ағымдағы деректерді жарамсыз етуді қалайсыз ба?',
    箱单数量: 'Қаптама тізімі саны',
    请输入预估所需箱单数: 'Болжалды қажетті қаптама тізімі санын енгізіңіз',
    拆分数量: 'Бөлу саны',
    装货箱编号: 'Жүк қаптама нөмірі',
    码: 'Код',
    包装数量: 'Қаптау саны',
    包装的数量: 'Қаптау саны',
    '单个重量(w/pc)': 'Бір данасының салмағы (w/pc)',
    包装的重量: 'Қаптау салмағы',
    '单个体积(v/pc)': 'Бір данасының көлемі (v/pc)',
    包装的体积: 'Қаптау көлемі',
    总重量: 'Жалпы салмағы',
    总体积: 'Жалпы көлемі',
    所属箱号: 'Тиесілі қаптама нөмірі',
    盘点详情: 'Тексеру туралы толық ақпарат',
    系统库存: 'Жүйе қоры',
    系统统计当前仓库的数量: 'Жүйе ағымдағы қойманың санын есептеді',
    盘点数量: 'Тексеру саны',
    盘亏盘盈: 'Артық/кемшілік',
    添加后请到出入库单列表审核:
      'Қосқаннан кейін қоймаға кіру/шығу құжаттары тізімінде тексеріңіз',
    '剩余数量（冻结库存数量)': 'Қалған саны (бұғатталған қор саны)',
    操作员: 'Оператор',
    出入库单详情: 'Қоймаға кіру/шығу құжаты туралы толық ақпарат',
    '您确定要对当前数据生成出入库单？':
      'Ағымдағы деректер үшін қоймаға кіру/шығу құжатын құруды қалайсыз ба?',
    出入库进度: 'Қоймаға кіру/шығу барысы',
    备注说明: 'Ескерту сипаттамасы',
    产品调拨详情: 'Өнімді қайта бөлу туралы толық ақпарат',
    组合件名称: 'Біріктірілген бөлшек атауы',
    单位成本: 'Бірлік өзіндік құны',
    组合成本: 'Біріктіру өзіндік құны',
    操作时间: 'Әрекет уақыты',
    操作人: 'Әрекет еткен',
    业务类型: 'Қызмет түрі',
    入库数量: 'Қоймаға қабылдау саны',
    出库数量: 'Қоймадан шығару саны',
    结存数量: 'Қалдық саны',
    库存低于预警库存: 'Қор ескерту қорынан төмен',
    各仓库数量: 'Әрбір қойманың саны',
    总库存: 'Жалпы қор',
    盘点时间: 'Тексеру уақыты',
    盘点产品量: 'Тексеру өнім саны',
    盘点人: 'Тексеруші',
    中文: 'Қытай тілі',
    父级: 'Жоғарғы деңгей',
    请选择父级: 'Жоғарғы деңгейді таңдаңыз',
    记录: 'Жазба',
    租金: 'Жалға ақы',
    人流量: 'Адам ағыны',
    是否转让: 'Ауыстыру керек пе',
    转让价格: 'Ауыстыру бағасы',
    流水: 'Айналым',
    利润: 'Пайда',
    推荐星级: 'Ұсынылған рейтинг',
    星: 'жұлдыз',
    联系方式: 'Байланыс тәсілі',
    商家: 'Саудагер',
    是否显示: 'Көрсету керек пе',
    请输入店铺名称: 'Дүкен атауын енгізіңіз',
    选址类型: 'Орын таңдау түрі',
    请选择选址类型: 'Орын таңдау түрін таңдаңыз',
    请输入店铺地址: 'Дүкен мекенжайын енгізіңіз',
    经度: 'Бойлық',
    请输入经度: 'Бойлықты енгізіңіз',
    纬度: 'Ендік',
    请输入纬度: 'Ендікті енгізіңіз',
    '租金(月)': 'Жалға ақы (айына)',
    请输入租金: 'Жалға ақыны енгізіңіз',
    请输入人流量: 'Адам ағынын енгізіңіз',
    请输入流水: 'Айналымды енгізіңіз',
    请输入利润: 'Пайданы енгізіңіз',
    请输入推荐星级: 'Ұсынылған рейтингті енгізіңіз',
    请输入转让价格: 'Ауыстыру бағасын енгізіңіз',
    请输入联系方式: 'Байланыс тәсілін енгізіңіз',
    竞品情况: 'Бәсекелестер жағдайы',
    请输入竞品情况: 'Бәсекелестер жағдайын енгізіңіз',
    请输入教程名称: 'Оқулық атауын енгізіңіз',
    教程类型: 'Оқулық түрі',
    请选择教程类型: 'Оқулық түрін таңдаңыз',
    教程: 'Оқулық',
    教程名称: 'Оқулық атауы',
    前: 'Алдында',
    小时内: 'сағат ішінде',
    分钟内: 'минут ішінде',
    销售趋势: 'Сату үрдісі',
    销售数量: 'Сату саны',
    客户最新报价: 'Тұтынушының соңғы баға ұсынысы',
    头像: 'Аватар',
    昵称: 'Лақап аты',
    真实姓名: 'Шын аты',
    手机号码: 'Ұялы телефон нөмірі',
    最后登录时间: 'Соңғы кіру уақыты',
    电话号码: 'Телефон нөмірі',
    请选择角色: 'Рөлді таңдаңыз',
    请选择公司: 'Компанияны таңдаңыз',
    请选择昵称: 'Лақап атын таңдаңыз',
    人员: 'Қызметкерлер',
    公司简称: 'Компания қысқартылған атауы',
    请输入公司简称: 'Компания қысқартылған атауын енгізіңіз',
    统一社会信用代码: 'Бірыңғай әлеуметтік сенімділік коды',
    请输入统一社会信用代码: 'Бірыңғай әлеуметтік сенімділік кодын енгізіңіз',
    企业法人: 'Кәсіпорын заңды тұлғасы',
    请输入企业法人: 'Кәсіпорын заңды тұлғасын енгізіңіз',
    注册地址: 'Тіркеу мекенжайы',
    请输入注册地址: 'Тіркеу мекенжайын енгізіңіз',
    注册日期: 'Тіркеу күні',
    请输入注册日期: 'Тіркеу күнін енгізіңіз',
    请选择注册日期: 'Тіркеу күнін таңдаңыз',
    联系电话: 'Байланыс телефон',
    请输入联系电话: 'Байланыс телефонды енгізіңіз',
    联系邮箱: 'Байланыс электрондық пошта',
    请输入联系邮箱: 'Байланыс электрондық поштаны енгізіңіз',
    站点域名: 'Сайт домені',
    请输入站点域名: 'Сайт доменін енгізіңіз',
    请输入ICP: 'ICP енгізіңіз',
    公司代号: 'Компания коды',
    请输入公司代号: 'Компания кодын енгізіңіз',
    公司简介: 'Компания туралы қысқаша мәлімет',
    请输入公司简介: 'Компания туралы қысқаша мәліметті енгізіңіз',
    公司LOGO: 'Компания логотипі',
    站点LOGO: 'Сайт логотипі',
    站点ICO: 'Сайт ICO',
    登录页背景图: 'Кіру бетінің фондық суреті',
    部门名称: 'Бөлім атауы',
    手机: 'Ұялы телефон',
    请输入部门名称: 'Бөлім атауын енгізіңіз',
    部门人员: 'Бөлім қызметкерлері',
    员工: 'Қызметкер',
    请选择员工: 'Қызметкерді таңдаңыз',
    职位: 'Лауазым',
    '您确定要对当前员工进行禁用？':
      'Ағымдағы қызметкерді бұғаттауды қалайсыз ба?',
    '您确定要对当前员工进行解除禁用？':
      'Ағымдағы қызметкердің бұғаттауын ашу керектігіне сенімдісіз бе?',
    '您确定要对当前员工进行离职处理？':
      'Ағымдағы қызметкерді жұмыстан шығаруды қалайсыз ба?',
    员工状态: 'Қызметкер күйі',
    权限字段: 'Рұқсат өрісі',
    编辑角色: 'Рөлді өңдеу',
    添加角色: 'Рөл қосу',
    角色名称: 'Рөл атауы',
    请输入角色名称: 'Рөл атауын енгізіңіз',
    角色描述: 'Рөл сипаттамасы',
    数据权限: 'Дерек рұқсаттары',
    模块权限: 'Модуль рұқсаттары',
    字段权限: 'Өріс рұқсаттары',
    请输入角色名: 'Рөл атауын енгізіңіз',
    组织架构: 'Ұйым құрылымы',
    员工管理: 'Қызметкерлерді басқару',
    标识: 'Идентификатор',
    成员限制: 'Қатысушылар шектеуі',
    成员数量: 'Қатысушылар саны',
    到期时间: 'Мерзімі аяқталу уақыты',
    站点: 'Сайт',
    行业: 'Сала',
    请输入标识: 'Идентификаторды енгізіңіз',
    管理员手机号: 'Әкімші телефон нөмірі',
    请输入管理员手机号: 'Әкімші телефон нөмірін енгізіңіз',
    管理员姓名: 'Әкімші аты',
    请输入管理员姓名: 'Әкімші атын енгізіңіз',
    公司行业: 'Компания саласы',
    请选择公司行业: 'Компания саласын таңдаңыз',
    请选择到期时间: 'Мерзімі аяқталу уақытын таңдаңыз',
    键: 'Кілт',
    必填: 'Міндетті',
    默认值: 'Әдепкі мән',
    占比: 'Үлесі',
    请输入正确key: 'Дұрыс кілтті енгізіңіз',
    字段: 'Өріс',
    只能是英文数字下划线的组合且以英文或者下划线开头:
      'Тек ағылшын әріптері, сандар, астыңғы сызықтар комбинациясы болуы керек және ағылшын әріпімен немесе астыңғы сызықпен басталу керек',
    请输入键: 'Кілтті енгізіңіз',
    请输入默认值: 'Әдепкі мәнді енгізіңіз',
    输入提示: 'Енгізу кеңесі',
    请输入输入提示: 'Енгізу кеңесін енгізіңіз',
    客户类型: 'Тұтынушы түрі',
    请输入客户类型名: 'Тұтынушы түрінің атауын енгізіңіз',
    请输入客户类型: 'Тұтынушы түрін енгізіңіз',
    客户配置: 'Тұтынушы конфигурациясы',
    行业字段: 'Сала өрісі',
    行业名称: 'Сала атауы',
    行业权限: 'Сала рұқсаттары',
    所属菜单: 'Тиесілі мәзір',
    字段名称: 'Өріс атауы',
    字段标识: 'Өріс идентификаторы',
    列表宽度: 'Тізім ені',
    父级菜单: 'Жоғарғы мәзір',
    请选择父级菜单: 'Жоғарғы мәзірді таңдаңыз',
    请输入字段名称: 'Өріс атауын енгізіңіз',
    请输入字段标识: 'Өріс идентификаторын енгізіңіз',
    请输入列表宽度: 'Тізім енін енгізіңіз',
    字段排序: 'Өріс сұрыптауы',
    请输入字段排序: 'Өріс сұрыптауын енгізіңіз',
    菜单名称: 'Мәзір атауы',
    菜单: 'Мәзір',
    请输入菜单名称: 'Мәзір атауын енгізіңіз',
    菜单地址: 'Мәзір мекенжайы',
    请输入菜单地址: 'Мәзір мекенжайын енгізіңіз',
    关联菜单: 'Байланысты мәзір',
    请选择关联菜单: 'Байланысты мәзірді таңдаңыз',
    菜单图标: 'Мәзір белгішесі',
    请输入菜单图标: 'Мәзір белгішесін енгізіңіз',
    菜单排序: 'Мәзір сұрыптауы',
    请输入菜单排序: 'Мәзір сұрыптауын енгізіңіз',
    操作名称: 'Әрекет атауы',
    操作代码: 'Әрекет коды',
    操作地址: 'Әрекет мекенжайы',
    表头操作: 'Кесте басындағы әрекет',
    列表操作: 'Тізім әрекеті',
    选项卡操作: 'Қойынды әрекеті',
    请输入操作名称: 'Әрекет атауын енгізіңіз',
    不输入则与操作名称相同: 'Енгізбесеңіз, әрекет атауымен бірдей болады',
    请输入操作代码: 'Әрекет кодын енгізіңіз',
    操作图标: 'Әрекет белгішесі',
    请输入操作图标: 'Әрекет белгішесін енгізіңіз',
    请输入操作地址: 'Әрекет мекенжайын енгізіңіз',
    操作排序: 'Әрекет сұрыптауы',
    请输入操作排序: 'Әрекет сұрыптауын енгізіңіз',
    显示在表头: 'Кесте басында көрсету',
    显示在列表: 'Тізімде көрсету',
    显示在选项卡: 'Қойындыда көрсету',
    所属企业: 'Тиесілі кәсіпорын',
    企业: 'Кәсіпорын',
    选择企业: 'Кәсіпорын таңдау',
    操作管理: 'Әрекеттерді басқару',
    字段管理: 'Өрістерді басқару',
    设备调试: 'Құрылғыны реттеу',
    门锁状态: 'Есік құлып күйі',
    物品状态: 'Зат күйі',
    门锁编号: 'Есік құлып нөмірі',
    开锁: 'Құлыпты ашу',
    检测: 'Тексеру',
    通电: 'Электр тогын беру',
    断电: 'Электр тогын үзу',
    门锁操作: 'Есік құлып әрекеті',
    门锁打开: 'Есік құлып ашылды',
    门锁已开启: 'Есік құлып ашық',
    门锁关闭: 'Есік құлып жабылды',
    门锁已关闭: 'Есік құлып жабық',
    发信昵称: 'Хат жіберуші лақап аты',
    邮箱服务商: 'Электрондық пошта провайдері',
    默认发信邮箱: 'Әдепкі хат жіберу электрондық поштасы',
    请输入发信昵称: 'Хат жіберуші лақап атын енгізіңіз',
    请选择邮箱服务商: 'Электрондық пошта провайдерін таңдаңыз',
    密码: 'Құпия сөз',
    语种: 'Тіл',
    请选择语种: 'Тілді таңдаңыз',
    '内容-头部': 'Мазмұн-бас',
    '内容-尾部': 'Мазмұн-соңы',
    用户名: 'Пайдаланушы аты',
    性别: 'Жыныс',
    个人简介: 'Жеке сипаттама',
    我的邮箱: 'Менің электрондық поштам',
    重置密码: 'Құпия сөзді қалпына келтіру',
    短信验证码: 'SMS растау коды',
    新密码: 'Жаңа құпия сөз',
    供应商分类: 'Жеткізуші санаты',
    车型配置: 'Көлік моделі конфигурациясы',
    部件配置: 'Бөлшек конфигурациясы',
    行业模板: 'Сала үлгісі',
    '请选择行业模板(非必填)': 'Сала үлгісін таңдаңыз (міндетті емес)',
    分类图片: 'Санат суреті',
    英文名称: 'Ағылшын атауы',
    顶级分类: 'Жоғарғы санат',
    请输入搜索内容: 'Іздеу мазмұнын енгізіңіз',
    父级分类: 'Жоғарғы санат',
    请选择父级分类: 'Жоғарғы санатты таңдаңыз',
    '分类名称（英文）': 'Санат атауы (ағылшын тілінде)',
    '请输入分类名称（英文）': 'Санат атауын енгізіңіз (ағылшын тілінде)',
    分类排序: 'Санат сұрыптауы',
    类型标题: 'Түр тақырыбы',
    类型名称: 'Түр атауы',
    请输入类型名称: 'Түр атауын енгізіңіз',
    仓库设置: 'Қойма параметрлері',
    图片数量: 'Суреттер саны',
    宽度: 'Ені',
    高度: 'Биіктігі',
    素材名称: 'Материал атауы',
    分类标题: 'Санат тақырыбы',
    事项分类: 'Мәселе санаты',
    故事分类: 'Әңгіме санаты',
    汇率设置: 'Валюта курсы параметрлері',
    人民币: 'Қытай юані',
    前缀: 'Префикс',
    请选择中间规则: 'Орта ережені таңдаңыз',
    请选择后缀规则: 'Суффикс ережесін таңдаңыз',
    产品编号规则: 'Өнім нөмірі ережесі',
    '前缀如CP，类型代码需要在类型信息里面增加':
      'Префикс мысалы CP, түр коды түр ақпаратына қосылуы керек',
    空: 'Бос',
    类型id: 'Түр id',
    类型代码: 'Түр коды',
    自增ID: 'Автоарттырылатын ID',
    客户编号规则: 'Тұтынушы нөмірі ережесі',
    前缀如KH: 'Префикс мысалы KH',
    国家ID: 'Ел ID',
    国家代码: 'Ел коды',
    销售单名称规则: 'Сату құжаты атауы ережесі',
    前缀如XSDD: 'Префикс мысалы XSDD',
    客户ID: 'Тұтынушы ID',
    年月日: 'Жыл-ай-күн',
    采购单名称规则: 'Сатып алу құжаты атауы ережесі',
    前缀如CGD: 'Префикс мысалы CGD',
    供应商ID: 'Жеткізуші ID',
    销售报价权限: 'Сату баға ұсынысы рұқсаттары',
    '严格模式下，报价低于产品最低售价不可提交，宽松模式下可以提交，会给出明显警告':
      'Қатаң режимде, баға ұсынысы өнімнің ең төменгі сату бағасынан төмен болса, жіберуге болмайды, жеңіл режимде жіберуге болады, бірақ айқын ескерту беріледі',
    宽松模式: 'Жеңіл режим',
    采购报价权限: 'Сатып алу баға ұсынысы рұқсаттары',
    '严格模式下，采购高于供应商报价不可提交，宽松模式下可以提交，会给出明显警告':
      'Қатаң режимде, сатып алу баға ұсынысы жеткізушінің баға ұсынысынан жоғары болса, жіберуге болмайды, жеңіл режимде жіберуге болады, бірақ айқын ескерту беріледі',
    基本配置: 'Негізгі конфигурация',
    '用户ID/用户名': 'Пайдаланушы ID/пайдаланушы аты',
    路径: 'Жол',
    请求ID: 'Сұраныс ID',
    规则: 'Ереже',
    执行类: 'Орындау класы',
    执行方法: 'Орындау әдісі',
    是否启用: 'Қосу керек пе',
    任务标题: 'Тапсырма тақырыбы',
    请输入任务标题: 'Тапсырма тақырыбын енгізіңіз',
    任务规则: 'Тапсырма ережесі',
    请输入任务规则: 'Тапсырма ережесін енгізіңіз',
    如: 'Мысалы',
    则代表每: 'онда әрбір',
    分钟执行一次: 'минут сайын орындалады',
    请输入执行类: 'Орындау класын енгізіңіз',
    请输入执行方法: 'Орындау әдісін енгізіңіз',
    任务类型: 'Тапсырма түрі',
    请选择任务类型: 'Тапсырма түрін таңдаңыз',
    参数格式: 'Параметр форматы',
    '请输入参数格式(必须为json格式),可不填写':
      'Параметр форматын енгізіңіз (json форматы болуы керек), толтырмауға болады',
    数据组类型: 'Дерек тобы түрі',
    请选择数据组类型: 'Дерек тобы түрін таңдаңыз',
    属性: 'Сипат',
    '请输入属性key(唯一)：name': 'Сипат кілтін енгізіңіз (бірегей): name',
    '属性key(唯一)：name': 'Сипат кілті (бірегей): name',
    属性类型: 'Сипат түрі',
    排序值: 'Сұрыптау мәні',
    请填写选项配置值: 'Опция конфигурация мәнін толтырыңыз',
    参数方式例如: 'Параметр тәсілі мысалы',
    白色: 'Ақ',
    红色: 'Қызыл',
    黑色: 'Қара',
    添加属性: 'Сипат қосу',
    数据组名称: 'Дерек тобы атауы',
    数据组描述: 'Дерек тобы сипаттамасы',
    请输入关键字: 'Кілт сөзді енгізіңіз',
    扩展属性: 'Кеңейтілген сипат',
    请输入数据组名称: 'Дерек тобы атауын енгізіңіз',
    请输入数据组描述: 'Дерек тобы сипаттамасын енгізіңіз',
    请上传: 'Жүктеңіз',
    主体名称: 'Субъект атауы',
    域名: 'Домен',
    站点标题: 'Сайт тақырыбы',
    团队名称: 'Команда атауы',
    主体: 'Субъект',
    所属: 'Тиесілі',
    请输入所属: 'Тиесілін енгізіңіз',
    请输入主体名称: 'Субъект атауын енгізіңіз',
    请输入税号: 'Салық нөмірін енгізіңіз',
    法人: 'Заңды тұлға',
    请输入法人: 'Заңды тұлғаны енгізіңіз',
    请输入站点标题: 'Сайт тақырыбын енгізіңіз',
    主体简介: 'Субъект туралы қысқаша мәлімет',
    请输入主体简介: 'Субъект туралы қысқаша мәліметті енгізіңіз',
    主体LOGO: 'Субъект логотипі',
    站点背景: 'Сайт фоны',
    数据配置: 'Дерек конфигурациясы',
    主体管理: 'Субъекті басқару',
    账号: 'Аккаунт',
    请输入账号: 'Аккаунтты енгізіңіз',
    周期: 'Цикл',
    日志类型: 'Журнал түрі',
    执行结果: 'Орындау нәтижесі',
    登录成功: 'Кіру сәтті',
    访问时间: 'Қолжетімділік уақыты',
    登录IP: 'Кіру IP',
    下载模版: 'Үлгіні жүктеу',
    枚举变量: 'Тізімдік айнымалы',
    模版文件: 'Үлгі файл',
    仅支持Xlsx: 'Тек Xlsx қолдайды',
    若为Xls文件请先在Excel中另存为Xlsx:
      'Егер Xls файл болса, алдымен Excel-де Xlsx ретінде сақтаңыз',
    '添加完成后，请点击字段集编辑完善模版填充配置信息':
      'Қосқаннан кейін, өріс жиынтығын өңдеуді басып, үлгі толтыру конфигурация ақпаратын толтырыңыз',
    变量: 'Айнымалы',
    为单一数据占位: 'Бір дана дерек үшін орын бөлу',
    为列数据占位: 'Баған дерегі үшін орын бөлу',
    字段集: 'Өріс жиынтығы',
    '文件名称(点击预览)': 'Файл атауы (алдын ала қарау үшін басыңыз)',
    文件大小: 'Файл көлемі',
    数据填充起始行: 'Дерек толтыру бастау жолы',
    模板选择: 'Үлгі таңдау',
    无模板导出: 'Үлгісіз экспорттау',
    模板导出: 'Үлгімен экспорттау',
    无模板打印: 'Үлгісіз басып шығару',
    模板打印: 'Үлгімен басып шығару',
    请选择模板: 'Үлгіні таңдаңыз',
    '正在导出中...': 'Экспортталуда...',
    '正在打印中...': 'Басып шығарылуда...',
    单元格: 'Ұяшық',
    多行项: 'Көпжолды элемент',
    是否求和: 'Қосынды есептеу керек пе',
    是否图片: 'Сурет пе',
    是否合并: 'Біріктіру керек пе',
    图片宽度: 'Сурет ені',
    图片高度: 'Сурет биіктігі',
    关联合并: 'Байланысты біріктіру',
    请选择字段: 'Өрісті таңдаңыз',
    链接: 'Сілтеме',
    轮播图设置: 'Слайд-шоу параметрлері',
    首页分类商品设置: 'Басты бет санат тауарлары параметрлері',
    '此内容依赖于：产品》产品分类，您可以勾选你需要展示的分类，勾选后分类将出现在首页f分类商品中。':
      'Бұл мазмұн келесіге тәуелді: өнім》өнім санаты, қажетті көрсету үшін санаттарды белгілей аласыз, белгілегеннен кейін санаттар басты беттегі f санат тауарларында пайда болады.',
    首页分类导航设置: 'Басты бет санат навигациясы параметрлері',
    '此内容依赖于：产品》产品分类，您可以勾选你需要展示的分类，勾选后分类将出现在首页导航栏中。':
      'Бұл мазмұн келесіге тәуелді: өнім》өнім санаты, қажетті көрсету үшін санаттарды белгілей аласыз, белгілегеннен кейін санаттар басты бет навигация панелінде пайда болады.',
    导航设置: 'Навигация параметрлері',
    站点名称: 'Сайт атауы',
    请输入站点名称: 'Сайт атауын енгізіңіз',
    '对SEO很重要,不要堆砌关键字':
      'SEO үшін маңызды, кілт сөздерді жинақтамаңыз',
    站点描述: 'Сайт сипаттамасы',
    请输入站点描述: 'Сайт сипаттамасын енгізіңіз',
    '站点的描述，用于展示在搜素结果':
      'Сайт сипаттамасы, іздеу нәтижелерінде көрсету үшін',
    站点关键词: 'Сайт кілт сөздері',
    请输入站点关键词: 'Сайт кілт сөздерін енгізіңіз',
    '搜索时会匹配对应的关键词，不要重复':
      'Іздеу кезінде сәйкес кілт сөздер сәйкес келеді, қайталамаңыз',
    请输入公司地址: 'Компания мекенжайын енгізіңіз',
    社媒设置: 'Әлеуметтік медиа параметрлері',
    联系我们: 'Бізбен байланысыңыз',
    请输入正确的网址信息: 'Дұрыс веб-сайт ақпаратын енгізіңіз',
    请输入facebook主页地址: 'Facebook басты бет мекенжайын енгізіңіз',
    请输入twitter主页地址: 'Twitter басты бет мекенжайын енгізіңіз',
    请输入youtube主页地址: 'Youtube басты бет мекенжайын енгізіңіз',
    请输入linkedin主页地址: 'LinkedIn басты бет мекенжайын енгізіңіз',
    请输入instagram主页地址: 'Instagram басты бет мекенжайын енгізіңіз',
    页尾设置: 'Беттің төменгі жағын параметрлеу',
    '您确定要作废当前数据?': 'Ағымдағы деректерді жарамсыз етуді қалайсыз ба?',
    实施明细: 'Енгізу туралы толық ақпарат',
    任务状态: 'Тапсырма күйі',
    参与人: 'Қатысушылар',
    未开始: 'Басталмады',
    任务详情: 'Тапсырма туралы толық ақпарат',
    任务概况: 'Тапсырма шолуы',
    完成时间: 'Аяқталу уақыты',
    '您确定要作废此任务？': 'Бұл тапсырманы жарамсыз етуді қалайсыз ба?',
    '您确定已完成此任务？': 'Бұл тапсырманы аяқтағаныңызға сенімдісіз бе?',
    请选择团队成员: 'Команда қатысушыларын таңдаңыз',
    请填写比列: 'Пропорцияны толтырыңыз',
    请填写分成比列: 'Бөлу пропорциясын толтырыңыз',
    进度: 'Барыс',
    分成比例不能低于: 'Бөлу қатынасы төмен болмауы керек',
    或高于: 'немесе жоғары',
    钱包金额: 'Әмиян сомасы',
    用户角色: 'Пайдаланушы рөлі',
    注册时间: 'Тіркеу уақыты',
    用户: 'Пайдаланушы',
    请输入真实姓名: 'Шын атын енгізіңіз',
    用户邮箱: 'Пайдаланушы электрондық поштасы',
    请输入用户邮箱: 'Пайдаланушы электрондық поштасын енгізіңіз',
    请输入正确的用户邮箱地址:
      'Дұрыс пайдаланушы электрондық пошта мекенжайын енгізіңіз',
    性别选择: 'Жынысты таңдау',
    所属团队: 'Тиесілі команда',
    请选择团队: 'Команданы таңдаңыз',
    所属角色: 'Тиесілі рөл',
    用户密码: 'Пайдаланушы құпия сөзі',
    请输入用户密码: 'Пайдаланушы құпия сөзін енгізіңіз',
    用户头像: 'Пайдаланушы аватары',
    用户昵称: 'Пайдаланушы лақап аты',
    回复: 'Жауап беру',
    反馈: 'Кері байланыс',
    请输入回复: 'Жауапты енгізіңіз',
    启用状态: 'Қосу күйі',
    用户来源: 'Пайдаланушы қайнар көзі',
    积分: 'Ұпай',
    请输入用户昵称: 'Пайдаланушы лақап атын енгізіңіз',
    请选择用户角色: 'Пайдаланушы рөлін таңдаңыз',
    未知功能: 'Белгісіз функция',
    成员头像: 'Қатысушы аватары',
    成员名称: 'Қатысушы атауы',
    成员角色: 'Қатысушы рөлі',
    管理产品: 'Өнімдерді басқару',
    请输入团队名称: 'Команда атауын енгізіңіз',
    设备区域: 'Құрылғы аймағы',
    请选择设备区域: 'Құрылғы аймағын таңдаңыз',
    团队简介: 'Команда туралы қысқаша мәлімет',
    请输入团队简介: 'Команда туралы қысқаша мәліметті енгізіңіз',
    团队头像: 'Команда аватары',
    HS编码: 'HS коды',
    '产品组成：产品A由B/C/D组成,组合的产品A在销售和库存环节跟其他产品一样。在箱单处理环节可以自动拆分':
      'Өнім құрамы: өнім A B/C/D құрамынан тұрады, құрама өнім A сату және қор деңгейінде басқа өнімдермен бірдей. Қаптама тізімін өңдеу кезінде автоматты түрде бөлінеді',
    M会自动为您过滤: 'M сіз үшін автоматты түрде сүзіледі',
    S后刷新项目: 'S кейін жобаны жаңартыңыз',
    客户投诉: 'Тұтынушы шағымы',
    配置项: 'Конфигурация элементі',
    login核心接口异常: 'login негізгі интерфейсінде аномалия',
    '请检查返回JSON格式是否正确，是否正确返回':
      'Қайтарылған JSON форматы дұрыс па, дұрыс қайтарылды ма тексеріңіз',
    getUserInfo核心接口异常: 'getUserInfo негізгі интерфейсінде аномалия',
    请检查返回JSON格式是否正确: 'Қайтарылған JSON форматы дұрыс па тексеріңіз',
    不含税: 'Салықсыз',
    产品质量: 'Өнім сапасы',
    发货速度: 'Жөнелту жылдамдығы',
    售后服务: 'Сатудан кейінгі қызмет',
    客诉: 'Тұтынушы шағымы',
    客诉标题: 'Тұтынушы шағымы тақырыбы',
    请输入客诉标题: 'Тұтынушы шағымы тақырыбын енгізіңіз',
    客诉类型: 'Тұтынушы шағымы түрі',
    关联信息: 'Байланысты ақпарат',
    请选择关联信息: 'Байланысты ақпаратты таңдаңыз',
    客诉原因: 'Тұтынушы шағымы себебі',
    请输入客诉原因: 'Тұтынушы шағымы себебін енгізіңіз',
    valFun是一个函数: 'valFun функция болып табылады',
    产品组成: 'Өнім құрамы',
    最近销售时间: 'Соңғы сату уақыты',
    EXW价格: 'EXW бағасы',
    FOB价格: 'FOB бағасы',
    厂商税率: 'Өндіруші салық ставкасы',
    最近采购时间: 'Соңғы сатып алу уақыты',
    采购次数: 'Сатып алу саны',
    产品供应商分布: 'Өнім жеткізушілерінің таралуы',
    OEM码: 'OEM коды',
    附件信息: 'Қосымша ақпарат',
    原因: 'Себеп',
    URL地址: 'URL мекенжайы',
    含税: 'Салықпен',
    请输入采购税率: 'Сатып алу салық ставкасын енгізіңіз',
    是否含税: 'Салықпен бе',
    交货方式: 'Жеткізу тәсілі',
    请选择客诉类型: 'Тұтынушы шағымы түрін таңдаңыз',
    客诉信息: 'Тұтынушы шағымы ақпараты',
    请输入客户WhatsApp: 'Тұтынушы WhatsApp-ын енгізіңіз',
    '仅支持Xlsx,若为Xls文件请先在Excel中另存为Xlsx':
      'Тек Xlsx қолдайды, егер Xls файл болса, алдымен Excel-де Xlsx ретінде сақтаңыз',
    设为主图: 'Негізгі сурет ету',
    包邮: 'Жеткізу ақысыз',
    不包邮: 'Жеткізу ақысымен',
    邮费: 'Пошта ақысы',
    减少: 'Азайту',
    增加: 'Арттыру',
    产品图文: 'Өнім графикалық және мәтіндік ақпараты',
    图文列表: 'Графикалық және мәтіндік тізім',
    图文生成: 'Графикалық және мәтіндік ақпаратты құру',
    金豆记录: 'Алтын дән жазбалары',
    是否包邮: 'Жеткізу ақысыз ба',
    抠图图集: 'Қию суреттер жинағы',
    金豆变更: 'Алтын дән өзгерісі',
    选择产品型号: 'Өнім моделін таңдау',
    预览图文: 'Графикалық және мәтіндік ақпаратты алдын ала қарау',
    生成PDF: 'PDF құру',
    '当前只可选择生成三级分类产品，若需生成完整产品图文，请先完善三级分类':
      'Ағымдағы уақытта тек үшінші деңгей санат өнімдерін таңдауға болады, толық өнім графикалық және мәтіндік ақпаратын құру үшін алдымен үшінші деңгей санатты толтырыңыз',
    生成请求已提交: 'Құру сұранысы жіберілді',
    可前往产品图文列表页查看进度:
      'Өнім графикалық және мәтіндік ақпарат тізімі бетіне барып барысты қарауға болады',
    返回上页: 'Алдыңғы бетке оралу',
    开始生成: 'Құруды бастау',
    重新生成: 'Қайта құру',
    前往列表页: 'Тізім бетіне өту',
    金豆剩余: 'Қалған алтын дән',
    消费类型: 'Тұтыну түрі',
    消费金豆: 'Алтын дәнді тұтыну',
    消费前: 'Тұтынудан бұрын',
    消费后: 'Тұтынудан кейін',
    消费时间: 'Тұтыну уақыты',
    请选择消费类型: 'Тұтыну түрін таңдаңыз',
    '您确定要对当前员工进行恢复？':
      'Ағымдағы қызметкерді қалпына келтіруді қалайсыз ба?',
    金豆使用规则: 'Алтын дән қолдану ережелері',
    长: 'Ұзындығы',
    厘米: 'сантиметр',
    宽: 'Ені',
    不能为空: 'Бос болмауы керек',
    购买数量: 'Сатып алу саны',
    '预览（可根据买家采购的不同数量设置不同价格）':
      'Алдын ала қарау (сатып алушының әртүрлі санын сатып алуына байланысты әртүрлі баға орнатуға болады)',
    可售数量: 'Сатуға қолжетімді сан',
    单品货号: 'Бірлік тауар нөмірі',
    是否上架: 'Сатуға шығарылды ма',
    上架店铺: 'Сатуға шығарылған дүкен',
    请选择店铺: 'Дүкенді таңдаңыз',
    商品类目: 'Тауар санаты',
    上一步: 'Алдыңғы қадам',
    提交: 'Жіберу',
    下一步: 'Келесі қадам',
    选择类目: 'Санатты таңдау',
    新增产品: 'Жаңа өнім қосу',
    修改产品: 'Өнімді өзгерту',
    使用运费模版: 'Жеткізу ақысы үлгісін қолдану',
    运费指导模版: 'Жеткізу ақысы бағыттауыш үлгісі',
    卖家承担运费: 'Сатушы жеткізу ақысын өзі төлейді',
    库存详情: 'Қор туралы толық ақпарат',
    国内仓: 'Ұлттық қойма',
    荔枝角: 'Личжицзяо',
    深水埗: 'Шамшуипу',
    '产品报价低于最低售价不可提交,请调整!':
      'Өнім баға ұсынысы ең төменгі сату бағасынан төмен болса, жіберуге болмайды, реттеңіз!',
    '产品报价低于最低售价!':
      'Өнім баға ұсынысы ең төменгі сату бағасынан төмен!',
    '产品报价高于最低采购价不可提交,请调整!':
      'Өнім баға ұсынысы ең төменгі сатып алу бағасынан жоғары болса, жіберуге болмайды, реттеңіз!',
    '产品报价高于最低采购价!':
      'Өнім баға ұсынысы ең төменгі сатып алу бағасынан жоғары!',
    工单: 'Жұмыс тапсырмасы',
    工序名称: 'Технологиялық процес атауы',
    加工时长: 'Өңдеу ұзақтығы',
    默认仓库: 'Әдепкі қойма',
    '尺寸/规格': 'Өлшем/Спецификация',
    所述仓库: 'Аталған қойма',
    绑定: 'Байланыстыру',
    选择: 'Таңдау',
    运费: 'Жеткізу ақысы',
    '已更换产品，需重新打印标签贴标':
      'Өнім ауыстырылды, белгіні қайта басып шығару қажет',
    规格材质: 'Спецификация материалдары',
    '蓝色字体表示建议售价，绿色字体表示历史成交报价':
      'Көк қаріп ұсынылған сату бағасын, жасыл қаріп тарихи сауда баға ұсыныстарын білдіреді',
    建议采购价: 'Ұсынылған сатып алу бағасы',
    智能选择供应商: 'Ақылды жеткізуші таңдау',
    品规: 'Сапа спецификациясы',
    '体积/净重/长-宽-高': 'Көлем/Таза салмақ/Ұзындығы-Ені-Биіктігі',
    盒规: 'Қорап спецификациясы',
    '您确定要对当前数据进行一键采购？':
      'Ағымдағы деректер үшін бір басқанда сатып алу жасауды қалайсыз ба?',
    '您确定要对当前数据进行一键备货？':
      'Ағымдағы деректер үшін бір басқанда дайындауды қалайсыз ба?',
    '当前产品明细数据有未关联的产品请关联产品?':
      'Ағымдағы өнім туралы толық ақпаратта байланыспаған өнімдер бар, өнімді байланыстырасыз ба?',
    '您当前报价低于最低售价的价格，请修改！':
      'Сіздің ағымдағы баға ұсынысыңыз ең төменгі сату бағасынан төмен, өзгертіңіз!',
    箱单信息: 'Қаптама тізімі ақпараты',
    混装: 'Аралас қаптау',
    添加箱子: 'Қаптама қосу',
    请选择箱规: 'Қаптама спецификациясын таңдаңыз',
    请选择箱号: 'Қаптама нөмірін таңдаңыз',
    '支持产品名称/OEM码/编码搜索':
      'Өнім атауы/OEM коды/код арқылы іздеуді қолдайды',
    降序: 'Кему ретімен',
    升序: 'Арту ретімен',
    月结: 'Ай сайын төлеу',
    寄付: 'Жіберуші төлейді',
    到付: 'Алушы төлейді',
    明天: 'Ертең',
    后天: 'Бүгіннен кейінгі күні',
    深水涉: 'Шамшуися',
    待入库: 'Қоймаға қабылдау күтілуде',
    在仓: 'Қоймада',
    上车: 'Көлікке жүктеу',
    取消派件: 'Жеткізуден бас тарту',
    发往客户: 'Тұтынушыға жіберу',
    已送达: 'Жеткізілді',
    元天屯: 'Юаньтяньтунь',
    九龍: 'Коулун',
    新界: 'Жаңы аймақ',
    港島: 'Гонконг аралы',
    '離島/偏遠': 'Қашық аралдар/Алыс',
    九東: 'Коулун шығыс',
    港東: 'Гонконг шығыс',
    客户账单: 'Тұтынушы есеп-шоты',
    供应商账单: 'Жеткізуші есеп-шоты',
    运营报表: 'Қызмет есептемесі',
    产品面板: 'Өнім панелі',
    电商产品: 'Электрондық коммерция өнімі',
    报价单表: 'Баға ұсыныс кестесі',
    产品图册: 'Өнім суреттер жинағы',
    产品箱规: 'Өнім қаптама спецификациясы',
    私有线索: 'Жеке із',
    公海线索: 'Қоғамдық теңіз іздері',
    销售面板: 'Сату панелі',
    抖音订单: 'Доуинь тапсырысы',
    营销: 'Маркетинг',
    我方渠道: 'Біздің арна',
    竞对渠道: 'Бәсекелес арна',
    我方店铺: 'Біздің дүкен',
    竞对店铺: 'Бәсекелес дүкен',
    渠道类型: 'Арна түрі',
    对账列表: 'Есептестік тізімі',
    账单明细: 'Есеп-шот туралы толық ақпарат',
    '发货单(家具)': 'Жөнелту құжаты (жиһаз)',
    '派货行程(家具)': 'Жеткізу бағдарламасы (жиһаз)',
    今日计划: 'Бүгінгі жоспар',
    收货单: 'Қабылдау құжаты',
    商品代发: 'Тауарларды жеткізу',
    商品退货: 'Тауарларды қайтару',
    商品索赔: 'Тауарлар бойынша шағым',
    '库存余额(家具)': 'Қор қалдығы (жиһаз)',
    快递寄件: 'Жедел хат жіберу',
    收费标准: 'Тарифтер',
    工厂: 'Зауыт',
    生产计划: 'Өндіріс жоспары',
    生产工单: 'Өндіріс тапсырмасы',
    委外管理: 'Сыртқа жалдау басқаруы',
    委外订单: 'Сыртқа жалдау тапсырысы',
    整单委外: 'Толық тапсырысты сыртқа жалдау',
    工序委外: 'Технологиялық процесті сыртқа жалдау',
    生产执行: 'Өндірісті орындау',
    生产工序: 'Өндіріс технологиялық процесі',
    报工单: 'Жұмыс есебі',
    物料管理: 'Шикізат басқаруы',
    领料单: 'Шикізат алу құжаты',
    退料单: 'Шикізатты қайтару құжаты',
    质量管理: 'Сапа басқаруы',
    工序质检: 'Технологиялық процес сапасын тексеру',
    委外质检: 'Сыртқа жалдау сапасын тексеру',
    BOM管理: 'BOM басқаруы',
    产品BOM: 'Өнім BOM',
    BOM清单: 'BOM тізімі',
    工序工艺: 'Технологиялық процес технологиясы',
    工艺: 'Технология',
    工序: 'Технологиялық процес',
    设备列表: 'Құрылғылар тізімі',
    设备类型: 'Құрылғы түрі',
    三方应用: 'Үшінші тарап қолданбасы',
    硬件配置: 'Құрылғы конфигурациясы',
    费用记录: 'Шығын жазбалары',
    仓储体积: 'Қойма көлемі',
    导出记录: 'Жазбаларды экспорттау',
    是否KP: 'KP ма',
    起订量: 'Минималды тапсырыс саны',
    部件备注: 'Бөлшек ескертуі',
    原产地: 'Шығарылған жері',
    产品评分: 'Өнім бағалауы',
    供应链评分: 'Жеткізу тізбегі бағалауы',
    账期客户: 'Есептесу мерзімі бар тұтынушы',
    感兴趣产品: 'Қызығушылық тудыратын өнімдер',
    客户折扣: 'Тұтынушы жеңілдігі',
    采购类型: 'Сатып алу түрі',
    线索名称: 'Із атауы',
    线索来源: 'Із қайнар көзі',
    线索阶段: 'Із кезеңі',
    线索编码: 'Із коды',
    客户地址: 'Тұтынушы мекенжайы',
    客户区域: 'Тұтынушы аймағы',
    产品类别: 'Өнім санаты',
    订单备注: 'Тапсырыс ескертуі',
    后台备注: 'Админ ескертуі',
    送货日期: 'Жеткізу күні',
    选择日期: 'Күнді таңдау',
    是否账期: 'Есептесу мерзімі бар ма',
    关联订单号: 'Байланысты тапсырыс нөмірі',
    订单支付状态: 'Тапсырыс төлем күйі',
    配送方式: 'Жеткізу тәсілі',
    收件电话: 'Алушы телефон',
    收件地址: 'Алушы мекенжайы',
    快递单号: 'Жедел хат нөмірі',
    收货人信息: 'Қабылдаушы ақпараты',
    所在州: 'Штат',
    运输保险: 'Көлік сақтандыруы',
    货品价值: 'Тауар құны',
    签收选项: 'Қабылдау опциялары',
    寄件人信息: 'Жіберуші ақпараты',
    商品体积: 'Тауар көлемі',
    商品重量: 'Тауар салмағы',
    商品货值: 'Тауар құны',
    快递费用: 'Жедел хат шығыны',
    包裹信息: 'Бау ақпараты',
    '长(in)': 'Ұзындығы (дюйм)',
    '宽(in)': 'Ені (дюйм)',
    '高(in)': 'Биіктігі (дюйм)',
    '重量(lb)': 'Салмағы (фунт)',
    计算费用: 'Шығынды есептеу',
    快递公司: 'Жедел хат компаниясы',
    快递面签: 'Жедел хат жүзбен қол қою',
    预约日期: 'Брондау күні',
    预约时间: 'Брондау уақыты',
    退货照片: 'Қайтару суреттері',
    外观照片: 'Сыртқы түрі суреті',
    拆开照片: 'Ашылған күйі суреті',
    处理方式: 'Өңдеу тәсілі',
    退货进度: 'Қайтару барысы',
    索赔结果: 'Шағым нәтижесі',
    订单截图: 'Тапсырыс скриншоты',
    证明图片: 'Дәлелдік сурет',
    适用产品: 'Қолданылатын өнімдер',
    版本号: 'Нұсқа нөмірі',
    计划单号: 'Жоспар нөмірі',
    生产类型: 'Өндіріс түрі',
    计划生产数量: 'Жоспарланған өндіріс саны',
    计划开工日期: 'Жоспарланған жұмыс бастау күні',
    计划完工日期: 'Жоспарланған жұмыс аяқтау күні',
    生产产品: 'Өндірілетін өнім',
    生产批次号: 'Өндіріс партия нөмірі',
    生产单号: 'Өндіріс нөмірі',
    生产状态: 'Өндіріс күйі',
    延期情况: 'Кешігу жағдайы',
    委外状态: 'Сыртқа жалдау күйі',
    入库日期: 'Қоймаға қабылдау күні',
    排产人: 'Өндіріс жоспарлаушы',
    生产完成率: 'Өндіріс аяқталу үлесі',
    已完工数量: 'Аяқталған саны',
    待入库数量: 'Қоймаға қабылдау күтілген саны',
    已入库数量: 'Қоймаға қабылданған саны',
    工序计划数量: 'Технологиялық процес жоспар саны',
    工序完工数量: 'Технологиялық процес аяқталған саны',
    报废数: 'Бұзылған саны',
    返工数: 'Қайта өңделген саны',
    总生产成本: 'Жалпы өндіріс құны',
    加工成本: 'Өңдеу құны',
    物料成本: 'Шикізат құны',
    委外编号: 'Сыртқа жалдау нөмірі',
    委外供应商: 'Сыртқа жалдау жеткізушісі',
    委外类型: 'Сыртқа жалдау түрі',
    委外产品: 'Сыртқа жалдау өнімі',
    委外数量: 'Сыртқа жалдау саны',
    委外单价: 'Сыртқа жалдау бірлік бағасы',
    委外日期: 'Сыртқа жалдау күні',
    委外总额: 'Сыртқа жалдау жалпы сомасы',
    委外应付总额: 'Сыртқа жалдау үшін төленетін жалпы сома',
    委外已付总额: 'Сыртқа жалдау үшін төленген жалпы сома',
    已退货数量: 'Қайтарылған саны',
    质检不合格数量: 'Сапа тексеруінен өтпеген саны',
    质检合格率: 'Сапа тексеруінен өткен үлесі',
    工序编号: 'Технологиялық процес нөмірі',
    工序状态: 'Технологиялық процес күйі',
    执行工序: 'Технологиялық процесті орындау',
    工艺路线: 'Технологиялық маршрут',
    工序执行人: 'Технологиялық процесті орындаушы',
    工序计划生产数: 'Технологиялық процес жоспарланған өндіріс саны',
    实际完工日期: 'Нақты аяқталу күні',
    待完工数量: 'Аяқталу күтілген саны',
    完工良品数: 'Аяқталған жақсы өнім саны',
    完工良品率: 'Аяқталған жақсы өнім үлесі',
    工序完成率: 'Технологиялық процес аяқталу үлесі',
    返工数量: 'Қайта өңдеу саны',
    返工率: 'Қайта өңдеу үлесі',
    报废数量: 'Бұзылу саны',
    报废率: 'Бұзылу үлесі',
    报工单编号: 'Жұмыс есебі нөмірі',
    生产数量: 'Өндіріс саны',
    生产人员: 'Өндіріс қызметкерлері',
    报工日期: 'Жұмыс есебі күні',
    质检状态: 'Сапа тексеру күйі',
    良品数量: 'Жақсы өнім саны',
    生产工资: 'Өндіріс жалақысы',
    工序单价: 'Технологиялық процес бірлік бағасы',
    问题描述: 'Мәселе сипаттамасы',
    问题图片: 'Мәселе суреті',
    物料申请单号: 'Шикізат өтініш нөмірі',
    审批状态: 'Бекіту күйі',
    申请人: 'Өтініш беруші',
    申请时间: 'Өтініш уақыты',
    委外工单: 'Сыртқа жалдау тапсырмасы',
    设备名称: 'Құрылғы атауы',
    设备编码: 'Құрылғы коды',
    设备型号: 'Құрылғы моделі',
    外观尺寸: 'Сыртқы өлшемдері',
    设备用途: 'Құрылғы қолданылуы',
    管理负责人: 'Басқару жауаптысы',
    投产日期: 'Өндіріске енгізу күні',
    采购日期: 'Сатып алу күні',
    生产日期: 'Өндіріс күні',
    生产厂家: 'Өндіруші',
    用途: 'Қолданылуы',
    设备图集: 'Құрылғы суреттер жинағы',
    请输入OEM码多个: 'Бірнеше OEM кодын енгізіңіз',
    分割: 'Бөлу',
    请选择产品类别: 'Өнім санатын таңдаңыз',
    是否关键产品: 'Негізгі өнім бе',
    请选择原产地: 'Шығарылған жерін таңдаңыз',
    请输入部件备注: 'Бөлшек ескертуін енгізіңіз',
    箱规信息已移至详情页面添加编辑:
      'Қаптама спецификациясы ақпараты егжей-тегжей бетіне қосылып өңделуге жылжытылды',
    产品规格: 'Өнім спецификациясы',
    复制产品: 'Өнімді көшіру',
    图片设计: 'Сурет дизайндау',
    箱规类型: 'Қаптама спецификациясы түрі',
    请选择箱规类型: 'Қаптама спецификациясы түрін таңдаңыз',
    请输入产品数量: 'Өнім санын енгізіңіз',
    可以容纳的产品个数: 'Сыйымдылық өнім саны',
    默认箱规: 'Әдепкі қаптама спецификациясы',
    费用箱规: 'Шығын қаптама спецификациясы',
    计算货品体积费用时的箱规:
      'Тауар көлемін есептеу шығындары үшін қаптама спецификациясы',
    '长(cm)': 'Ұзындығы(см)',
    请输入箱规长: 'Қаптама спецификациясы ұзындығын енгізіңіз',
    '宽(cm)': 'Ені(см)',
    请输入箱规宽: 'Қаптама спецификациясы енін енгізіңіз',
    '高(cm)': 'Биіктігі(см)',
    请输入箱规高: 'Қаптама спецификациясы биіктігін енгізіңіз',
    请输入箱规重量: 'Қаптама спецификациясы салмағын енгізіңіз',
    请输入箱规体积: 'Қаптама спецификациясы көлемін енгізіңіз',
    所属分类: 'Тиесілі санат',
    请选择所属分类: 'Тиесілі санатты таңдаңыз',
    '用于生成电商网站的链接,可不填写':
      'Электрондық коммерция сайтын құру үшін қолданылатын сілтеме, толтыру міндетті емес',
    图册: 'Суреттер жинағы',
    文件请到附件中上传: 'Файлды қосымшаларға жүктеңіз',
    产品id: 'Өнім id',
    渠道名称: 'Арна атауы',
    请选择渠道名称: 'Арна атауын таңдаңыз',
    请输入链接地址: 'Сілтеме мекенжайын енгізіңіз',
    请输入销售价格: 'Сату бағасын енгізіңіз',
    售出产品数: 'Сатылған өнім саны',
    请输入售出产品数量: 'Сатылған өнім санын енгізіңіз',
    拉取三方店铺商品: 'Үшінші тарап дүкенінен тауарларды алу',
    拉取三方店铺订单: 'Үшінші тарап дүкенінен тапсырыстарды алу',
    三方店铺: 'Үшінші тарап дүкені',
    请选择三方店铺: 'Үшінші тарап дүкенін таңдаңыз',
    拉取: 'Алу',
    当前快递单号为: 'Ағымдағы жедел хат нөмірі',
    下单成功: 'Тапсырыс берілді',
    保存并打印: 'Сақтау және басып шығару',
    请输入订单号: 'Тапсырыс нөмірін енгізіңіз',
    客户信息: 'Тұтынушы ақпараты',
    智能填写: 'Ақылды толтыру',
    '粘贴收货信息到此处，将自动识别姓名/电话/地址':
      'Қабылдау ақпаратын осы жерге қойыңыз, аты/телефоны/мекенжайы автоматты түрде анықталады',
    客户电话: 'Тұтынушы телефон',
    请输入客户电话: 'Тұтынушы телефон нөмірін енгізіңіз',
    已存在客户: 'Бар тұтынушы',
    '是否使用当前客户信息？': 'Ағымдағы тұтынушы ақпаратын қолдану керек пе?',
    客户姓名: 'Тұтынушы аты',
    请输入客户姓名: 'Тұтынушы атын енгізіңіз',
    收货地址: 'Қабылдау мекенжайы',
    请输入收货地址: 'Қабылдау мекенжайын енгізіңіз',
    销售点: 'Сату нүктесі',
    请选择销售点: 'Сату нүктесін таңдаңыз',
    付款信息: 'Төлем ақпараты',
    是否已付款: 'Төленді ме',
    '您的报价产品中有低于最低售价的价格，请检查！':
      'Сіздің баға ұсыныс өнімдеріңізде ең төменгі сату бағасынан төмен бағалар бар, тексеріңіз!',
    线索: 'Із',
    国家地区: 'Ел аймағы',
    请输入客户感兴趣产品: 'Тұтынушы қызығушылық тудыратын өнімдерді енгізіңіз',
    是否KA: 'KA ма',
    请输入客户网址: 'Тұтынушы веб-сайтын енгізіңіз',
    请输入客户地区: 'Тұтынушы аймағын енгізіңіз',
    请输入客户折扣百分比: 'Тұтынушы жеңілдік пайызын енгізіңіз',
    请输入比分比: 'Пропорцияны енгізіңіз',
    请选择线索阶段: 'Із кезеңін таңдаңыз',
    请输入收件人: 'Алушыны енгізіңіз',
    请输入收件电话: 'Алушы телефон нөмірін енгізіңіз',
    请输入收件地址: 'Алушы мекенжайын енгізіңіз',
    请选择渠道类型: 'Арна түрін таңдаңыз',
    渠道分类: 'Арна санаты',
    请选择渠道分类: 'Арна санатын таңдаңыз',
    快递账号: 'Жедел хат аккаунты',
    请选择快递账号: 'Жедел хат аккаунтын таңдаңыз',
    系统配置: 'Жүйе конфигурациясы',
    快递账号配置: 'Жедел хат аккаунт конфигурациясы',
    中添加: 'қосу',
    请输入采购单单号: 'Сатып алу тапсырыс нөмірін енгізіңіз',
    账期: 'Есептесу мерзімі',
    添加付款明细: 'Төлем туралы толық ақпарат қосу',
    请输入昵称: 'Лақап атын енгізіңіз',
    密码为手机号后六位: 'Құпия сөз телефон нөмірінің соңғы алты цифры',
    请选择部门: 'Бөлімді таңдаңыз',
    供应商账号: 'Жеткізуші аккаунты',
    关联供应商: 'Байланысты жеткізуші',
    入库预报: 'Қоймаға қабылдау болжамы',
    请选择配送方式: 'Жеткізу тәсілін таңдаңыз',
    交货时间: 'Жеткізу уақыты',
    收货人姓名: 'Қабылдаушы аты',
    请输入收货人姓名: 'Қабылдаушы атын енгізіңіз',
    收货人电话: 'Қабылдаушы телефон',
    请输入收货人电话: 'Қабылдаушы телефон нөмірін енгізіңіз',
    收货人邮箱: 'Қабылдаушы электрондық поштасы',
    请输入收货人邮箱: 'Қабылдаушы электрондық поштасын енгізіңіз',
    收货人地址: 'Қабылдаушы мекенжайы',
    请输入收货人地址: 'Қабылдаушы мекенжайын енгізіңіз',
    请输入城市: 'Қаланы енгізіңіз',
    州: 'Штат',
    请输入州: 'Штатты енгізіңіз',
    请选择国家: 'Елді таңдаңыз',
    请输入邮编: 'Пошта индексін енгізіңіз',
    请输入包装要求: 'Қаптау талабын енгізіңіз',
    寄件人: 'Жіберуші',
    请选择寄件人信息: 'Жіберуші ақпаратын таңдаңыз',
    请选择签收选项: 'Қабылдау опцияларын таңдаңыз',
    请选择运输保险: 'Көлік сақтандыруын таңдаңыз',
    商品代发单: 'Тауарларды жеткізу тапсырысы',
    快递索赔单: 'Жедел хат шағымы',
    商品退货单: 'Тауарларды қайтару тапсырысы',
    请输入快递单号: 'Жедел хат нөмірін енгізіңіз',
    请选择处理方式: 'Өңдеу тәсілін таңдаңыз',
    将收取一定的费用: 'Белгілі бір шығындар алынады',
    请输入备注信息: 'Ескерту ақпаратын енгізіңіз',
    '退货拍照(拆开)': 'Қайтару суреті(ашылған)',
    '退货拍照(外观)': 'Қайтару суреті(сыртқы түрі)',
    提交后将会通知供货商:
      'Жібергеннен кейін жеткізушіге хабарландыру жіберіледі',
    选择处理方式: 'Өңдеу тәсілін таңдау',
    处理费用: 'Өңдеу шығындары',
    请输入处理费用: 'Өңдеу шығындарын енгізіңіз',
    商品快递索赔: 'Тауар жедел хат шағымы',
    请输入货品价值: 'Тауар құнын енгізіңіз',
    请输入索赔原因: 'Шағым себебін енгізіңіз',
    结果: 'Нәтиже',
    请选择结果: 'Нәтижені таңдаңыз',
    请输入费用: 'Шығындарды енгізіңіз',
    三方发货: 'Үшінші тарап жеткізу',
    多个用英文逗号隔开: 'Бірнешеуін ағылшын тіліндегі үтірмен бөліңіз',
    等: 'және т.б.',
    件产品: 'тауар данасы',
    请选择发货计划: 'Жеткізу жоспарын таңдаңыз',
    收件人信息: 'Алушы ақпараты',
    收件人姓名: 'Алушы аты',
    请输入收件人姓名: 'Алушы атын енгізіңіз',
    收件人手机号: 'Алушы телефон нөмірі',
    请输入收件人手机号: 'Алушы телефон нөмірін енгізіңіз',
    收件人地址: 'Алушы мекенжайы',
    请输入收件人地址: 'Алушы мекенжайын енгізіңіз',
    省市区县街道: 'Облыс/қала/аймақ/көше',
    快捷选择寄件人信息: 'Жіберуші ақпаратын жылдам таңдау',
    更多快捷寄件人信息请到: 'Қосымша жылдам жіберуші ақпараты үшін кіріңіз',
    发货地址: 'Жеткізу мекенжайы',
    寄件人姓名: 'Жіберуші аты',
    请输入寄件人姓名: 'Жіберуші атын енгізіңіз',
    寄件人手机号: 'Жіберуші телефон нөмірі',
    请输入寄件人手机号: 'Жіберуші телефон нөмірін енгізіңіз',
    寄件人地址: 'Жіберуші мекенжайы',
    请输入寄件人地址: 'Жіберуші мекенжайын енгізіңіз',
    快递信息: 'Жедел хат ақпараты',
    请选择快递公司: 'Жедел хат компаниясын таңдаңыз',
    物品名称: 'Зат атауы',
    请输入物品名称: 'Зат атауын енгізіңіз',
    支付方式: 'Төлем тәсілі',
    请选择支付方式: 'Төлем тәсілін таңдаңыз',
    '物品总重量(Kg)': 'Заттардың жалпы салмағы(кг)',
    请输入物品总重量: 'Заттардың жалпы салмағын енгізіңіз',
    无需单位: 'Бірліксіз',
    寄件: 'Жіберу',
    '下单中...': 'Тапсырыс берілуде...',
    立即打印面单: 'Дереу жүзбен қол қою парағын басып шығару',
    打印机: 'Принтер',
    请选择打印机: 'Принтерді таңдаңыз',
    快递配置: 'Жедел хат конфигурациясы',
    请选择快递配置: 'Жедел хат конфигурациясын таңдаңыз',
    请选择委外订单: 'Сыртқа жалдау тапсырысын таңдаңыз',
    请输入产品名: 'Өнім атауын енгізіңіз',
    名片: 'Визитка',
    是否固定: 'Бекітілген бе',
    默认排序: 'Әдепкі сұрыптау',
    排序方式: 'Сұрыптау тәсілі',
    设置默认排序字段: 'Әдепкі сұрыптау өрісін орнату',
    请输入HSCODE: 'HSCODE енгізіңіз',
    别名: 'Бүркеншік атау',
    '请输入别名,多个用英文逗号隔开':
      'Бүркеншік атауды енгізіңіз, бірнешеуін ағылшын тіліндегі үтірмен бөліңіз',
    销售渠道: 'Сату арнасы',
    推广渠道: 'Насихаттау арнасы',
    关联店铺: 'Байланысты дүкен',
    请选择关联店铺: 'Байланысты дүкенді таңдаңыз',
    请输入渠道名称: 'Арна атауын енгізіңіз',
    快速调价: 'Жылдам баға өзгерту',
    当前修改影响: 'Ағымдағы өзгеріс әсер етеді',
    '条数据,总价': 'жол дерегі, жалпы бағасы',
    '是否继续修改?': 'Өзгертуді жалғастырасыз ба?',
    新购产品按建议价格: 'Жаңа сатып алынатын өнімдер ұсынылған баға бойынша',
    请输入倍率: 'Көбейткішті енгізіңіз',
    倍调价: 'Көбейткішпен баға өзгерту',
    复购产品按历史底价:
      'Қайта сатып алынатын өнімдер тарихи ең төменгі баға бойынша',
    所有产品按当前价格: 'Барлық өнімдер ағымдағы баға бойынша',
    打印模版: 'Басып шығару үлгісі',
    硬件设备: 'Құрылғылар',
    购买打印机: 'Принтер сатып алу',
    飞鹅云标签打印机: 'Feie Cloud белгі принтері',
    佳博云标签打印机: 'Gainscha Cloud белгі принтері',
    SN编码: 'SN коды',
    请输入SN编码: 'SN кодын енгізіңіз',
    是否默认: 'Әдепкі ме',
    '标签纸长(mm)': 'Белгі қағазының ұзындығы(мм)',
    请输入标签纸长度: 'Белгі қағазының ұзындығын енгізіңіз',
    '标签纸宽(mm)': 'Белгі қағазының ені(мм)',
    请输入标签纸宽度: 'Белгі қағазының енін енгізіңіз',
    模本内容: 'Үлгі мазмұны',
    请输入模本内容: 'Үлгі мазмұнын енгізіңіз',
    缩略图: 'Кіші сурет',
    最大打印宽度: 'Ең үлкен басып шығару ені',
    购买: 'Сатып алу',
    打印标签: 'Белгіні басып шығару',
    请选择设备: 'Құрылғыны таңдаңыз',
    请选择打印模版: 'Басып шығару үлгісін таңдаңыз',
    请输入打印数量: 'Басып шығару санын енгізіңіз',
    请输入寄件人: 'Жіберушіні енгізіңіз',
    寄件人电话: 'Жіберуші телефон',
    请输入寄件人电话: 'Жіберуші телефон нөмірін енгізіңіз',
    寄件人邮箱: 'Жіберуші электрондық поштасы',
    请输入寄件人邮箱: 'Жіберуші электрондық поштасын енгізіңіз',
    寄件地址: 'Жіберу мекенжайы',
    请输入寄件地址: 'Жіберу мекенжайын енгізіңіз',
    默认地址: 'Әдепкі мекенжай',
    费用变更: 'Шығындар өзгерісі',
    费用方式: 'Шығындар тәсілі',
    费用类型: 'Шығындар түрі',
    请选择费用类型: 'Шығындар түрін таңдаңыз',
    请输入金额: 'Соманы енгізіңіз',
    请输入文件名称: 'Файл атауын енгізіңіз',
    来源链接: 'Қайнар көз сілтемесі',
    请输入网页来源链接: 'Веб-сайт қайнар көз сілтемесін енгізіңіз',
    更换产品: 'Өнімді ауыстыру',
    更换的产品: 'Ауыстырылған өнім',
    名称备注: 'Атау ескертуі',
    请输入菜单名称备注: 'Мәзір атау ескертуін енгізіңіз',
    是否显示PC: 'Компьютерде көрсету керек пе',
    是否显示移动端: 'Ұялы телефонда көрсету керек пе',
    请输入token: 'Токенді енгізіңіз',
    征收比例: 'Салық алу қатынасы',
    快递费用征收比例: 'Жедел хат шығындарын салық алу қатынасы',
    请输入比例: 'Пропорцияны енгізіңіз',
    请选择版本号: 'Нұсқа нөмірін таңдаңыз',
    用量: 'Қолданыс саны',
    请输入用量: 'Қолданыс санын енгізіңіз',
    损耗率: 'Шығын қатынасы',
    请输入损耗率: 'Шығын қатынасын енгізіңіз',
    物料BOM: 'Шикізат BOM',
    请选择物料BOM: 'Шикізат BOM таңдаңыз',
    请输入单位: 'Бірлікті енгізіңіз',
    请输入单价: 'Бірлік бағасын енгізіңіз',
    时长: 'Ұзақтық',
    请输入加工时长: 'Өңдеу ұзақтығын енгізіңіз',
    是否质检: 'Сапа тексеруі керек пе',
    请输入工序描述: 'Технологиялық процес сипаттамасын енгізіңіз',
    请选择生产类型: 'Өндіріс түрін таңдаңыз',
    请选择订单: 'Тапсырысты таңдаңыз',
    请选择产品BOM: 'Өнім BOM таңдаңыз',
    请选择生产优先级: 'Өндіріс артықшылығын таңдаңыз',
    请输入交货日期: 'Жеткізу күнін енгізіңіз',
    请输入计划开工日期: 'Жоспарланған жұмыс бастау күнін енгізіңіз',
    请输入计划完工日期: 'Жоспарланған жұмыс аяқтау күнін енгізіңіз',
    请输入生产批次号: 'Өндіріс партия нөмірін енгізіңіз',
    委外工序: 'Сыртқа жалдау технологиялық процесі',
    请选择生产状态: 'Өндіріс күйін таңдаңыз',
    请选择生产计划: 'Өндіріс жоспарын таңдаңыз',
    生产订单: 'Өндіріс тапсырысы',
    请选择生产订单: 'Өндіріс тапсырысын таңдаңыз',
    请选择执行工序: 'Орындалатын технологиялық процесті таңдаңыз',
    请选择委外工序: 'Сыртқа жалдау технологиялық процесін таңдаңыз',
    生产需求: 'Өндіріс қажеттілігі',
    请选择生产需求: 'Өндіріс қажеттілігін таңдаңыз',
    请选择产品工艺: 'Өнім технологиясын таңдаңыз',
    请输入委外数量: 'Сыртқа жалдау санын енгізіңіз',
    请输入计划生产数量: 'Жоспарланған өндіріс санын енгізіңіз',
    请输入委外单价: 'Сыртқа жалдау бірлік бағасын енгізіңіз',
    请选择计划开工日期: 'Жоспарланған жұмыс бастау күнін таңдаңыз',
    请选择委外日期: 'Сыртқа жалдау күнін таңдаңыз',
    请选择计划完工日期: 'Жоспарланған жұмыс аяқтау күнін таңдаңыз',
    '请搜索/选择负责人': 'Жауаптыны іздеңіз/таңдаңыз',
    请选择生产工单: 'Өндіріс тапсырмасын таңдаңыз',
    产品工艺: 'Өнім технологиясы',
    请选择工序执行人: 'Технологиялық процесті орындаушыны таңдаңыз',
    '请搜索/选择工序执行人':
      'Технологиялық процесті орындаушыны іздеңіз/таңдаңыз',
    请输入生产数量: 'Өндіріс санын енгізіңіз',
    请选择生产人员: 'Өндіріс қызметкерлерін таңдаңыз',
    '请搜索/选择生产人员': 'Өндіріс қызметкерлерін іздеңіз/таңдаңыз',
    请选择报工日期: 'Жұмыс есебі күнін таңдаңыз',
    质检数量: 'Сапа тексеру саны',
    请输入质检数量: 'Сапа тексеру санын енгізіңіз',
    请输入入库数量: 'Қоймаға қабылдау санын енгізіңіз',
    质检: 'Сапа тексеру',
    请输入报废数量: 'Бұзылу санын енгізіңіз',
    请输入返工数量: 'Қайта өңдеу санын енгізіңіз',
    请输入良品数量: 'Жақсы өнім санын енгізіңіз',
    请输入问题描述: 'Мәселе сипаттамасын енгізіңіз',
    类别: 'Санат',
    请选择申请人: 'Өтініш берушіні таңдаңыз',
    请选择关联领料单: 'Байланысты шикізат алу құжатын таңдаңыз',
    服务商: 'Қызмет көрсетуші',
    请选择快递服务商: 'Жедел хат қызмет көрсетушіні таңдаңыз',
    月结号: 'Ай сайын төлеу нөмірі',
    请输入月结号: 'Ай сайын төлеу нөмірін енгізіңіз',
    添加快递信息: 'Жедел хат ақпаратын қосу',
    选择香港仓库: 'Гонконг қоймасын таңдау',
    选择仓库: 'Қойманы таңдау',
    选择发货时间及司机: 'Жеткізу уақыты мен көлік жүргізушіні таңдау',
    司机: 'Көлік жүргізуші',
    请选择司机: 'Көлік жүргізушіні таңдаңыз',
    '请搜索/选择司机': 'Көлік жүргізушіні іздеңіз/таңдаңыз',
    请选择发货日期: 'Жеткізу күнін таңдаңыз',
    上门时间: 'Келу уақыты',
    截止时间: 'Аяқталу уақыты',
    更改区域: 'Аймақты өзгерту',
    区域: 'Аймақ',
    请选择区域: 'Аймақты таңдаңыз',
    shopify店铺: 'Shopify дүкені',
    店铺名: 'Дүкен атауы',
    请输入shopify店铺名: 'Shopify дүкен атауын енгізіңіз',
    请输入店铺名: 'Дүкен атауын енгізіңіз',
    请输入access: 'Қолжетімділікті енгізіңіз',
    请输入app: 'Қолданбаны енгізіңіз',
    对账明细: 'Есептестік туралы толық ақпарат',
    请输入日期: 'Күнді енгізіңіз',
    生产设备: 'Өндіріс құрылғылары',
    请输入设备名称: 'Құрылғы атауын енгізіңіз',
    请选择设备类型: 'Құрылғы түрін таңдаңыз',
    请输入设备编码SN: 'Құрылғы коды SN енгізіңіз',
    请输入设备型号: 'Құрылғы моделін енгізіңіз',
    请输入长度: 'Ұзындығын енгізіңіз',
    请输入宽度: 'Енін енгізіңіз',
    请输入高度: 'Биіктігін енгізіңіз',
    请选择采购日期: 'Сатып алу күнін таңдаңыз',
    请选择投产日期: 'Өндіріске енгізу күнін таңдаңыз',
    请输入采购价格: 'Сатып алу бағасын енгізіңіз',
    采购币种: 'Сатып алу валютасы',
    请输入生产厂家: 'Өндірушіні енгізіңіз',
    请选择生产日期: 'Өндіріс күнін таңдаңыз',
    请输入用途: 'Қолданылуын енгізіңіз',
    发货: 'Жеткізу',
    同步发货状态: 'Жеткізу күйін синхрондау',
    行: 'Жол',
    请输入行: 'Жолды енгізіңіз',
    请输入子仓库行数: 'Ішкі қойма жол санын енгізіңіз',
    列: 'Баған',
    请输入列: 'Бағанды енгізіңіз',
    请输入子仓库列数: 'Ішкі қойма баған санын енгізіңіз',
    子仓库数量不能超过: 'Ішкі қойма саны аспауы керек',
    个: 'дана',
    新增仓库: 'Жаңа қойма қосу',
    '请搜索/选择产品': 'Өнімді іздеңіз/таңдаңыз',
    '请搜索/选择创建人': 'Құрушыны іздеңіз/таңдаңыз',
    编辑人: 'Өңдеуші',
    '请搜索/选择最后编辑人': 'Соңғы өңдеушіні іздеңіз/таңдаңыз',
    '请搜索/选择供应商': 'Жеткізушіні іздеңіз/таңдаңыз',
    请输入价格: 'Бағаны енгізіңіз',
    请选择委外状态: 'Сыртқа жалдау күйін таңдаңыз',
    请选择工序状态: 'Технологиялық процес күйін таңдаңыз',
    店铺: 'Дүкен',
    关联状态: 'Байланыс күйі',
    请选择关联状态: 'Байланыс күйін таңдаңыз',
    未关联: 'Байланыспаған',
    已关联: 'Байланысқан',
    面单模板: 'Жүзбен қол қою парағы үлгісі',
    请选择电子面单模板: 'Электрондық жүзбен қол қою парағы үлгісін таңдаңыз',
    打印类型: 'Басып шығару түрі',
    请选择打印类型: 'Басып шығару түрін таңдаңыз',
    只下单不打印: 'Тек тапсырыс беру, басып шығармау',
    生成图片短链: 'Сурет қысқа сілтемесін құру',
    快递: 'Жедел хат',
    云打印机: 'Бұлт принтері',
    生成html短链: 'HTML қысқа сілтемесін құру',
    '请搜索/选择客户来源': 'Тұтынушы қайнар көзін іздеңіз/таңдаңыз',
    '请搜索/选择销售点': 'Сату нүктесін іздеңіз/таңдаңыз',
    货物状态: 'Жүк күйі',
    请选择货物状态: 'Жүк күйін таңдаңыз',
    '请搜索/选择客户': 'Тұтынушыны іздеңіз/таңдаңыз',
    请选择账期日期: 'Есептесу мерзімі күнін таңдаңыз',
    账期类型: 'Есептесу мерзімі түрі',
    请选择账期类型: 'Есептесу мерзімі түрін таңдаңыз',
    '产品编码/名称关键字': 'Өнім коды/атау кілт сөзі',
    '輸入產品/單號/手機': 'Өнім/тапсырыс нөмірі/телефон енгізіңіз',
    请选择数据权限: 'Дерек рұқсаттарын таңдаңыз',
    '请搜索/选择渠道名称': 'Арна атауын іздеңіз/таңдаңыз',
    '请搜索/选择产品分类': 'Өнім санатын іздеңіз/таңдаңыз',
    '请搜索/选择部件': 'Бөлшекті іздеңіз/таңдаңыз',
    '请搜索/选择产品货源': 'Өнім қайнар көзін іздеңіз/таңдаңыз',
    '请搜索/选择产品上下架状态': 'Өнім сату күйін іздеңіз/таңдаңыз',
    请选择客户类型: 'Тұтынушы түрін таңдаңыз',
    '请搜索/选择客户等级': 'Тұтынушы деңгейін іздеңіз/таңдаңыз',
    '请搜索/选择客户行业': 'Тұтынушы саласын іздеңіз/таңдаңыз',
    请输入感兴趣的产品: 'Қызығушылық тудыратын өнімдерді енгізіңіз',
    线索状态: 'Із күйі',
    请选择线索状态: 'Із күйін таңдаңыз',
    '名称/单号/关键词': 'Атау/нөмір/кілт сөз',
    请选择计划日期: 'Жоспар күнін таңдаңыз',
    '请搜索/选择业务员': 'Саудагерді іздеңіз/таңдаңыз',
    退货状态: 'Қайтару күйі',
    请选择退货状态: 'Қайтару күйін таңдаңыз',
    '请搜索/选择渠道': 'Арнаны іздеңіз/таңдаңыз',
    '请搜索/选择渠道类型': 'Арна түрін іздеңіз/таңдаңыз',
    图册名称: 'Суреттер жинағы атауы',
    请选择图册名称: 'Суреттер жинағы атауын таңдаңыз',
    '请输入编码/选择产品': 'Кодты енгізіңіз/өнімді таңдаңыз',
    请选择在仓状态: 'Қоймадағы күйді таңдаңыз',
    服务器正在升级中: 'Сервер жаңартылуда',
    '响应超时，请稍后再试': 'Жауап уақыты өтті, кейінірек қайталап көріңіз',
    线索详情: 'Із туралы толық ақпарат',
    导出明细: 'Туралы толық ақпаратты экспорттау',
    客户产品: 'Тұтынушы өнімдері',
    线索等级: 'Із деңгейі',
    '您确定要将当前线索转化为客户吗？':
      'Ағымдағы ізді тұтынушыға айналдыруды қалайсыз ба?',
    '您确定要将当前线索释放发到公海吗？':
      'Ағымдағы ізді қоғамдық теңізге босатуды қалайсыз ба?',
    '您确定要领取当前线索？': 'Ағымдағы ізді алу керектігіне сенімдісіз бе?',
    分配线索: 'Ізді бөлу',
    是否为负责人: 'Жауапты ма',
    天成交单数: 'Күн сайынғы шарт жасау саны',
    天成交金额: 'Күн сайынғы шарт жасау сомасы',
    客户评分: 'Тұтынушы бағалауы',
    感兴趣的产品: 'Қызығушылық тудыратын өнімдер',
    折扣: 'Жеңілдік',
    最后下单时间: 'Соңғы тапсырыс беру уақыты',
    生成账单: 'Есеп-шот құру',
    设备详情: 'Құрылғы туралы толық ақпарат',
    充值记录: 'Толтыру жазбалары',
    充值成功: 'Толтыру сәтті',
    充值失败: 'Толтыру сәтсіз',
    充值金额: 'Толтыру сомасы',
    充值状态: 'Толтыру күйі',
    充值账户: 'Толтыру шоты',
    充值时间: 'Толтыру уақыты',
    物料: 'Шикізат',
    可用库存: 'Қолжетімді қор',
    所属BOM: 'Тиесілі BOM',
    BOM详情: 'BOM туралы толық ақпарат',
    清单明细: 'Тізім туралы толық ақпарат',
    委外详情: 'Сыртқа жалдау туралы толық ақпарат',
    生成领料单: 'Шикізат алу құжатын құру',
    退料单详情: 'Шикізатты қайтару құжаты туралы толық ақпарат',
    领料单详情: 'Шикізат алу құжаты туралы толық ақпарат',
    物料明细: 'Шикізат туралы толық ақпарат',
    实际库存: 'Нақты қор',
    申请数量: 'Өтініш саны',
    入库单: 'Қоймаға қабылдау құжаты',
    物料类型: 'Шикізат түрі',
    分析结果: 'Талдау нәтижесі',
    已生成采购计划: 'Сатып алу жоспары құрылды',
    未生成采购计划: 'Сатып алу жоспары құрылмады',
    所需用量: 'Қажетті қолданыс саны',
    净需求: 'Таза қажеттілік',
    待采购数量: 'Сатып алу күтілген саны',
    已采购入库数量: 'Сатып алынып қоймаға қабылданған саны',
    待申请物料数量: 'Шикізат өтініші күтілген саны',
    已领料出库数量: 'Шикізат алынып қоймадан шығарылған саны',
    已退料数量: 'Қайтарылған шикізат саны',
    待安排生产: 'Өндіріс жоспары күтілуде',
    已安排生产: 'Өндіріс жоспары жасалды',
    待安排委外: 'Сыртқа жалдау жоспары күтілуде',
    已生产数量: 'Өндірілген саны',
    '您确定要对当前数据生成采购计划？':
      'Ағымдағы деректер үшін сатып алу жоспарын құруды қалайсыз ба?',
    生产工单详情: 'Өндіріс тапсырмасы туралы толық ақпарат',
    '您确定要对当前数据预生成工序？':
      'Ағымдағы деректер үшін технологиялық процесті алдын ала құруды қалайсыз ба?',
    '您确定要对当前数据预生成入库单？':
      'Ағымдағы деректер үшін қоймаға қабылдау құжатын алдын ала құруды қалайсыз ба?',
    需求物料: 'Қажетті шикізат',
    生产计划详情: 'Өндіріс жоспары туралы толық ақпарат',
    '您确定要生成物料需求清单？':
      'Шикізат қажеттілік тізімін құруды қалайсыз ба?',
    生产概览: 'Өндіріс шолуы',
    生产工序详情: 'Өндіріс технологиялық процесі туралы толық ақпарат',
    报工单详情: 'Жұмыс есебі туралы толық ақпарат',
    工序号: 'Технологиялық процес нөмірі',
    完工数量: 'Аяқталған саны',
    请先选择工序执行人: 'Алдымен технологиялық процесті орындаушыны таңдаңыз',
    '您确定要开始当前工序？':
      'Ағымдағы технологиялық процесті бастауды қалайсыз ба?',
    分配执行人: 'Орындаушыны бөлу',
    委外生产: 'Сыртқа жалдау өндірісі',
    质检详情: 'Сапа тексеру туралы толық ақпарат',
    质检明细: 'Сапа тексеру туралы толық ақпарат',
    质检单号: 'Сапа тексеру нөмірі',
    质检类型: 'Сапа тексеру түрі',
    质检申请人: 'Сапа тексеру өтініш беруші',
    质检人: 'Сапа тексеруші',
    质检时间: 'Сапа тексеру уақыты',
    到货数量: 'Қабылданған саны',
    工序详情: 'Технологиялық процес туралы толық ақпарат',
    工艺详情: 'Технология туралы толық ақпарат',
    工艺明细: 'Технология туралы толық ақпарат',
    工序单位: 'Технологиялық процес бірлігі',
    工序负责人: 'Технологиялық процес жауаптысы',
    工序编码: 'Технологиялық процес коды',
    回款渠道: 'Қайтару арнасы',
    对账单详情: 'Есептестік құжаты туралы толық ақпарат',
    账期日期: 'Есептесу мерзімі күні',
    当前欠款: 'Ағымдағы қарыз',
    账单产品明细: 'Есеп-шот өнімдері туралы толық ақпарат',
    总计回款: 'Жалпы қайтару',
    当前订单金额: 'Ағымдағы тапсырыс сомасы',
    当前已付金额: 'Ағымдағы төленген сома',
    '您确定要对当前数据重新生成对账单吗？':
      'Ағымдағы деректер үшін есептестік құжатын қайта құруды қалайсыз ба?',
    客户生成账单: 'Тұтынушы үшін есеп-шот құру',
    供应商生成账单: 'Жеткізуші үшін есеп-шот құру',
    已付款: 'Төленді',
    未付款: 'Төленбеді',
    已开票: 'Есеп-шот шығарылды',
    未开票: 'Есеп-шот шығарылмады',
    客户数量: 'Тұтынушылар саны',
    客户渠道: 'Тұтынушы арнасы',
    订单渠道: 'Тапсырыс арнасы',
    产品及供应链统计: 'Өнім мен жеткізу тізбегі статистикасы',
    编辑产品: 'Өнімді өңдеу',
    新增供应链: 'Жаңа жеткізу тізбегі қосу',
    KP资料不详细: 'KP ақпараты толық емес',
    周新增数据: 'Апта сайынғы жаңа деректер',
    客户数据统计: 'Тұтынушы деректерінің статистикасы',
    产品数据统计: 'Өнім деректерінің статистикасы',
    更新产品: 'Өнімді жаңарту',
    KP供应链不足: 'KP жеткізу тізбегі жеткіліксіз',
    '请输入手机号/邮箱': 'Телефон нөмірін/электрондық поштаны енгізіңіз',
    关联单号: 'Байланысты нөмір',
    变更类型: 'Өзгеріс түрі',
    变更金额: 'Өзгеріс сомасы',
    变更前: 'Өзгерістен бұрын',
    变更后: 'Өзгерістен кейін',
    变更时间: 'Өзгеріс уақыты',
    导出模块: 'Экспорт модулі',
    导出名称: 'Экспорт атауы',
    请选择导出模块: 'Экспорт модулін таңдаңыз',
    仓储体积详情: 'Қойма көлемі туралы толық ақпарат',
    客户数: 'Тұтынушылар саны',
    订单数: 'Тапсырыстар саны',
    渠道详情: 'Арна туралы толық ақпарат',
    关联产品: 'Байланысты өнімдер',
    生成链接: 'Сілтеме құру',
    发布商品: 'Тауар жариялау',
    请输入关键词搜索分类: 'Кілт сөзді енгізіп санат іздеңіз',
    售价: 'Сату бағасы',
    '您确定要对当前产品更新到阿里巴巴？':
      'Ағымдағы өнімді Alibaba-ға жаңартуды қалайсыз ба?',
    '净品规格的默认箱规将作为品规在列表展示，外箱规格的默认箱规将作为箱规在列表展示':
      'Таза өнім спецификациясының әдепкі қаптама спецификациясы санат ретінде тізімде көрсетіледі, сыртқы қаптама спецификациясының әдепкі қаптама спецификациясы қаптама спецификациясы ретінде тізімде көрсетіледі',
    请输入箱规名称: 'Қаптама спецификациясы атауын енгізіңіз',
    请输入体积: 'Көлемді енгізіңіз',
    非默认箱规: 'Әдепкі емес қаптама спецификациясы',
    非费用箱规: 'Шығын емес қаптама спецификациясы',
    '体积/净重-毛重/长-宽-高':
      'Көлем/таза салмақ-жалпы салмақ/ұзындығы-ені-биіктігі',
    图文详情: 'Графикалық және мәтіндік туралы толық ақпарат',
    查看价格策略: 'Баға стратегиясын қарау',
    查看历史成交: 'Тарихи саудаларды қарау',
    渠道管理: 'Арна басқаруы',
    箱规管理: 'Қаптама спецификациясы басқаруы',
    应用渠道: 'Қолдану арнасы',
    图片使用: 'Сурет қолдану',
    覆盖: 'Қаплау',
    追加: 'Қосу',
    继续: 'Жалғастыру',
    选择应用渠道: 'Қолдану арнасын таңдау',
    图册搜索: 'Суреттер жинағын іздеу',
    页: 'Бет',
    图册上传: 'Суреттер жинағын жүктеу',
    建议价格: 'Ұсынылған баға',
    天销量: 'Күн сайынғы сату көлемі',
    所属仓库: 'Тиесілі қойма',
    渠道数量: 'Арна саны',
    选择客户: 'Тұтынушыны таңдау',
    选择模板: 'Үлгіні таңдау',
    若选择客户则会导出该客户关联模版信息:
      'Егер тұтынушы таңдалса, оның байланысты үлгі ақпараты экспортталады',
    '为保证预览体验，当前仅展示最多':
      'Алдын ала қарау тәжірибесін қамтамасыз ету үшін, қазір тек ең көбі',
    '条数据，点击': 'дерек жолы көрсетіледі, басыңыз',
    即可下载完整Excel数据: 'толық Excel деректерін жүктеп алу үшін',
    店铺类型: 'Дүкен түрі',
    店铺名称: 'Дүкен атауы',
    '您确定要发布当前产品?': 'Ағымдағы өнімді жариялауды қалайсыз ба?',
    绑定产品: 'Байланыстырылған өнім',
    照片: 'Фото',
    关键字: 'Кілт сөз',
    网页: 'Веб-бет',
    页数: 'Бет саны',
    EXW币种: 'EXW валюта',
    FOB币种: 'FOB валюта',
    网站: 'Веб-сайт',
    双击可编辑: 'Екі рет басып өңдеуге болады',
    自动上传: 'Автоматты түрде жүктеу',
    '部分产品报价高于采购单价，是否确定要审核通过？':
      'Кейбір өнімдердің бағасы сатып алу бағасынан жоғары, тексеруді қабылдауды қалайсыз ба?',
    请选择供货商: 'Жеткізушіні таңдаңыз',
    请输入包件编码: 'Қаптама кодын енгізіңіз',
    请输入包件数量: 'Қаптама санын енгізіңіз',
    请输入物流单号: 'Жеткізу нөмірін енгізіңіз',
    厂商: 'Өндіруші',
    产品名: 'Өнім атауы',
    '规格/材质': 'Спецификация/материал',
    备货产品: 'Дайындалған өнім',
    付款情况: 'Төлем жағдайы',
    库存情况: 'Қор жағдайы',
    '您确定要对当前数据付款？操作后状态将会流转':
      'Ағымдағы деректер үшін төлем жасауды қалайсыз ба? Әрекеттен кейін күй өзгереді',
    '您确定要对当前数据所有包裹确认收货？':
      'Ағымдағы деректердің барлық қаптамаларын қабылдауды растайсыз ба?',
    '您确定要对当前数据发往香港仓？':
      'Ағымдағы деректерді Гонконг қоймасына жіберуді қалайсыз ба?',
    '确认所有包裹已上车？':
      'Барлық қаптамалар көлікке жүктелгенін растайсыз ба?',
    包件编码: 'Қаптама коды',
    包件数量: 'Қаптама саны',
    物流单号: 'Жеткізу нөмірі',
    包裹状态: 'Қаптама күйі',
    最近下单时间: 'Соңғы тапсырыс беру уақыты',
    包含数量: 'Қамтылған саны',
    请选择地址: 'Мекенжайды таңдаңыз',
    适用范围: 'Қолдану ауқымы',
    派送费用: 'Жеткізу шығындары',
    基础运价: 'Негізгі жеткізу бағасы',
    体积比: 'Көлем қатынасы',
    家庭地址费: 'Үй мекенжайы үшін шығын',
    '目的地若为家庭地址，则收取该费用':
      'Мақсат мекенжайы үй болса, бұл шығын алынады',
    偏远地区费: 'Алыс аймақтар үшін шығын',
    '目的地邮编若在Fedex偏远地区清单中，则收取该费用':
      'Мақсат пошта индексі Fedex алыс аймақтар тізімінде болса, бұл шығын алынады',
    特殊处理费: 'Арнайы өңдеу шығыны',
    产品实重: 'Өнімнің нақты салмағы',
    磅: 'фунт',
    包装: 'Қаптау',
    '满足以下任一条件，则收取该费用':
      'Келесі шарттардың кем дегенде біреуі орындалса, бұл шығын алынады',
    产品没有完全由外包装箱包装起来:
      'Өнім толығымен сыртқы қаптама қораптарымен қапталмаған',
    外包装由缠绕膜外包: 'Сыртқы қаптама орамалап қағазбен қапталған',
    未使用纸箱包装: 'Қағаз қораптарымен қапталмаған',
    包装箱外形不是方形的: 'Қаптама қораптарының пішіні шаршы емес',
    尺寸: 'Өлшем',
    最长边: 'Ең ұзын қабырғасы',
    英寸: 'дюйм',
    次长边: 'Екінші ұзын қабырғасы',
    '最短边）': 'ең қысқа қабырғасы)',
    英寸且: 'дюйм және',
    超标费: 'Стандарттан тыс шығын',
    '产生超标费后，基础运价按实际重量，体积重和':
      'Стандарттан тыс шығын пайда болғаннан кейін, негізгі жеткізу бағасы нақты салмақ, көлем салмақ және',
    磅三者中最大者计费: 'фунттың үшеуінің ең үлкені бойынша есептеледі',
    用Fedex: 'Fedex арқылы',
    Ground发货: 'жер жүзінде жеткізу',
    '最短边）大于': 'ең қысқа қабырғасы) үлкен',
    英寸且小于等于: 'дюймнен және тең немесе кіші',
    最长边大于: 'ең ұзын қабырғасы үлкен',
    Delivery发货: 'жеткізу',
    未授权发货费: 'Авторизацияланбаған жеткізу шығыны',
    计价重大于: 'Есептелетін салмақ үлкен',
    签收费: 'Қолтаңба шығыны',
    地址更正费: 'Мекенжай түзету шығыны',
    '由于地址不正确，Fedex会设法寻找正确的地址以完成送货':
      'Мекенжай дұрыс емес болғандықтан, Fedex жеткізуді аяқтау үшін дұрыс мекенжайды іздейді',
    '应发货方要求，更改送货地址':
      'Жеткізу талабы бойынша, жеткізу мекенжайын өзгерту',
    地址更改服务费: 'Мекенжай өзгерту қызметі шығыны',
    '应发货方要求，更改地址或者召回货物服务费':
      'Жеткізу талабы бойынша, мекенжайды өзгерту немесе тауарды қайтару қызметі шығыны',
    燃油附加费: 'Отын қосымша шығыны',
    '根据官方燃油附加费率，按百分比收取':
      'Ресми отын қосымша тарифіне сәйкес, пайызбен алынады',
    适用于超大或超重件运输:
      'Өте үлкен немесе ауыр жүктерді тасымалдау үшін қолданылады',
    '每次发货前，可免费询价':
      'Әрбір жеткізуден бұрын, тегін баға сұрауға болады',
    体积重: 'Көлем салмағы',
    '高/体积比': 'биіктігі/көлем қатынасы',
    计价重量为体积重和实际重量中数值较大者:
      'Есептелетін салмақ көлем салмағы мен нақты салмақтың үлкені болып табылады',
    '特殊处理费，超标费及未授权发货费三项，不重复收费，只收取最贵的一项':
      'Арнайы өңдеу шығыны, стандарттан тыс шығын және авторизацияланбаған жеткізу шығыны үшеуі үшін қайталау алынбайды, тек ең қымбаты алынады',
    '所有尺寸，重量均按英制计算':
      'Барлық өлшемдер мен салмақтар британдық жүйе бойынша есептеледі',
    千克: 'килограмм',
    '所有尺寸，重量均向上取整':
      'Барлық өлшемдер мен салмақтар жоғары қарай дөңгелектеледі',
    所有货币单位均为美元: 'Барлық ақша бірліктері доллар болып табылады',
    '如Fedex价格变动，报价将进行相应变动，我司将另行通知':
      'Егер Fedex бағалары өзгерсе, баға ұсыныстар да сәйкесінше өзгереді, біздің компания бұл туралы басқаша хабарлайды',
    '此报价不含旺季附加费，旺季附加费按官网价收取':
      'Бұл баға ұсынысы маусымдық қосымша шығындарды қамтымайды, маусымдық қосымша шығындар ресми веб-сайт бағалары бойынша алынады',
    旺季附加费收费时间段以Fedex官网收费时间段为准:
      'Маусымдық қосымша шығындардың төлену уақыты Fedex ресми веб-сайт төлем уақытына сәйкес келеді',
    收费重量尺寸以Fedex实际账单为准:
      'Төленетін салмақ пен өлшем Fedex нақты есеп-шотына сәйкес келеді',
    计价重量计算方式: 'Есептелетін салмақты есептеу әдісі',
    见拣货费价格: 'Таңдау шығыны бағасын қараңыз',
    今日计划详情: 'Бүгінгі жоспар туралы толық ақпарат',
    快递详情: 'Жедел хат туралы толық ақпарат',
    物流信息: 'Жеткізу ақпараты',
    查看运费: 'Жеткізу шығындарын қарау',
    快递服务商: 'Жедел хат қызмет көрсетуші',
    个工作日: 'жұмыс күні',
    含: 'қамтиды',
    免费追踪: 'Тегін бақылау',
    选择快递: 'Жедел хатты таңдау',
    请完善包裹信息: 'Қаптама ақпаратын толтырыңыз',
    '您确定选择当前快递服务商并支付费用?':
      'Ағымдағы жедел хат қызмет көрсетушіні таңдап, шығындарды төлеуді қалайсыз ба?',
    运费预估: 'Жеткізу шығындарын алдын ала бағалау',
    关联发货计划: 'Байланысты жеткізу жоспары',
    物品体积: 'Зат көлемі',
    物品总重量: 'Заттардың жалпы салмағы',
    您确定要对当前数据进行寄件: 'Ағымдағы деректер үшін жіберуді қалайсыз ба',
    您确定要对当前数据进行取消寄件:
      'Ағымдағы деректер үшін жіберуден бас тартуды қалайсыз ба',
    选择面单: 'Жүзбен қол қою парағын таңдау',
    选择打印机: 'Принтерді таңдау',
    费用预估为: 'Шығындардың алдын ала бағасы',
    费用预估: 'Шығындарды алдын ала бағалау',
    '您确定要对当前产品发往香港仓？':
      'Ағымдағы өнімді Гонконг қоймасына жіберуді қалайсыз ба?',
    发货单详情: 'Жеткізу құжаты туралы толық ақпарат',
    文本记录: 'Мәтіндік жазба',
    '规格/尺寸': 'Спецификация/өлшем',
    发货仓: 'Жеткізу қоймасы',
    包件备注: 'Қаптама ескертуі',
    行程安排: 'Саяхат жоспары',
    送货员: 'Жеткізуші',
    '确认取消包裹派送？': 'Қаптама жеткізуден бас тартуды растайсыз ба?',
    '确认包裹客户已接收？': 'Қаптаманы тұтынушы қабылдағанын растайсыз ба?',
    '确认包裹要回仓？': 'Қаптаманы қоймаға қайтару керектігін растайсыз ба?',
    未安排: 'Жоспарланбаған',
    库存状况: 'Қор жағдайы',
    采购情况: 'Сатып алу жағдайы',
    确认收货: 'Қабылдауды растау',
    发往香港仓: 'Гонконг қоймасына жіберу',
    确认上车: 'Көлікке жүктелгенін растау',
    您确定对所选数据进行全部: 'Таңдалған деректерге толық',
    '操作吗？': 'әрекет жасауды қалайсыз ба?',
    采购中: 'Сатып алу барысында',
    已售待送: 'Сатылды, жеткізу күтілуде',
    收货单详情: 'Қабылдау құжаты туралы толық ақпарат',
    '您确定要签收入库？': 'Қоймаға қабылдауды растауды қалайсыз ба?',
    供货商: 'Жеткізуші',
    到达时间: 'Келу уақыты',
    出入库单号: 'Қоймаға кіру/шығу құжаты нөмірі',
    仓位: 'Қойма орны',
    '总体积(m³)': 'Жалпы көлем(м³)',
    添加行: 'Жол қосу',
    添加列: 'Баған қосу',
    拆分为表格: 'Кестеге бөлу',
    当前共有: 'Қазіргі уақытта барлығы',
    '条数据，请输入要拆分的行数':
      'дерек жолы бар, бөлінетін жол санын енгізіңіз',
    拆分的行数: 'Бөлінетін жол саны',
    请输入要拆分的行数: 'Бөлінетін жол санын енгізіңіз',
    商品快递索赔详情: 'Тауар жедел хат шағымы туралы толық ақпарат',
    请选择商品代发单: 'Тауарларды жеткізу тапсырысын таңдаңыз',
    商品退货详情: 'Тауарларды қайтару туралы толық ақпарат',
    商品代发详情: 'Тауарларды жеткізу туралы толық ақпарат',
    '您确定要通知仓库发货？': 'Қойманы жеткізуге шақыруды қалайсыз ба?',
    请完善产品仓库信息: 'Өнім қойма ақпаратын толтырыңыз',
    入库预报详情: 'Қоймаға қабылдау болжамы туралы толық ақпарат',
    '您确定要发货？': 'Жеткізуді қалайсыз ба?',
    索赔原因: 'Шағым себебі',
    '您确定要对当前数据进行退货处理?':
      'Ағымдағы деректер үшін қайтару өңдеуін жасауды қалайсыз ба?',
    发货模版: 'Жеткізу үлгісі',
    智能识别: 'Ақылды тану',
    您确定要对当前订单进行作废:
      'Ағымдағы тапсырысты жарамсыз етуді қалайсыз ба',
    '部分产品报价低于最低售价确定要审核通过？':
      'Кейбір өнімдердің бағасы ең төменгі сату бағасынан төмен, тексеруді қабылдауды қалайсыз ба?',
    预设报价: 'Алдын ала орнатылған баға',
    是否发货: 'Жеткізу керек пе',
    '您确定要取消当前订单寄件？':
      'Ағымдағы тапсырыс жіберуінен бас тартуды қалайсыз ба?',
    '您确定要清除当前订单的关联信息？清除后可以重新添加产品':
      'Ағымдағы тапсырыстың байланысты ақпаратын жоюды қалайсыз ба? Жойғаннан кейін өнімдерді қайта қосуға болады',
    VIP类型: 'VIP түрі',
    商店域名: 'Дүкен домені',
    请输入商店域名: 'Дүкен доменін енгізіңіз',
    请选择VIP类型: 'VIP түрін таңдаңыз',
    选项值: 'Опция мәні',
    面单标题: 'Жүзбен қол қою парағы тақырыбы',
    网点: 'Тармақ нүктесі',
    快递员: 'Жедел хат жүргізуші',
    面单编码: 'Жүзбен қол қою парағы коды',
    面单模版: 'Жүзбен қол қою парағы үлгісі',
    绑定打印机: 'Принтерге байланыстыру',
    秘钥: 'Құпия кілт',
    校验码: 'Тексеру коды',
    打印机类型: 'Принтер түрі',
    在线状态: 'Желідегі күй',
    模版图: 'Үлгі суреті',
    模版标题: 'Үлгі тақырыбы',
    '打印纸尺寸(mm)': 'Басып шығару қағазы өлшемі(мм)',
    快递面单模版: 'Жедел хат жүзбен қол қою парағы үлгісі',
    排序字段: 'Сұрыптау өрісі',
    '您确定要对当前数据进行同步翻译？':
      'Ағымдағы деректерді синхронды түрде аударуды қалайсыз ба?',
    请输入code编码: 'code кодын енгізіңіз',
    请输入汇率: 'Валюта бағамын енгізіңіз',
    销售单号规则: 'Сату құжаты нөмірі ережесі',
    采购单号规则: 'Сатып алу құжаты нөмірі ережесі',
    使用币种: 'Қолданылатын валюта',
    默认汇率: 'Әдепкі валюта бағамы',
    开启供应商仓储报表: 'Жеткізуші қойма есептемесін қосу',
    默认币种: 'Әдепкі валюта',
    费用征收比例: 'Шығындарды салық алу қатынасы',
    请输入merchant: 'merchant енгізіңіз',
    秘钥Key: 'Құпия кілт Key',
    请输入秘钥Key: 'Құпия кілт Key енгізіңіз',
    不允许使用特殊符号: 'Арнайы белгілерді қолдануға болмайды',
    公钥Key: 'Қоғамдық кілт Key',
    请输入公钥Key: 'Қоғамдық кілт Key енгізіңіз',
    字段控制: 'Өріс басқаруы',
    stripe支付配置: 'stripe төлем конфигурациясы',
    乐刷支付配置: '乐刷 төлем конфигурациясы',
    使用次数: 'Қолдану саны',
    已授权: 'Авторизацияланған',
    未授权: 'Авторизацияланбаған',
    扫码授权: 'QR код арқылы авторизациялау',
    授权状态: 'Авторизация күйі',
    token过期时间: 'token мерзімі аяқталу уақыты',
    昨日销量: 'Кешегі сату көлемі',
    店铺扫码授权: 'Дүкен QR код арқылы авторизациялау',
    三方渠道: 'Үшінші тарап арнасы',
    '您确定生成全部任务？': 'Барлық тапсырмаларды құруды қалайсыз ба?',
    // TODO: 2025-08-18
    选择日期时间: 'Күн мен уақытты таңдау',
    分阶段付款: 'Кезеңдік төлем',
    请输入或选择颜色: 'Түсті енгізіңіз немесе таңдаңыз',
    已选: 'Таңдалды',
    '现货发货获取流量扶持，一档时效越短数量越多，流量扶持越多；买家下单数量超出一档或商品仅勾选定制视为定制交易':
      'Дайын өнімді жеткізу арқылы трафик қолдауын алу, бірінші кезең уақыты қысқа болған сайын саны көп болады, трафик қолдауы да көбірек болады; тұтынушы тапсырыс берген саны бірінші кезеңнен асып кетсе немесе тауар тек тапсырысқа арналған болса, тапсырысқа арналған сауда ретінде қарастырылады',
    库存上限: 'Қордың жоғарғы шегі',
    '预览（可根据买家购买的不同数量设置不同的发货时间）':
      'Алдын ала қарау (тұтынушы сатып алған әртүрлі сандарға сәйкес әртүрлі жеткізу уақытын орнатуға болады)',
    以上: 'жоғарыда',
    承诺: 'Ұсыныс',
    属性已存在: 'Сипат бар',
    图片选择: 'Суретті таңдау',
    管理相册: 'Альбомдарды басқару',
    要插入的图片: 'Кірістірілетін сурет',
    使用选中图片: 'Таңдалған суретті қолдану',
    请选择相册: 'Альбомды таңдаңыз',
    图片选择超出最大数量: 'Суреттерді таңдау ең көбінен асып кетті',
    规格图片: 'Спецификация суреті',
    '体积(cm³)': 'Көлем(см³)',
    '重量(g)': 'Салмақ(г)',
    按规格设置: 'Спецификация бойынша орнату',
    按商品设置: 'Тауар бойынша орнату',
    白色系: 'Ақ түс тобы',
    乳白色: 'Сүтті ақ',
    米白色: 'Бидай түсті ақ',
    象牙白: 'Піл сүйегі түсті ақ',
    灰色系: 'Сұр түс тобы',
    灰色: 'Сұр',
    浅灰色: 'Ашық сұр',
    深灰色: 'Қараңғы сұр',
    银色: 'Күміс',
    铅色: 'Қорғасын түсті',
    奶奶灰: 'Қарт шеше сұр',
    石板灰: 'Тақта сұр',
    深空灰: 'Қараңғы ғарыш сұр',
    石墨色: 'Графит түсті',
    银灰色: 'Күміс сұр',
    黑色系: 'Қара түс тобы',
    红色系: 'Қызыл түс тобы',
    桔红色: 'Қызғылт сары',
    粉红色: 'Қызғылт',
    玫红色: 'Қызғылт күлгін',
    藕色: 'Қызғылт сары-ақ',
    西瓜红: 'Қызғылт қызыл',
    酒红色: 'Қызыл сары',
    桃色: 'Шабдалы түсті',
    深红色: 'Қою қызыл',
    砖红色: 'Кірпіш қызыл',
    橙红色: 'Қызғылт қызыл',
    珊瑚色: 'Коралл түсті',
    洋红色: 'Қызғылт күлгін',
    亮粉: 'Ашық қызғылт',
    胭脂色: 'Қызыл сары',
    深粉红: 'Қою қызғылт',
    蔷薇色: 'Гүл түсті',
    猩红色: 'Қызыл',
    黄色系: 'Сары түс тобы',
    黄色: 'Сары',
    浅黄色: 'Ашық сары',
    柠檬黄: 'Лимон сары',
    桔色: 'Қызғылт сары',
    明黄色: 'Ашық сары',
    金色: 'Алтын',
    荧光黄: 'Флуоресцентті сары',
    姜黄色: 'Қызғылт сары',
    香槟色: 'Шампан түсті',
    杏色: 'Шабдалы түсті',
    卡其色: 'Хаки түсті',
    土黄色: 'Топырақ сары',
    橙色: 'Қызғылт',
    肤色: 'Тері түсті',
    小麦色: 'Бидай түсті',
    向日葵色: 'Күнбағыс түсті',
    绿色系: 'Жасыл түс тобы',
    绿色: 'Жасыл',
    浅绿色: 'Ашық жасыл',
    墨绿色: 'Қою жасыл',
    军绿色: 'Әскери жасыл',
    翠绿色: 'Жеміс жасыл',
    荧光绿: 'Флуоресцентті жасыл',
    青色: 'Көкшіл жасыл',
    草绿色: 'Шөл жасыл',
    黄绿色: 'Сарғыш жасыл',
    碧绿: 'Көкшіл жасыл',
    绿宝石: 'Изумруд түсті',
    海洋绿: 'Теңіз жасыл',
    橄榄色: 'Зәйтүнді түсті',
    橄榄绿: 'Зәйтүнді жасыл',
    抹茶色: 'Матча түсті',
    孔雀绿: 'Тауық жасыл',
    蓝色系: 'Көк түс тобы',
    蓝色: 'Көк',
    天蓝色: 'Аспан көк',
    孔雀蓝: 'Тауық көк',
    宝蓝色: 'Сапфир көк',
    深蓝色: 'Қою көк',
    湖蓝色: 'Көл көк',
    浅蓝色: 'Ашық көк',
    藏青色: 'Қараңғы көк',
    海蓝色: 'Теңіз көк',
    蔚蓝色: 'Көк',
    紫色系: 'Қызғылт күлгін түсті',
    紫色: 'Қызғылт күлгін',
    浅紫色: 'Ашық қызғылт күлгін',
    深紫色: 'Қара қызғылт күлгін',
    紫红色: 'Қызғылт-күлгін',
    紫罗兰: 'Қызғылт күлгін',
    暗紫罗兰: 'Қара қызғылт күлгін',
    深洋红色: 'Қара қызыл',
    紫兰色: 'Қызғылт күлгін',
    薰衣草紫: 'Лаванда түсі',
    棕色系: 'Қоңыр түсті',
    咖啡色: 'Қоңыр',
    深棕色: 'Қара қоңыр',
    浅棕色: 'Ашық қоңыр',
    栗色: 'Каштан түсі',
    深卡其布色: 'Қара хаки',
    巧克力色: 'Шоколад түсі',
    褐色: 'Қоңыр',
    驼色: 'Түйе түсі',
    焦糖色: 'Карамель түсі',
    古铜色: 'Қола түсі',
    红褐色: 'Қызыл-қоңыр',
    琥珀色: 'Кәді түсі',
    玫瑰金: 'Қызғылт алтын',
    透明系: 'Мөлдір түсті',
    透明: 'Мөлдір',
    '7天包换Tips':
      'Сатушы сатып алушы қамтамасыз ету қызметіне міндеттеме беру негізінде, сатып алушыға "7 күн ішінде ауыстыру" қызметін қамтамасыз етуді еркін таңдайды. Сатып алушы онлайн түрде "7 күн ішінде ауыстыру" қызметін қолдайтын тауарды тапсырыс бергеннен кейін, сатушы тауарды қабылдағаннан кейін 7 күн ішінде адамзаттық зақым жоқ тауарларды ауыстыру қызметін қамтамасыз етеді. Егер сатушы жоғарыда айтылған міндеттемені орындамаса, сатып алушы белгіленген мерзім ішінде құқықтарын қорғауға арналған шағым талап етуге және өтемақы талап етуге болады.',
    '7天无理由退Tips':
      'Сатушы сатып алушы тауарды қабылдағаннан кейін 7 күн ішінде, "тауар жағдайы жақсы" жағдайында, сатып алушыға қайтару қызметін қамтамасыз етеді.',
    材质保障Tips:
      'Сатушы сатып алушы қамтамасыз ету қызметіне міндеттеме беру негізінде, сатып алушыға қамтамасыз ету қызметін еркін таңдайды. Сатушы осы тауар сатып алушымен алдын ала келіскен материал талаптарына сай келетінін қамтамасыз етеді, әйтпесе тауар ақының 20%-ына (бірақ ең көбі 10000 юан) сатып алушыға өтемақы төлейді.',
    破损包赔Tips:
      'Сатушы сатып алушы қамтамасыз ету қызметіне міндеттеме беру негізінде, сатып алушыға "зиян көрсе өтемақы" қызметін еркін ұсынады. Сатып алушы онлайн түрде сатушының өнімін тапсырыс бергеннен кейін, егер өнімде зақым болса, сатушы қамтамасыз ету мерзімі ішінде сатып алушыға бір рет тегін қосымша жібереді, егер қосымша жіберілгеннен кейін сатып алушы әлі де жақсы өнім ала алмаса, сатушы зақым көрген өнімнің қайтару-ақы төлеу қызметін қамтамасыз етуі тиіс.',
    少货必赔Tips:
      'Егер сатушы белгіленген мерзім ішінде қатысты дәлел материалдарын ұсына алмаса немесе ұсынылған дәлел материалдары айқын жарамсыз болса, Alibaba сатып алушының өтемақы талабын қабылдайды, сатушы осы келісім бойынша сатып алушыға оның көрсеткен зиянын өтемақы төлеуге келіседі, өтемақы сомасы сатып алушы нақты төлеген жетіспейтін өнімнің бағасы (тек қана қосалқы бөлшектер жетіспесе де бүкіл жиынтық өнімнің бағасы үшін өтемақы төлеу керек). Осындай жағдайда Alibaba сатушының кепілдік ақшасын пайдалануға немесе Alipay компаниясына сатушының Alipay шотынан тиісті соманы тікелей алып сатып алушыға алдын ала өтемақы төлеуге құқылы.',
    坏单包赔Tips:
      'Alibaba сатып алушының өтемақы талабын қабылдайды, сатушы осы келісім бойынша сатып алушыға оның көрсеткен зиянын өтемақы төлеуге келіседі, өтемақы сомасы сатып алушы талап еткен жаман тапсырыс санының өнім бағасы. Осындай жағдайда Alibaba сатушының кепілдік ақшасын пайдалануға немесе Alipay компаниясына сатушының Alipay шотынан тиісті соманы тікелей алып сатып алушыға алдын ала өтемақы төлеуге құқылы.',
    官方直送Tips: `"Сатушы "ресми тікелей жеткізу" қамтамасыз ету қызметін қосқаннан кейін, сатып алушыға "ресми тікелей жеткізу" қамтамасыз ету қызметін қамтамасыз етеді. Тауар келесі шарттарды қанағаттандыруы тиіс, ол тауар "ресми тікелей жеткізу" қамтамасыз ету белгісін шығарады: 
                (1) Сіз тауарда "ресми тікелей жеткізу" қамтамасыз ету қызметін белгілегенсіз;
                (2) Осы тауар "жеткізу ақы бағыттауыш үлгісін" қолданады;
                (3) Сатушының осы тауары бойынша соңғы 30 күндік транзакциялар "ресми тікелей жеткізу" қызметін қолдану үлесі 90% және одан жоғары (соңғы 30 күндік транзакциялар 10 және одан жоғары).
                Егер сатушы осы тауар үшін "жеткізу ақы бағыттауыш үлгісін" қолданбаған немесе соңғы 30 күндік транзакциялар "ресми тікелей жеткізу" қызметін қолдану үлесі 90% және одан жоғары (соңғы 30 күндік транзакциялар 10 және одан жоғары) міндеттемесін орындамаса, осы тауар жойылады."`,
    天包换: 'күн ауыстыру',
    天包换Tips: 'күн ауыстыру кеңестері',
    天无理由退: 'күн себепсіз қайтару',
    天无理由退Tips: 'күн себепсіз қайтару кеңестері',
    材质保障: 'Материал қамтамасыз ету',
    破损包赔: 'Зақым көрсе өтемақы',
    少货必赔: 'Жетіспесе міндетті түрде өтемақы',
    坏单包赔: 'Жаман тапсырыс өтемақы',
    官方直送: 'Ресми тікелей жеткізу',
    常用类目: 'Жиі қолданылатын санаттар',
    您选择的类目: 'Сіз таңдаған санат',
    主要下游平台: 'Негізгі төменгі ағын платформалары',
    速卖通: 'AliExpress',
    亚马逊: 'Amazon',
    独立站: 'Тәуелсіз сайт',
    主要销售地区: 'Негізгі сату аймақтары',
    欧洲: 'Еуропа',
    北美: 'Солтүстік Америка',
    南美: 'Оңтүстік Америка',
    东南亚: 'Шығыс Азия',
    东北亚: 'Солтүстік-Шығыс Азия',
    中东: 'Орта Шығыс',
    非洲: 'Африка',
    请至少选择一项: 'Кем дегенде бір нәрсені таңдаңыз',
    '您已开通买保服务，当前保证金金额为':
      'Сіз сатып алу қамтамасыз ету қызметін қосып қойдыңыз, ағымдағы кепілдік ақшасы сомасы',
    保障服务首页: 'Қамтамасыз ету қызметінің басты беті',
    申请开通: 'Қосуға өтініш беру',
    不支持: 'Қолдамайды',
    值: 'Мәні',
    自产产品: 'Өз өндіріс өнімдері',
    KP产品: 'KP өнімдері',
    有产品凭证: 'Өнім куәлігі бар',
    首次采购: 'Бірінші сатып алу',
    '次采购,之前共采购': 'рет сатып алу, барлығы сатып алынды',
    '产品数量低于最低起售数量不可提交,请调整!':
      'Өнім саны ең төменгі сату санынан аз болса, жіберуге болмайды, реттеңіз!',
    产品数量低于最低起售数量: 'Өнім саны ең төменгі сату санынан аз',
    产品报价低于最低售价: 'Өнім баға ұсынысы ең төменгі сату бағасынан төмен',
    产品报价高于最低采购价:
      'Өнім баға ұсынысы ең төменгі сатып алу бағасынан жоғары',
    三方仓库名: 'Үшінші тарап қойма атауы',
    冻结数量: 'Блокталған саны',
    订单日期: 'Тапсырыс күні',
    流程名称: 'Процесс атауы',
    货架: 'Стеллаж',
    更新: 'Жаңарту',
    暂无: 'Әзірге жоқ',
    deliveryPlanNumTips: 'Жалпы саны - Жеткізу саны = Күтілген саны (бірлік)',
    stockNumTips: 'Қор - Блокталған қор = Қолжетімді қор (бірлік)',
    totalStockNumTips:
      'Қор (жалпы қор - блокталған қор = қолжетімді қор) (бірлік)',
    冻结库存: 'Блокталған қор',
    '添加中...': 'Қосылуда...',
    调价: 'Баға өзгерту',
    不调价: 'Баға өзгертпеу',
    上次采购价: 'Соңғы сатып алу бағасы',
    产品价格和数量一样: 'Өнім бағасы мен саны бірдей',
    请选择船号: 'Кеме нөмірін таңдаңыз',
    请选择集装箱号: 'Контейнер нөмірін таңдаңыз',
    '调出仓库(库存)': 'Шығару қоймасы (қор)',
    '调入仓库(库存)': 'Қабылдау қоймасы (қор)',
    自项目实际完结日起: 'Жоба нақты аяқталған күннен бастап',
    当前产品的个仓位数量信息: 'Ағымдағы өнімнің жеке орын саны туралы ақпарат',
    当前产品的冻结库存信息: 'Ағымдағы өнімнің блокталған қоры туралы ақпарат',
    在途库存: 'Жолдағы қор',
    默认仓位: 'Әдепкі орын',
    已生成: 'Құрылды',
    未生成: 'Құрылмады',
    备货图: 'Дайындау суреті',
    船号: 'Кеме нөмірі',
    集装箱号: 'Контейнер нөмірі',
    '您当前数量低于最小起订量，请修改！':
      'Сіздің ағымдағы саныңыз ең аз тапсырыс санынан аз, өтінемін өзгертіңіз!',
    导入数据: 'Деректерді импорттау',
    下载模板: 'Үлгіні жүктеу',
    请配置模块名称: 'Модуль атауын конфигурациялаңыз',
    聚合搜索: 'Біріктірілген іздеу',
    产品标题: 'Өнім тақырыбы',
    全部产品: 'Барлық өнімдер',
    按产品数量: 'Өнім саны бойынша',
    按产品种类: 'Өнім түрі бойынша',
    项目: 'Жоба',
    出入库单: 'Қоймаға кіру/шығу құжаты',
    项目服务商: 'Жоба қызмет көрсетушісі',
    模具: 'Қалып',
    我创建的: 'Мен құрған',
    我负责的: 'Мен жауаптымын',
    我参与的: 'Мен қатысқан',
    元旦节: 'Жаңа жыл мерекесі',
    情人节: 'Қызғанар мерекесі',
    劳动节: 'Еңбек мерекесі',
    青年节: 'Жастар мерекесі',
    儿童节: 'Балалар мерекесі',
    教师节: 'Ұстаздар мерекесі',
    国庆节: 'Ұлттық мереке',
    圣诞节: 'Рождество мерекесі',
    妇女节: 'Әйелдер мерекесі',
    植树节: 'Ағаш отырғызу мерекесі',
    愚人节: 'Апрельдің бірі мерекесі',
    护士节: 'Қызметкерлер мерекесі',
    建党节: 'Партия құрылған мереке',
    建军节: 'Әскер құрылған мереке',
    平安夜: 'Күннің түнгі тыныштығы',
    除夕: 'Жыл соңы',
    春节: 'Қысқы демалыс',
    元宵节: 'Шамдар мерекесі',
    龙抬头: 'Айдаһар басы көтерілген күні',
    端午节: 'Қайық мерекесі',
    七夕节: 'Қызғанарлар мерекесі',
    中元节: 'Рухтар мерекесі',
    中秋节: 'Күз ортасы мерекесі',
    重阳节: 'Қарттар мерекесі',
    寒衣节: 'Қысқы киім мерекесі',
    下元节: 'Төменгі ай мерекесі',
    腊八节: 'Қаңтардың сегізінші күні',
    北方小年: 'Солтүстік кіші жыл',
    南方小年: 'Оңтүстік кіші жыл',
    打印失败: 'Басып шығару сәтсіз',
    今日: 'Бүгін',
    昨日: 'Кеше',
    本周: 'Осы апта',
    上周: 'Өткен апта',
    本月: 'Осы ай',
    上月: 'Өткен ай',
    最近三个月: 'Соңғы үш ай',
    最近半年: 'Соңғы жарты жыл',
    用时: 'Уақытты қолдану',
    天: 'күн',
    逾期: 'Кешігу',
    剩余: 'Қалдық',
    已完结: 'Аяқталды',
    公式必须是字符串类型: 'Формула жол түрінде болуы керек',
    变量必须是对象类型: 'Айнымалы объект түрінде болуы керек',
    无效的变量名: 'Жарамсыз айнымалы атауы',
    公式包含不允许的字符: 'Формулада рұқсат етілмеген таңбалар бар',
    计算结果不是有效数字: 'Есептеу нәтижесі жарамды сан емес',
    计算失败: 'Есептеу сәтсіз',
    零售适配: 'Жеке саудаға сәйкес келу',
    相册: 'Альбом',
    生日: 'Туған күн',
    宗教: 'Дін',
    账单地址: 'Есеп-шот мекенжайы',
    订单来源: 'Тапсырыс қайнар көзі',
    审核备注: 'Тексеру ескертуі',
    复核状态: 'Қайта тексеру күйі',
    复核人: 'Қайта тексеруші',
    复核备注: 'Қайта тексеру ескертуі',
    备货进度: 'Дайындау барысы',
    发货单据: 'Жеткізу құжаттары',
    请选择州: 'Штатты таңдаңыз',
    计划金额: 'Жоспарланған сома',
    回款状态: 'Қайтару күйі',
    次品数: 'Бұйым саны',
    不合格数量: 'Сапасыз саны',
    次品数量: 'Бұйым саны',
    模具名称: 'Қалып атауы',
    模具编码: 'Қалып коды',
    模具类型: 'Қалып түрі',
    开发方: 'Әзірлеуші',
    维护方: 'Қызмет көрсетуші',
    加工方: 'Өңдеуші',
    耗材: 'Жұмсалатын материалдар',
    当前位置: 'Ағымдағы орын',
    模具成本: 'Қалып құны',
    成本描述: 'Құн сипаттамасы',
    产权描述: 'Меншік сипаттамасы',
    模具图集: 'Қалып суреттер жинағы',
    模具描述: 'Қалып сипаттамасы',
    研发成本: 'Зерттеу және әзірлеу құны',
    生产成本: 'Өндіріс құны',
    预计售价: 'Болжалды сату бағасы',
    回本数量: 'Қайтару саны',
    样品状态: 'Үлгі күйі',
    启动时间: 'Бастау уақыты',
    预计完结: 'Болжалды аяқталу',
    实际完结: 'Нақты аяқталу',
    项目描述: 'Жоба сипаттамасы',
    项目成本: 'Жоба құны',
    产品成本: 'Өнім құны',
    项目复盘: 'Жоба қайта қарау',
    关联模块: 'Байланысты модуль',
    关联数据: 'Байланысты деректер',
    任务描述: 'Тапсырма сипаттамасы',
    完成图集: 'Аяқталған суреттер жинағы',
    完成视频: 'Аяқталған видео',
    完成反馈: 'Аяқталған кері байланыс',
    配送员: 'Жеткізуші',
    配送仓库: 'Жеткізу қоймасы',
    配送状态: 'Жеткізу күйі',
    批量审核: 'Жаппай тексеру',
    零售价格: 'Жеке сауда бағасы',
    批发价: 'Шағым бағасы',
    基础信息: 'Негізгі ақпарат',
    请选择标签: 'Белгіні таңдаңыз',
    销售信息: 'Сату ақпараты',
    仓储信息: 'Қойма ақпараты',
    分类信息: 'Санат ақпараты',
    图片与视频: 'Суреттер мен видео',
    包装与箱规: 'Қаптау және қаптама спецификациясы',
    描述与详情: 'Сипаттама мен егжей-тегжей',
    拓展信息: 'Кеңейтілген ақпарат',
    '数据未保存是否保存数据？':
      'Деректер сақталмады, деректерді сақтау керек пе?',
    不保存: 'Сақтамау',
    按SKU: 'SKU бойынша',
    按产品分类: 'Өнім санаты бойынша',
    所有: 'Барлығы',
    同步得物价格: '得物 бағасын синхрондау',
    请输入具体的SKU: 'Нақты SKU енгізіңіз',
    同步: 'Синхрондау',
    同步得物商品: '得物 тауарларын синхрондау',
    尺寸单位: 'Өлшем бірлігі',
    请选择尺寸单位: 'Өлшем бірлігін таңдаңыз',
    重量单位: 'Салмақ бірлігі',
    请选择重量单位: 'Салмақ бірлігін таңдаңыз',
    商品ID: 'Тауар ID',
    请输入Shopify商品页面链接中products后面跟的纯数字ID:
      'Shopify тауар бетінің сілтемесінде products кейін келетін таза санды ID енгізіңіз',
    请选择订单来源: 'Тапсырыс қайнар көзін таңдаңыз',
    '您的报价产品中有低于最低售价或最小起订量的产品，请检查！':
      'Сіздің баға ұсыныс өнімдеріңізде ең төменгі сату бағасынан төмен немесе ең аз тапсырыс санынан аз өнімдер бар, тексеріңіз!',
    请选择来源: 'Қайнар көзді таңдаңыз',
    请选择日期: 'Күнді таңдаңыз',
    请输入宗教: 'Дінді енгізіңіз',
    客户标签: 'Тұтынушы белгісі',
    供应商标签: 'Жеткізуші белгісі',
    运费测算: 'Жеткізу ақысын есептеу',
    请输入处理方式: 'Өңдеу тәсілін енгізіңіз',
    添加回款明细: 'Қайтару туралы толық ақпарат қосу',
    其他费用: 'Басқа шығындар',
    费用减免: 'Шығындардан босату',
    额外费用: 'Қосымша шығындар',
    费用说明: 'Шығындар сипаттамасы',
    职责: 'Міндеттер',
    直接输入并选择: 'Тікелей енгізіп таңдаңыз',
    批量生成入库预报: 'Жаппай қоймаға қабылдау болжамын құру',
    各产品数量: 'Әрбір өнім саны',
    请填写数量: 'Санды толтырыңыз',
    平台单号: 'Платформа нөмірі',
    请输入平台单号: 'Платформа нөмірін енгізіңіз',
    '仓库代退-商品退货单': 'Қойма арқылы қайтару-тауарларды қайтару құжаты',
    添加快递单号: 'Жедел хат нөмірін қосу',
    码头: 'Пирс',
    请选择码头: 'Пирсті таңдаңыз',
    三方仓产品调拨: 'Үшінші тарап қоймасынан өнімдерді қайта бөлу',
    关联网页: 'Байланысты веб-бет',
    字段取值: 'Өріс мәнін алу',
    请输入取值字段: 'Мән алу өрісін енгізіңіз',
    部件属性: 'Бөлшек сипаттары',
    '部件属性在设置》扩展字段》产品中添加':
      'Бөлшек сипаттарын параметрлер》кеңейтілген өрістер》өнімдерде қосу',
    请选择部件包含的属性: 'Бөлшек қамтитын сипаттарды таңдаңыз',
    密钥: 'Құпия кілт',
    请输入密钥: 'Құпия кілтті енгізіңіз',
    父级仓库: 'Жоғарғы деңгейлі қойма',
    打印图片: 'Суретті басып шығару',
    模块名称: 'Модуль атауы',
    请输入模块名称: 'Модуль атауын енгізіңіз',
    显示移动端: 'Ұялы телефонда көрсету',
    凭证文件: 'Куәлік файлы',
    生产: 'Өндіріс',
    '良品数量(实际入库数量)':
      'Жақсы өнім саны (нақты қоймаға қабылданған саны)',
    请输入Key: 'Кілтті енгізіңіз',
    请输入Secret: 'Құпия сөзді енгізіңіз',
    资产: 'Актив',
    资产类型: 'Актив түрі',
    请选择资产类型: 'Актив түрін таңдаңыз',
    资产状态: 'Актив күйі',
    请选择资产状态: 'Актив күйін таңдаңыз',
    资产编码: 'Актив коды',
    请输入资产编码: 'Актив кодын енгізіңіз',
    资产名称: 'Актив атауы',
    请输入资产名称: 'Актив атауын енгізіңіз',
    购入日期: 'Сатып алу күні',
    请选择购入日期: 'Сатып алу күнін таңдаңыз',
    请输入规格型号: 'Спецификация моделін енгізіңіз',
    设备序列号: 'Құрылғы сериялық нөмірі',
    请输入设备序列号: 'Құрылғы сериялық нөмірін енгізіңіз',
    价值币种: 'Құн валютасы',
    期初价值: 'Бастапқы құны',
    请输入期初价值: 'Бастапқы құнын енгізіңіз',
    当前价值: 'Ағымдағы құны',
    请输入当前价值: 'Ағымдағы құнын енгізіңіз',
    使用人: 'Қолданушы',
    请选择使用人: 'Қолданушыны таңдаңыз',
    使用部门: 'Қолдану бөлімі',
    请选择使用部门: 'Қолдану бөлімін таңдаңыз',
    存放位置: 'Сақтау орны',
    请输入存放位置: 'Сақтау орнын енгізіңіз',
    资产图集: 'Актив суреттер жинағы',
    资产描述: 'Актив сипаттамасы',
    请输入资产描述: 'Актив сипаттамасын енгізіңіз',
    生产模具: 'Өндіріс қалыбы',
    请输入模具名称: 'Қалып атауын енгізіңіз',
    请选择模具类型: 'Қалып түрін таңдаңыз',
    请输入模具编码SN: 'Қалып коды SN енгізіңіз',
    模具状态: 'Қалып күйі',
    请输入模具成本: 'Қалып құнын енгізіңіз',
    成本币种: 'Құн валютасы',
    模具位置: 'Қалып орны',
    请输入模具位置: 'Қалып орнын енгізіңіз',
    请输入成本描述: 'Құн сипаттамасын енгізіңіз',
    请输入耗材描述: 'Жұмсалатын материалдар сипаттамасын енгізіңіз',
    请选择模具开发商: 'Қалып әзірлеушіні таңдаңыз',
    请选择模具维护方: 'Қалып қызмет көрсетушіні таңдаңыз',
    请选择模具加工方: 'Қалып өңдеушіні таңдаңыз',
    请输入模具描述: 'Қалып сипаттамасын енгізіңіз',
    请输入产权描述: 'Меншік сипаттамасын енгізіңіз',
    请输入项目名称: 'Жоба атауын енгізіңіз',
    项目标签: 'Жоба белгісі',
    项目阶段: 'Жоба кезеңі',
    请输入启动时间: 'Бастау уақытын енгізіңіз',
    请输入预计完结时间: 'Болжалды аяқталу уақытын енгізіңіз',
    请输入实际完结时间: 'Нақты аяқталу уақытын енгізіңіз',
    项目预算: 'Жоба бюджеті',
    请输入项目预计研发成本:
      'Жобаның болжалды зерттеу және әзірлеу құнын енгізіңіз',
    请输入项目预计生产成本: 'Жобаның болжалды өндіріс құнын енгізіңіз',
    请输入预计售价: 'Болжалды сату бағасын енгізіңіз',
    请输入项目预计回本数量: 'Жобаның болжалды қайтару санын енгізіңіз',
    请输入项目描述: 'Жоба сипаттамасын енгізіңіз',
    请输入项目成本描述: 'Жоба құны сипаттамасын енгізіңіз',
    请输入项目产品成本描述: 'Жоба өнім құны сипаттамасын енгізіңіз',
    请输入项目复盘内容: 'Жоба қайта қарау мазмұнын енгізіңіз',
    详情描述: 'Егжей-тегжей сипаттамасы',
    请输入详情描述: 'Егжей-тегжей сипаттамасын енгізіңіз',
    请选择发货地址: 'Жеткізу мекенжайын таңдаңыз',
    货架数量: 'Стеллаж саны',
    请输入货架数量: 'Стеллаж санын енгізіңіз',
    '前缀标题如：仓库1-': 'Префикс тақырыбы, мысалы: қойма1-',
    '后缀标题如：-01行': 'Суффикс тақырыбы, мысалы: -01 жол',
    第三方仓库: 'Үшінші тарап қоймасы',
    三方仓库: 'Үш тарапты қойма',
    请选择三方仓库公司: 'Үшінші тарап қойма компаниясын таңдаңыз',
    产品授权大市场: 'Өнім авторизациясы үлкен нарық',
    授权公司: 'Авторизация компаниясы',
    请选择授权公司: 'Авторизация компаниясын таңдаңыз',
    授权产品: 'Авторизация өнімі',
    产品评论: 'Өнім пікірлері',
    显示状态: 'Көрсету күйі',
    评论图片: 'Пікір суреті',
    评论内容: 'Пікір мазмұны',
    请输入评论内容: 'Пікір мазмұнын енгізіңіз',
    请输入标签名称: 'Белгі атауын енгізіңіз',
    标签类型: 'Белгі түрі',
    请选择标签类型: 'Белгі түрін таңдаңыз',
    请选择关联模块: 'Байланысты модульді таңдаңыз',
    请选择关联数据: 'Байланысты деректерді таңдаңыз',
    关联模板: 'Байланысты үлгі',
    请选择关联模板: 'Байланысты үлгіні таңдаңыз',
    请输入开始日期: 'Бастау күнін енгізіңіз',
    截止日期: 'Аяқталу күні',
    请选择截止日期: 'Аяқталу күнін таңдаңыз',
    请输入任务描述内容: 'Тапсырма сипаттамасы мазмұнын енгізіңіз',
    完成任务: 'Тапсырманы аяқтау',
    请输入任务答辩内容: 'Тапсырма жауап беру мазмұнын енгізіңіз',
    合格情况: 'Сапа жағдайы',
    请选择合格情况: 'Сапа жағдайын таңдаңыз',
    请选择入库日期: 'Қоймаға қабылдау күнін таңдаңыз',
    是否有清单: 'Тізім бар ма',
    销售日期: 'Сату күні',
    请选择销售日期: 'Сату күнін таңдаңыз',
    产品标签: 'Өнім белгісі',
    数据范围: 'Дерек ауқымы',
    请选择复核状态: 'Қайта тексеру күйін таңдаңыз',
    单品数量: 'Бір тауар саны',
    请选择单品数量: 'Бір тауар санын таңдаңыз',
    前缀标题: 'Префикс тақырыбы',
    '前缀标题如：仓库': 'Префикс тақырыбы, мысалы: қойма',
    后缀标题: 'Суффикс тақырыбы',
    后缀标题如: 'Суффикс тақырыбы, мысалы',
    大于: 'Үлкен',
    入库状态: 'Қоймаға қабылдау күйі',
    发货地: 'Жеткізу орны',
    请选择业务类型: 'Қызмет түрін таңдаңыз',
    采购单: 'Сатып алу құжаты',
    '请搜索/选择采购单': 'Сатып алу құжатын іздеңіз/таңдаңыз',
    请选择参与人: 'Қатысушыны таңдаңыз',
    请选择开始时间: 'Бастау уақытын таңдаңыз',
    请选择跟进人: 'Бақылаушыны таңдаңыз',
    请选择跟进时间: 'Бақылау уақытын таңдаңыз',
    后: 'кейін',
    分钟: 'минут',
    昨天: 'кеше',
    下载查看: 'Жүктеу және қарау',
    '导入数据过多，已添加至异步导入队列生成':
      'Импорттау үшін деректер тым көп, асинхронды импорт кезегіне қосылды',
    '您确定要将当前任务进行作废操作？':
      'Ағымдағы тапсырманы жарамсыз ету әрекетін жасауды қалайсыз ба?',
    子任务: 'Ішкі тапсырма',
    创建: 'Құру',
    负责: 'Жауапты',
    模块: 'Модуль',
    跟进模块: 'Бақылау модулі',
    查看富文本内容: 'Бай мәтін мазмұнын қарау',
    跟进附件: 'Бақылау қосымшасы',
    跟进位置: 'Бақылау орны',
    富文本内容: 'Бай мәтін мазмұны',
    暂无关联数据: 'Байланысты деректер жоқ',
    列表显示: 'Тізім түрінде көрсету',
    日历显示: 'Күнтізбе түрінде көрсету',
    初一: 'Бірінші күн',
    多任务: 'Көп тапсырма',
    项: 'элемент',
    请先添加数据: 'Алдымен деректерді қосыңыз',
    组合产品: 'Біріктірілген өнім',
    "90天销售笔数'": '90 күндік сату саны',
    '90天销售客户数': '90 күндік сату тұтынушылар саны',
    最近销售: 'Соңғы сату',
    资产图片: 'Актив суреті',
    资产详情: 'Актив туралы толық ақпарат',
    上次采购: 'Соңғы сатып алу',
    客户订单: 'Тұтынушы тапсырысы',
    KA一个月未下单: 'KA бір ай бойы тапсырыс бермеді',
    KA三个月未下单: 'KA үш ай бойы тапсырыс бермеді',
    KA一个月未跟进: 'KA бір ай бойы бақылау жасамады',
    合并客户数据: 'Тұтынушы деректерін біріктіру',
    被合并客户: 'Біріктірілетін тұтынушы',
    请选择被合并客户: 'Біріктірілетін тұтынушыны таңдаңыз',
    合并到客户: 'Тұтынушыға біріктіру',
    请选择合并到客户: 'Тұтынушыға біріктіру үшін таңдаңыз',
    模具详情: 'Қалып туралы толық ақпарат',
    位置状态变化: 'Орын күйінің өзгеруі',
    项目详情: 'Жоба туралы толық ақпарат',
    模具明细: 'Қалып туралы толық ақпарат',
    关联服务商: 'Байланысты қызмет көрсетуші',
    模具供应商详情: 'Қалып жеткізуші туралы толық ақпарат',
    关联项目: 'Байланысты жоба',
    关联模具: 'Байланысты қалып',
    客户头像: 'Тұтынушы аватары',
    请选择服务商: 'Қызмет көрсетушіні таңдаңыз',
    成本价格: 'Құн бағасы',
    包含模具: 'Қалыптарды қамтиды',
    开发状态: 'Әзірлеу күйі',
    距离完结: 'Аяқталуға дейін',
    距完结: 'Аяқталуға дейін',
    '您确定要同步产品到BOM吗？': 'Өнімдерді BOM-ға синхрондауды қалайсыз ба?',
    计划信息: 'Жоспар ақпараты',
    明细信息: 'Толық ақпарат',
    关联采购订单: 'Байланысты сатып алу тапсырысы',
    说明: 'Сипаттама',
    凭证图: 'Куәлік суреті',
    计划付款: 'Жоспарланған төлем',
    计划占比: 'Жоспарланған үлесі',
    已付占比: 'Төленген үлесі',
    计划回款: 'Жоспарланған қайтару',
    回款信息: 'Қайтару ақпараты',
    已回占比: 'Қайтарылған үлесі',
    图表统计: 'Диаграмма статистикасы',
    渠道销量: 'Арна сату көлемі',
    新增刊登产品: 'Жаңа жарияланған өнімдер',
    新增刊登排名: 'Жаңа жарияланған рейтинг',
    渠道新增刊登: 'Арна жаңа жарияланған',
    销售产品: 'Сату өнімдері',
    提成排行: 'Комиссия рейтингі',
    计提金额: 'Есептелген сома',
    上一时间段: 'Алдыңғы уақыт аралығы',
    当前时间段: 'Ағымдағы уақыт аралығы',
    请选择统计币种: 'Статистика валютасын таңдаңыз',
    库存预警: 'Қор ескертуі',
    剩余库存: 'Қалдық қор',
    请选择操作人: 'Әрекет етушіні таңдаңыз',
    操作内容: 'Әрекет мазмұны',
    渠道大类: 'Арна жоғарғы санаты',
    渠道店铺: 'Арна дүкені',
    自产货源: 'Өз өндіріс қайнар көзі',
    零售适配评分: 'Жеке саудаға сәйкес келу бағалауы',
    未上架产品: 'Сатуға шығарылмаған өнімдер',
    AI分析: 'AI талдау',
    请选择尺寸: 'Өлшемді таңдаңыз',
    请输入重量: 'Салмақты енгізіңіз',
    评论: 'Пікір',
    '您确定要对当前所有数据进行刷新操作？':
      'Ағымдағы барлық деректерді жаңарту әрекетін жасауды қалайсыз ба?',
    组合商品: 'Біріктірілген тауар',
    商品编码: 'Тауар коды',
    商品分类: 'Тауар санаты',
    价格公式: 'Баға формуласы',
    尺码表: 'Өлшем кестесі',
    是否关键商品: 'Негізгі тауар ма',
    批量修改尺码表: 'Жаппай өлшем кестесін өзгерту',
    请选择尺码表: 'Өлшем кестесін таңдаңыз',
    推送到第三方店铺: 'Үшінші тарап дүкеніне жіберу',
    请选择第三方店铺: 'Үшінші тарап дүкенін таңдаңыз',
    请选择规类型: 'Спецификация түрін таңдаңыз',
    添加规格: 'Спецификация қосу',
    '规格类型在：设置》产品设置》规格类型中添加':
      'Спецификация түрі: параметрлер》өнім параметрлері》спецификация түрлерінде қосылады',
    '不能选择重复属性！！': 'Қайталанатын сипаттарды таңдауға болмайды!!',
    商品详情: 'Тауар туралы толық ақпарат',
    产品SKU: 'Өнім SKU',
    产品售价: 'Өнім сату бағасы',
    规格属性: 'Спецификация сипаттары',
    选择规格: 'Спецификацияны таңдау',
    商品属性: 'Тауар сипаттары',
    获取得物价格: '得物 бағасын алу',
    添加规格模板: 'Спецификация үлгісін қосу',
    规格模板名称: 'Спецификация үлгісінің атауы',
    请输入模板名称: 'Үлгі атауын енгізіңіз',
    '请添加规格及属性值！！': 'Спецификация мен сипат мәндерін қосыңыз!!',
    '商品规格数量过多，请重新选择！':
      'Тауар спецификацияларының саны тым көп, қайта таңдаңыз!',
    '产品编码有重复请检查！！': 'Өнім кодтары қайталанады, тексеріңіз!!',
    规格设置: 'Спецификация параметрлері',
    采购总量: 'Жалпы сатып алу саны',
    最高售价: 'Ең жоғары сату бағасы',
    最近一次售价: 'Соңғы сату бағасы',
    最近一次采购时间: 'Соңғы сатып алу уақыты',
    更改: 'Өзгерту',
    查看历史采购: 'Тарихи сатып алуларды қарау',
    智能AI: 'Ақылды AI',
    销售预测: 'Сату болжамы',
    '实线为真实销量；虚线为预测销量':
      'Түзу сызық нақты сату көлемі; үзік сызық болжалды сату көлемі',
    PROPHET方法预测: 'PROPHET әдісі бойынша болжам',
    PROPHET方法预测Tips:
      'PROPHET - Facebook (қазір Meta) ашық кодты уақыт қатарын болжау кітапханасы, ол Prophet деп аталады. Ол уақыт қатары деректерін модельдеу және болжау үшін негізінен қолданылады, ол айқын мезгілділік пен демалыс күндерінің әсері бар деректер үшін қолайлы',
    SARIMA方法预测: 'SARIMA әдісі бойынша болжам',
    SARIMA方法预测Tips:
      'SARIMA - Seasonal Autoregressive Integrated Moving Average қысқартылған түрі, уақыт қатарын болжау үшін классикалық статистикалық модель. Ол ARIMA моделінің кеңейтілген нұсқасы, ол айқын мезгілдік үлгі бар деректерді өңдеуге арналған',
    客户采购: 'Тұтынушы сатып алуы',
    预计出库: 'Болжалды қоймадан шығару',
    真实销量: 'Нақты сату көлемі',
    方法预测: 'әдісі бойынша болжам',
    '零售价格/建议售价-最低售价/成本':
      'Жеке сауда бағасы/ұсынылған баға-ең төменгі баға/құны',
    '90天销量/笔数': '90 күндік сату көлемі/саны',
    授权市场: 'Авторизация нарығы',
    '您确定下架当前产品？': 'Ағымдағы өнімді сатудан шығаруды қалайсыз ба?',
    '您确定要对当前所有数据进行比价并上架？':
      'Ағымдағы барлық деректерді баға салыстыру және сатуға шығаруды қалайсыз ба?',
    '您确定要对当前所选数据进行比价并上架？':
      'Ағымдағы таңдалған деректерді баға салыстыру және сатуға шығаруды қалайсыз ба?',
    批量下架: 'Жаппай сатудан шығару',
    自产滞销: 'Өз өндіріс баяу сатылатын',
    自产滞销Tips:
      'Өз өндіріс баяу сатылатын (өз өндіріс, 90 күндік сату<50 дана), қор саны бойынша кему ретімен, соңғы сату уақыты бойынша ескіден жаңаға қарай сұрыпталады',
    外购滞销: 'Сырттан сатып алынған баяу сатылатын',
    外购滞销Tips:
      'Сырттан сатып алынған баяу сатылатын (сырттан сатып алу, қор бар, және 90 күндік сату<10), қор саны бойынша кему ретімен, соңғы сату уақыты бойынша ескіден жаңаға қарай сұрыпталады',
    省市区: 'Облыс/қала/аймақ',
    位置: 'Орын',
    操作记录: 'Әрекет журналы',
    主域名: 'Негізгі домен',
    网页快照: 'Веб-бет суреті',
    条形码: 'Штрих-код',
    '起订量(moq)': 'Ең аз тапсырыс саны (moq)',
    '您确定要对当客户订单中的产品进行同步吗？':
      'Тұтынушы тапсырысындағы өнімдерді синхрондауды қалайсыз ба?',
    同步订单中的产品: 'Тапсырыстағы өнімдерді синхрондау',
    采购单的其他费用金额: 'Сатып алу құжатының басқа шығындар сомасы',
    '您确定要对当前数据直接生成入库单并审核通过？':
      'Ағымдағы деректер үшін тікелей қоймаға қабылдау құжатын құрып тексеруден өткізуді қалайсыз ба?',
    '您确认将产品货物状态变为采购？':
      'Өнім жүк күйін сатып алуға ауыстыруды растайсыз ба?',
    '您确定要批量提审选中的信息？':
      'Таңдалған ақпаратты жаппай тексеруге жіберуді қалайсыз ба?',
    派货行程单详情: 'Жүк жіберу маршрут құжаты туралы толық ақпарат',
    配送地址: 'Жеткізу мекенжайы',
    '您确定要对当前数据完成配送？':
      'Ағымдағы деректер үшін жеткізуді аяқтауды қалайсыз ба?',
    包含单数: 'Құжат санын қамтиды',
    '您确定要对当前数据开始派货？':
      'Ағымдағы деректер үшін жүк жіберуді бастауды қалайсыз ба?',
    '您确定要对当前数据结束派货？':
      'Ағымдағы деректер үшін жүк жіберуді аяқтауды қалайсыз ба?',
    '您确定要生成出库单？': 'Қоймадан шығару құжатын құруды қалайсыз ба?',
    各仓库库存: 'Әрбір қойманың қоры',
    '您确定要对当前数据进行自动派货？':
      'Ағымдағы деректер үшін автоматты түрде жүк жіберуді қалайсыз ба?',
    是否打印: 'Басып шығару керек пе',
    您确定要对选中的数据进行批量打印:
      'Таңдалған деректерді жаппай басып шығаруды қалайсыз ба',
    工厂库存: 'Зауыт қоры',
    入库记录: 'Қоймаға қабылдау журналы',
    库存低于: 'Қор аз',
    天销售: 'күндік сату',
    '天销售,滞销！': 'күндік сату, баяу сатылады!',
    可用天数: 'Қолжетімді күндер саны',
    根据当前库存和日均销售量计算预估可用天数:
      'Ағымдағы қор мен күндік орташа сату көлемі бойынша болжалды қолжетімді күндер санын есептеу',
    '你确定要复制和当前数据子节点结构一样？':
      'Ағымдағы деректердің ішкі түйін құрылымын көшіруді қалайсыз ба?',
    splitTableTips:
      'Егер стеллаж саны бар болса, ортаңғы тік сызықпен (|) бөліңіз',
    加载中: 'Жүктелуде',
    productCategoryNumStock: 'Өнім түрі|Жалпы саны (орын)',
    productCategoryNum: 'Өнім түрі | Саны',
    等待处理数量: 'Өңдеу күтілген саны',
    '已处理/订单数': 'Өңделді/тапсырыс саны',
    '处理完成！！': 'Өңдеу аяқталды!!',
    '您确定要批量打印面单吗？':
      'Жаппай жүзбен қол қою парағын басып шығаруды қалайсыз ба?',
    '您确定要批量删除所选数据吗？':
      'Таңдалған деректерді жаппай жоюды қалайсыз ба?',
    '您确定要批量确认运单费用吗？':
      'Жаппай жеткізу құжаты шығындарын растауды қалайсыз ба?',
    天销售笔数: 'күндік сату саны',
    天销售客户数: 'Күн сайынғы сату тұтынушыларының саны',
    '天销量/笔数': 'Күн сайынғы сату көлемі/саны',
    '尺寸/重量': 'Өлшем/салмақ',
    预估费用: 'Болжалды шығындар',
    收货地: 'Қабылдау орны',
    '您确定要使用当前预估费用进行费用确认吗？':
      'Ағымдағы болжалды шығындарды шығындарды растау үшін қолдануды қалайсыз ба?',
    第三方仓库详情: 'Үшінші тарап қоймасы туралы толық ақпарат',
    所在仓: 'Орналасқан қойма',
    待发货数量: 'Жеткізу күтілген саны',
    毛利: 'Жалпы пайыз',
    订单毛利金额: 'Тапсырыс жалпы пайыз сомасы',
    '订单金额-已收金额-优惠金额':
      'Тапсырыс сомасы-алынған сома-жеңілдік сомасы',
    订单的其他费用金额: 'Тапсырыстың басқа шығындар сомасы',
    '您确定要对当前数据撤销提审？':
      'Ағымдағы деректерді тексеруден шығаруды қалайсыз ба?',
    仅撤销: 'Тек болдырмау',
    撤销并删除关联单据: 'Болдырмау және байланысты құжаттарды жою',
    '您确定要对当前订单利润进行重新计算？':
      'Ағымдағы тапсырыс пайдасын қайта есептеуді қалайсыз ба?',
    订单复核: 'Тапсырысты қайта тексеру',
    订单金额调整: 'Тапсырыс сомасын реттеу',
    未提交: 'Жіберілмеді',
    未审核: 'Тексерілмеді',
    已审核: 'Тексерілді',
    未复核: 'Қайта тексерілмеді',
    已复核: 'Қайта тексерілді',
    大单品订单: 'Үлкен өнім тапсырысы',
    '您确定要批量出库选中的信息？':
      'Таңдалған ақпаратты жаппай қоймадан шығаруды қалайсыз ба?',
    删除时间: 'Жою уақыты',
    '您确定要恢复当前订单的信息？':
      'Ағымдағы тапсырыс ақпаратын қалпына келтіруді қалайсыз ба?',
    订单模版: 'Тапсырыс үлгісі',
    反馈处理: 'Кері байланыс өңдеу',
    岗位描述: 'Лауазым сипаттамасы',
    最新编辑: 'Соңғы өңдеу',
    使用公司: 'Қолданатын компания',
    标签名称: 'Белгі атауы',
    关联信息编码: 'Байланысты ақпарат коды',
    标签查询: 'Белгі бойынша іздеу',
    标签列表: 'Белгілер тізімі',
    操作说明: 'Әрекет нұсқаулығы',
    请输入操作说明: 'Әрекет нұсқаулығын енгізіңіз',
    显示选项卡: 'Опциялар қойындысын көрсету',
    规格值: 'Спецификация мәні',
    产品规格类型: 'Өнім спецификациясы түрі',
    规格名称: 'Спецификация атауы',
    请输入规格名称: 'Спецификация атауын енгізіңіз',
    '颜色、尺寸、重量等': 'Түс, өлшем, салмақ және т.б.',
    请输入规格属性: 'Спецификация сипатын енгізіңіз',
    '请输入规格属性值如红色、黑色、白色等':
      'Спецификация сипат мәнін енгізіңіз, мысалы қызыл, қара, ақ және т.б.',
    服务商类型: 'Қызмет көрсетуші түрі',
    规格类型: 'Спецификация түрі',
    常见问题: 'Жиі қойылатын сұрақтар',
    问题类型: 'Мәселе түрі',
    币种汇率: 'Валюта курсы',
    kickcrew页面价格: 'Kickcrew бетіндегі баға',
    '美元换算人民币汇率）': 'Доллардан юаньға айырбастау курсі)',
    汽配行业不适用: 'Автомобиль қосалқы бөлшектері саласына қолданылмайды',
    请输入价格公式: 'Баға формуласын енгізіңіз',
    '如（price': 'Мысалы (баға',
    严格宽松模式: 'Қатаң/бос орын режимі',
    单号规则: 'Нөмірлеу ережесі',
    页面设置: 'Бет параметрлері',
    搜索条件缓存: 'Іздеу шарттарын кэштеу',
    '页面搜索条件缓存开启后，页面搜索条件会缓存，下次访问时会自动加载上次搜索条件，请谨慎使用':
      'Бет іздеу шарттарын кэштеу қосылғаннан кейін, бет іздеу шарттары кэштеледі, келесі қатынағанда соңғы іздеу шарттары автоматты түрде жүктеледі, абайлаңыз',
    展示产品编辑时间: 'Өнім өңдеу уақытын көрсету',
    '产品编辑时间开启后，产品编辑时间和编辑人信息会显示在产品列表图片下方':
      'Өнім өңдеу уақыты қосылғаннан кейін, өнім өңдеу уақыты мен өңдеуші ақпараты өнімдер тізімінің суретінің астында көрсетіледі',
    展示产品最近销售时间: 'Өнімнің соңғы сатылған уақытын көрсету',
    '产品最近销售时间开启后，产品最近销售时间信息会显示在产品明细列表图片下方':
      'Өнімнің соңғы сатылған уақыты қосылғаннан кейін, өнімнің соңғы сатылған уақыты туралы ақпарат өнім туралы толық ақпарат тізімінің суретінің астында көрсетіледі',
    自动保存form表单: 'Пішінді автоматты түрде сақтау',
    '自动保存form表单开启后，打开编辑弹窗将会自动保存form表单内容':
      'Пішінді автоматты түрде сақтау қосылғаннан кейін, өңдеу терезесін ашқанда пішін мазмұны автоматты түрде сақталады',
    电商小程序审核: 'Электрондық коммерция кіші бағдарламасын тексеру',
    开启后文章分类将不显示: 'Қосылғаннан кейін мақала санаттары көрсетілмейді',
    双击复制单元格: 'Ұяшықты қос шерту арқылы көшіру',
    '开启后本系统中列表支持双击复制单元格内容，方便快捷复制文案':
      'Қосылғаннан кейін жүйедегі тізімдер ұяшық мазмұнын қос шерту арқылы көшіруді қолдайды, мәтінді ыңғайлы және жылдам көшіруге мүмкіндік береді',
    tab页新开页面: 'TAB беті жаңа бетте ашылады',
    '开启后本系统中所有的tab页都会在新页面打开，方便数据对比':
      'Қосылғаннан кейін жүйедегі барлық TAB беттері жаңа бетте ашылады, деректерді салыстыруға ыңғайлы',
    虚拟列表: 'Виртуалды тізім',
    '开启后本系统详情页明细列表将使用虚拟列表，请谨慎使用':
      'Қосылғаннан кейін жүйенің егжей-тегжей бетінің туралы толық ақпарат тізімі виртуалды тізімді қолданады, абайлаңыз',
    此操作会带来不必要的性能开销:
      'Бұл әрекет қажетсіз өнімділік шығындарын әкеледі',
    详情列表拖拽排序: 'Егжей-тегжей тізімін сүйреп әкеліп сұрыптау',
    开启后本系统详情页明细列表可以自由拖拽排序:
      'Қосылғаннан кейін жүйенің егжей-тегжей бетінің туралы толық ақпарат тізімін еркін сүйреп әкеліп сұрыптауға болады',
    其他设置: 'Басқа параметрлер',
    订单默认渠道: 'Тапсырыс әдепкі арнасы',
    设置后订单下单时会自动默认选择当前渠道值:
      'Орнатылғаннан кейін тапсырыс бергенде ағымдағы арна мәні автоматты түрде әдепкі түрде таңдалады',
    请搜索默认渠道: 'Әдепкі арнаны іздеңіз',
    '确定要测试吗？': 'Сынақ жүргізуді анықтап жатырсыз ба?',
    执行周期: 'Орындау мерзімі',
    请选择执行类型: 'Орындау түрін таңдаңыз',
    选择执行时间: 'Орындау уақытын таңдаңыз',
    电商小程序APPID: 'Электрондық коммерция кіші бағдарламасы APPID',
    请输入电商小程序APPID:
      'Электрондық коммерция кіші бағдарламасы APPID енгізіңіз',
    电商小程序Secret: 'Электрондық коммерция кіші бағдарламасы құпия кілті',
    请输入电商小程序AppSecret:
      'Электрондық коммерция кіші бағдарламасы AppSecret енгізіңіз',
    微信配置: 'WeChat конфигурациясы',
    定时任务配置: 'Уақыттық тапсырма конфигурациясы',
    任务模板详情: 'Тапсырма үлгісі туралы толық ақпарат',
    任务模板: 'Тапсырма үлгісі',
    纸张大小: 'Қағаз өлшемі',
    请选择纸张大小: 'Қағаз өлшемін таңдаңыз',
    纸张方向: 'Қағаз бағыты',
    请选择纸张方向: 'Қағаз бағытын таңдаңыз',
    预览: 'Алдын ала қарау',
    普通导出: 'Қарапайым экспорттау',
    普通打印: 'Қарапайым басып шығару',
    输出PDF: 'PDF шығару',
    打印机打印: 'Принтерден басып шығару',
    预览模板: 'Үлгіні алдын ала қарау',
    '此内容依赖于：产品》产品分类，您可以勾选你需要展示的分类，勾选后分类将出现在分类中。':
      'Бұл мазмұн өнімдерге тәуелді: Өнім санаттары, қажетті көрсетілетін санаттарды белгілей аласыз, белгілегеннен кейін санаттар санаттарда пайда болады.',
    '此内容依赖于：产品》产品分类，您可以勾选你需要展示的分类，勾选后分类将出现在首页(PC端)导航栏中。':
      'Бұл мазмұн өнімдерге тәуелді: Өнім санаттары, қажетті көрсетілетін санаттарды белгілей аласыз, белгілегеннен кейін санаттар басты бет (PC нұсқасы) навигациялық панелінде пайда болады.',
    授权时间: 'Рұқсат беру уақыты',
    授权企业: 'Рұқсат берілген компания',
    '您确定要对当前数据取消授权？':
      'Ағымдағы деректерге рұқсатты болдырмауды қалайсыз ба?',
    // TODO: 2025-12-01
    "OEM信息": "OEM ақпараты",
    "谷歌搜图": "Google іздеу суреті",
    "待完善、不售卖产品": "Жетілдіру үшін күтілуде, сатылмайтын өнімдер",
    "新产品": "Жаңа өнім",
    "图片地址": "Сурет адресі",
    "应用": "Қолданба",
    "图纸信息": "Схема ақпараты",
    "适配车型": "Үйлесімді көлік модельдері",
    "版本": "Нұсқа",
    "指导价": "Бағыт бағасы",
    "位置编号": "Орын нөмірі",
    "使用年份": "Пайдалану жылы",
    "图纸": "Схемалар",
    "型号": "Модель",
    "发动机": "Қозғалтқыш",
    "市场/地区": "Нарық/аймақ",
    "部件图": "Бөлшек сызбасы",
    "部件信息": "Бөлшек ақпараты",
    "适用品牌": "Қолданылатын брендтер",
    "部件编码": "Бөлшек коды",
    "回本周期": "Қайтарым мерзімі",
    "无法估算": "Болжау мүмкін емес",
    "回本日": "Қайтарым күні",
    "税费": "Салықтар мен жарнаlar",
    "评价": "Пікір",
    "海关编码": "Кеден коды",
    "新旧类型": "Жаңа/Ескі түрі",
    "订单评价": "Тапсырыс пікірі",
    "订单预审": "Тапсырысты алдын ала қарау",
    "是否施工": "Құрылыс жүргізілетін бе",
    "原厂零售价": "Зауыт шығаратын жеке бағасы",
    "请选择新旧类型": "Жаңа/Ескі түрін таңдаңыз",
    "请输入海关编码": "Кеден кодын енгізіңіз",
    "google搜索OEM码": "Google арқылы OEM кодын іздеу",
    "预计完工": "Болжалды аяқталу",
    "请选择预计完成时间": "Болжалды аяқталу уақытын таңдаңыз",
    "请输入箱规毛重": "Қорап спецификациясының жалпы салмағын енгізіңіз",
    "产品报价": "Өнім ұсынысы",
    "请输入产品报价": "Өнім ұсынысын енгізіңіз",
    "产品推介渠道": "Өнім жарнамалау арнасы",
    "其他信息": "Басқа ақпарат",
    "账期备注": "Есептесу мерзімі ескертулері",
    "图片视频": "Суреттер мен видеолар",
    "线索类型": "Лид түрі",
    "图像": "Кескін",
    "支持排序": "Сұрыптауды қолдау",
    "按照产品已有价格": "Бар өнім бағаларына сәйкес",
    "优先使用": "Басымдықпен қолдану",
    "零售价": "Жеке баға",
    "项目分类": "Жоба санаты",
    "请搜索/选择项目分类": "Жоба санатын іздеңіз/таңдаңыз",
    "请输入服务商名称": "Қызмет провайдерінің атауын енгізіңіз",
    "跟踪产品": "Бақыланатын өнім",
    "我方产品": "Біздің өніміміз",
    "请输入我方产品地址": "Біздің өнім адресімізді енгізіңіз",
    "竞品产品": "Бәсекелес өнім",
    "请输入竞品产品地址": "Бәсекелес өнім адресін енгізіңіз",
    "添加竞品产品地址": "Бәсекелес өнім адресін қосу",
    "最低价格": "Ең төменгі баға",
    "最低跟踪价格": "Ең төменгі бақылау бағасы",
    "打标签": "Белгілеу",
    "请搜索/选择新旧类型": "Жаңа/Ескі түрін іздеңіз/таңдаңыз",
    "未销售天数": "Сатылмаған күндер саны",
    "请输入未销售天数": "Сатылмаған күндер санын енгізіңіз",
    "请选择项目分类": "Жоба санатын таңдаңыз",
    "超时": "Уақыт шығып кетті",
    "到期": "Мерзімі аяқталды",
    "个月": "ай",
    "标签明细": "Белгі мәліметтері",
    "关联信息ID": "Байланысты ақпарат ID",
    "暂为匹配到当前关联信息": "Ағымдағы байланысты ақпаратқа сәйкес келмеді",
    "查看明细": "Мәліметтерді қарау",
    "占用数量": "Босатылмаған саны",
    "已购产品": "Сатып алынған өнімдер",
    "未购产品": "Сатып алынбаған өнімдер",
    "购买产品车型明细": "Сатып алынған өнім көлік моделі мәліметтері",
    "上次采购价格": "Соңғы сатып алу бағасы",
    "上次采购数量": "Соңғы сатып алу саны",
    "上次采购订单": "Соңғы сатып алу тапсырысы",
    "客户成长性": "Тұтынушы өсуі",
    "采购频率": "Сатып алу жиілігі",
    "每笔订单平均间隔": "Әрбір тапсырыс арасындағы орташа аралық",
    "以产品品牌分类的产品分布情况": "Бренд бойынша өнім таратуы",
    "以产品一级分类的产品分布情况": "Біріншілік санат бойынша өнім таратуы",
    "二级分类": "Екіншілік санат",
    "以产品二级分类的产品分布情况": "Екіншілік санат бойынша өнім таратуы",
    "以产品车型分类的产品分布情况": "Көлік моделі бойынша өнім таратуы",
    "以产品部件分类的产品分布情况": "Бөлшек бойынша өнім таратуы",
    "季": "Тоқсан",
    "至": "дейін",
    "暂无关联数据！": "Байланысты деректер жоқ!",
    "项目类型": "Жоба түрі",
    "利润金额": "Пайда сомасы",
    "订单利润": "Тапсырыс пайдасы",
    "客户推荐": "Тұтынушы ұсынысы",
    "图文标题": "Графика мен мәтін тақырыбы",
    "请输入图文标题": "Графика мен мәтін тақырыбын енгізіңіз",
    "最低售价/成本/原厂零售价": "Ең төменгі сату бағасы/құны/зауыт шығаратын жеке бағасы",
    "预计完成时间": "Болжалды аяқталу уақыты",
    "请先填写OEM编码": "Алдымен OEM кодын толтырыңыз",
    "我方售价": "Біздің сату бағамыз",
    "竞品售价": "Бәсекелес сату бағасы",
    "天销售少于": "Күн ішінде сатылған саны аз",
    "创建时间大于": "Құру уақыты үлкен",
    "天，按去库存周期由大到小排列": "күн, инвентаризация цикліне қарай кему ретімен",
    "天订单": "Күндік тапсырыс",
    "天客户": "Күндік тұтынушы",
    "去库存": "Инвентаризациядан шығару",
    "您确定要批量出库？": "Топтап складтан шығарғыңыз келетініне сенімдісіз бе?",
    "已审现金": "Тексерілген қаржы",
    "已审挂账": "Тексерілген несие",
    "作废订单": "Жарамсыз тапсырыстар",
    "拥有成员": "Қатысушылар",
    "关联父级信息": "Байланысты жоғарғы деңгейлі ақпарат",
    "产品信息中的箱规尺寸": "Өнім ақпаратындағы қорап спецификациясы өлшемдері",
    "产品信息中的箱规中的重量": "Өнім ақпаратындағы қорап спецификациясы салмағы",
    "上次跟进内容": "Соңғы бақылау мазмұны",
    "上次跟进附件": "Соңғы бақылау қосымшасы",
    "上次跟进位置": "Соңғы бақылау орны",
    "上次跟进时间": "Соңғы бақылау уақыты"
  },
}
